import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Sidebar } from 'primereact/sidebar';
import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Container,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Button as RSButton
} from "reactstrap";
// import CandidateDataInfo from "./CandidateListDataInfo";
// import { Modal, Button,Container } from "react-bootstrap";
import CompanySelector from "ATSComponents/Common/CompanySelector";
import LinkContactsPopup from "ATSComponents/Common/LinkContactsPopup";
import axios from 'axios';
import { Calendar } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox';
import { Chips } from 'primereact/chips';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Editor } from "primereact/editor";
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { RadioButton } from 'primereact/radiobutton';
import { MultiSelect } from "primereact/multiselect";
import { ProgressSpinner } from "primereact/progressspinner";
import { Tooltip } from "primereact/tooltip";
import { TreeSelect } from "primereact/treeselect";
import { Controller, useForm } from "react-hook-form";
import { FaBusinessTime, FaCheckCircle, FaFilePdf, FaFileWord, FaHistory, FaRegEye, FaTimes,FaArrowUp  } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import OrgTableShimmer from "ATSComponents/Common/OrgTableShimmer";
import ResumePreviewPanel from "./ResumePreviewPanel";
import PipelineHistoryTimeline from "./PipelineHistoryTimeline";
import Swal from "sweetalert2";
import { deliveryErrorMessage, isSuccessfulDelivery } from "../../utils/deliveryResult"
import { hasLegacyWordDocument } from "utils/fileValidation"
import { emailValidation, onlyAlphabetsandSpaces } from "../../utils/Constants";
import { onMessage } from "firebase/messaging";
import { messaging, getDeviceTokenView, generateToken } from "components/Common/FirebaseConfig";
import { FiBriefcase, FiMail, FiPhone } from "react-icons/fi";

const sortCandidateRows = (rows, field, order) => {
  if (!field || !order) return rows;
  return [...rows].sort((left, right) => {
    const a = String(left?.[field] ?? "").toLowerCase();
    const b = String(right?.[field] ?? "").toLowerCase();
    return a.localeCompare(b, undefined, { numeric: true }) * order;
  });
};

const AtsCandidatesAll = () => {
  document.title = "ATS - All Candidates";
  const [CandidateListData, setCandidateListData] = useState([]);
  const [selectedCandidates, setselectedCandidates] = useState([]);
  const [showUploadedResumeModal, setShowUploadedResumeModal] = useState(false);
  const [expandedJobRows, setExpandedJobRows] = useState({});
  const [ViewCandidatePopupShow, setViewCandidatePopupShow] = useState(false);
  const [backdrop, setBackdrop] = useState(true);
  const [keyboard, setKeyboard] = useState(true);
  const [showScrollTop, setShowScrollTop] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300); 
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const userInfos = JSON.parse(sessionStorage.getItem("user-info"));
  const [filterStatus, setFilterStatus] = useState("all");
  console.log(userInfos, "userInfosuserInfosuserInfos");
  const [selectedCandidateForDetails, setSelectedCandidateForDetails] = useState(null);
  const [showResultSummary, setShowResultSummary] = useState(false);
  const [selectedResult, setSelectedResult] = useState([]);
  const [loadingTalentScanCandidateId, setLoadingTalentScanCandidateId] = useState(null);
  const [filterRecruiter, setFilterRecruiter] = useState("");
const [recruiterList, setRecruiterList] = useState([]);
const [recruitersLoading, setRecruitersLoading] = useState(false);
const [filterStartDate, setFilterStartDate] = useState("");
const [filterEndDate, setFilterEndDate]     = useState("");
const getDefaultInterviewTimes = () => {
  const start = new Date(Date.now() + 10 * 60 * 1000); 
  const end = new Date(start.getTime() + 30 * 60 * 1000); 
  return { start, end };
};
const getRecruiters = async (companyId) => {
  // if (!companyId || companyId === "All") return;
  setRecruitersLoading(true);
  try {
    const response = await axios.get(`/api/v1/ats-users/`, {
      params: { company_id: companyId },
    });

    // Handle all common response shapes
    const raw =
      response.data?.results ||
      response.data?.data ||
      response.data?.users ||
      (Array.isArray(response.data) ? response.data : []);

    const formatted = raw.map((user) => ({
      id: user.id ?? user.user_id ?? user.pk,
      label:
        [user.first_name, user.middle_name, user.last_name]
          .filter(Boolean)
          .join(" ")
          .trim() ||
        user.username ||
        user.email ||
        "User",
    })).filter((r) => r.id);

    setRecruiterList(formatted);
  } catch (error) {
    console.error("Error fetching recruiters:", error);
    setRecruiterList([]);
  } finally {
    setRecruitersLoading(false);
  }
};
const linkifyEditorHtml = value => {
  if (!value || typeof document === "undefined") return value || "";

  const wrapper = document.createElement("div");
  wrapper.innerHTML = value;
  const urlRegex = /(https?:\/\/[^\s<]+|www\.[^\s<]+)/gi;

  const walk = node => {
    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.nodeValue;
      if (!urlRegex.test(text)) return;

      urlRegex.lastIndex = 0;
      const fragment = document.createDocumentFragment();
      let lastIndex = 0;
      text.replace(urlRegex, (match, _unused, offset) => {
        fragment.appendChild(document.createTextNode(text.slice(lastIndex, offset)));
        const href = match.startsWith("http") ? match : `https://${match}`;
        const anchor = document.createElement("a");
        anchor.href = href;
        anchor.target = "_blank";
        anchor.rel = "noopener noreferrer";
        anchor.textContent = match;
        anchor.style.color = "#0d6efd";
        anchor.style.textDecoration = "underline";
        fragment.appendChild(anchor);
        lastIndex = offset + match.length;
        return match;
      });
      fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
      node.parentNode.replaceChild(fragment, node);
      return;
    }

    if (node.nodeType === Node.ELEMENT_NODE && node.tagName !== "A") {
      Array.from(node.childNodes).forEach(walk);
    }
  };

  Array.from(wrapper.childNodes).forEach(walk);
  return wrapper.innerHTML;
};
  console.log("selectedCandidateForDetails",selectedCandidateForDetails)
  const navigate = useNavigate()
  const jobForm = useForm();
  const emailInputRef = useRef(null);
  const [allNotificationData, setAllNotificationData] = useState([]);
const [readNotificationCount, setReadNotificationCount] = useState(0);
const [readNotificationCount1, setReadNotificationCount1] = useState(0);
const [prevNotificationCount, setPrevNotificationCount] = useState(0);
const [approvalMap, setApprovalMap] = useState({});
const fetchApprovalRequests = async () => {
  const res = await axios.get(
    "/api/v1/candidate-job-links/approval-requests-for-manager/"
  );

  const map = {};

  res.data.forEach(item => {
    const candidateId = item.candidate;

    if (!map[candidateId]) {
      map[candidateId] = [];
    }

    map[candidateId].push(item);
  });

  setApprovalMap(map);
};

const openApproveRejectModal = (job, type) => {
  setSelectedJobCandidateForApproveReject(normalizeApprovalJob(job));
  setActionType(type); // approve | reject
  setShowApproveRejectModal(true);
};
const getUploadResult = data =>
  data?.result || data?.results || data?.data?.result || data?.data?.results || data?.data || data || {};

const getUploadSuccessFiles = data => {
  const result = getUploadResult(data);
  return Array.isArray(result?.created) ? result.created : [];
};
 const getUploadFailedCount = data =>
  Array.isArray(getUploadResult(data)?.failed)
    ? getUploadResult(data).failed.length
    : Number(getUploadResult(data)?.failed_count ?? 0);
const getUploadSuccessCount = data => {
  const result = getUploadResult(data);
  return Array.isArray(result?.created) 
    ? result.created.length 
    : Number(result?.created_count ?? result?.success_count ?? 0);
};
const normalizeResumeSourceName = value => {
  const sourceName = typeof value === "string" ? value.trim() : "";
  return sourceName && sourceName !== "-" ? sourceName : "Others"; if (requestId !== candidateRequestRef.current) return;
};
const getUploadFailedFiles = data =>
  Array.isArray(getUploadResult(data)?.failed)
    ? getUploadResult(data).failed
    : Array.isArray(getUploadResult(data)?.failed_files)
      ? getUploadResult(data).failed_files
      : Array.isArray(getUploadResult(data)?.failed_resumes)
        ? getUploadResult(data).failed_resumes
        : [];
const getAllNotifications = async () => {
  const empCode = userInfos?.user_details?.employee_code;
  const companyId =
    userInfos?.user_details?.companies_data?.[0]?.company_id ?? null;

  try {
    const response = await axios.get("/api/v1/view-all-notifications/", {
      params: {
        emp_code: empCode,
        company_id: companyId,
      },
    });

    const notifications = response.data.result[0].notifications || [];

    const unreadCount = notifications.filter(
      n => !n.is_read
    ).length;
  console.log("notifications.length",notifications.length)
    setReadNotificationCount(notifications.length);
    // setReadNotificationCount1(unreadCount);
    setAllNotificationData(notifications);

    generateToken();
  } catch (error) {
    console.error("Error fetching notifications:", error);
  }
};

// useEffect(() => {
//   getDeviceTokenView();
//   const unsubscribe = onMessage(messaging, (payload) => {
//     getAllNotifications();
//   });

//   getAllNotifications();

//   return () => {
//     unsubscribe(); // Cleanup the listener when the component unmounts
//   };
// }, []);
useEffect(() => {
  if (readNotificationCount1 > prevNotificationCount) {
    // Play notification sound here if needed
    // Example: notificationSound.play();
  }
  setPrevNotificationCount(readNotificationCount1);
}, [readNotificationCount1]);
//  onMessage(messaging, payload => {
//     getAllNotifications()
//   })
//     onMessage(messaging, payload => {
//       getAllNotifications()
//     })
// const handleApprove = async () => {
//   if (!selectedJobCandidateForApproveReject || !approveRejectReason.trim()) {
//     Swal.fire({
//       icon: "error",
//       title: "Error",
//       text: "Please provide a reason for approval",
//     });
//     return;
//   }

//   setIsApprovingRejecting(true);
//   try {
//     const jobCandidateId = selectedJobCandidateForApproveReject.job_candidate_id;
//       const url = `/api/v1/send-for-approval/approve/?job_candidate_id=${jobCandidateId}`;
//       const response = await axios.patch(url,{ reason: approveRejectReason })

//       if (response.data) {
//         Swal.fire({
//           icon: "success",
//           title: "Success!",
//           text: "Candidate approved successfully!",
//         })

//         // Update local state to reflect approval
//         // setCandidateListData(prev => {
//         //   const updatedCandidates = prev.map(candidate =>
//         //     candidate.candidate_id ===
//         //     selectedJobCandidateForApproveReject.candidate_id
//         //       ? {
//         //           ...candidate,
//         //           linked_jobs: candidate.linked_jobs.map(job =>
//         //             job.job_candidate_id === jobCandidateId
//         //               ? {
//         //                   ...job,
//         //                   is_approved: true,
//         //                   is_approved_reason: approveRejectReason,
//         //                   is_approved_at: new Date().toISOString(),
//         //                 }
//         //               : job
//         //           ),
//         //         }
//         //       : candidate
//         //   )
//         //   return updatedCandidates
//         // })
//         await getCandidates(
//           companyId,
//           lazyParams.page,
//           lazyParams.rows,
//           searchQuery
//         )


//         // Reset modal state

//       }
//     } catch (error) {
//       console.error("Approval Error:", error)
//       Swal.fire({
//         icon: "error",
//         title: "Error!",
//         text:
//           error.response?.data?.error ||
//           "Failed to approve candidate. Please try again.",
//       })
//     } finally {
//       setIsApprovingRejecting(false)
//       setShowApproveRejectModal(false)
//         setApproveRejectReason("")
//         setSelectedJobCandidateForApproveReject(null)
//     }
//   }
;

const handleApprove = async () => {
  if (!selectedJobCandidateForApproveReject || !approveRejectReason.trim()) {
    Swal.fire("Error", "Please enter reason", "error");
    return;
  }

  setIsApprovingRejecting(true);

  try {
    const jobCandidateId = selectedJobCandidateForApproveReject.job_candidate_id;

    await axios.patch(
      `/api/v1/send-for-approval/approve/?job_candidate_id=${jobCandidateId}`,
      { reason: approveRejectReason }
    );

    // ✅ CLOSE MODAL FIRST
    setShowApproveRejectModal(false);
    setApproveRejectReason("");
    setSelectedJobCandidateForApproveReject(null);
    // setApprovalMap(prevMap => {
    //   const candidateId = selectedJobCandidateForApproveReject.candidate_id;
    //   console.log("candidateId",candidateId)
    //   const updatedJobs = prevMap[candidateId]?.map(job =>
    //     job.job_candidate_id === jobCandidateId
    //       ? { ...job, is_approved: true, is_approved_reason: approveRejectReason }
    //       : job
    //   ) || [];
    //   console.log("updatedJobs",updatedJobs)

    //   return { ...prevMap, [candidateId]: updatedJobs };
    // });


    // ✅ Wait for modal to unmount
    setTimeout(() => {
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Candidate approved successfully!",
      });
    }, 150);
    setSearchQuery("");
    setFilterJobTitle("");
    setFilterStatus("all")
  // ✅ Re-fetch approval requests
  await fetchApprovalRequests();
    await getCandidates(companyId, lazyParams.page, lazyParams.rows, searchQuery, filterStatus, filterJobTitle, filterRecruiter, filterStartDate, filterEndDate, filterPipelineStage);
    await getAllNotifications();
    window.dispatchEvent(new Event('notificationUpdated'));
    

  } catch (error) {
    Swal.fire(
      "Error",
      error?.response?.data?.error || "Failed to approve candidate",
      "error"
    );
  } finally {
    setIsApprovingRejecting(false);
  }
};

//   const handleReject = async () => {
//     if (!selectedJobCandidateForApproveReject || !approveRejectReason.trim()) {
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Please provide a reason for rejection",
//       })
//       return
//     }

//     setIsApprovingRejecting(true)
//     try {
//       const jobCandidateId =
//         selectedJobCandidateForApproveReject.job_candidate_id
//       const url = `/api/v1/send-for-approval/reject/?job_candidate_id=${jobCandidateId}`

//       const response = await axios.patch(url, { reason: approveRejectReason })

//       if (response.data) {
//         Swal.fire({
//           icon: "success",
//           title: "Success!",
//           text: "Candidate rejected successfully!",
//         })

//         // Update local state to reflect rejection
//         // setCandidateListData(prev => {
//         //   const updatedCandidates = prev.map(candidate =>
//         //     candidate.candidate_id ===
//         //     selectedJobCandidateForApproveReject.candidate_id
//         //       ? {
//         //           ...candidate,
//         //           linked_jobs: candidate.linked_jobs.map(job =>
//         //             job.job_candidate_id === jobCandidateId
//         //               ? {
//         //                   ...job,
//         //                   is_rejected: true,
//         //                   is_rejected_reason: approveRejectReason,
//         //                   is_rejected_at: new Date().toISOString(),
//         //                 }
//         //               : job
//         //           ),
//         //         }
//         //       : candidate
//         //   )
//         //   return updatedCandidates
//         // })
// await getCandidates(companyId, lazyParams.page, lazyParams.rows, searchQuery)

//         // Reset modal state
        
//       }
//     } catch (error) {
//       console.error("Rejection Error:", error)
//       Swal.fire({
//         icon: "error",
//         title: "Error!",
//         text:
//           error.response?.data?.error ||
//           "Failed to reject candidate. Please try again.",
//       })
//     } finally {
//       setIsApprovingRejecting(false)
//       setShowApproveRejectModal(false)
//         setApproveRejectReason("")
//         setSelectedJobCandidateForApproveReject(null)
//     }
//   }
const handleReject = async () => {
  if (!selectedJobCandidateForApproveReject || !approveRejectReason.trim()) {
    Swal.fire("Error", "Please enter reason", "error");
    return;
  }

  setIsApprovingRejecting(true);

  try {
    const jobCandidateId = selectedJobCandidateForApproveReject.job_candidate_id;

    await axios.patch(
      `/api/v1/send-for-approval/reject/?job_candidate_id=${jobCandidateId}`,
      { reason: approveRejectReason }
    );

    // ✅ CLOSE MODAL FIRST
    setShowApproveRejectModal(false);
    setApproveRejectReason("");
    setSelectedJobCandidateForApproveReject(null);
      // ✅ Re-fetch approval requests
    //  setApprovalMap(prevMap => {
    //   const candidateId = selectedJobCandidateForApproveReject.candidate_id;
    //   const updatedJobs = prevMap[candidateId]?.map(job =>
    //     job.job_candidate_id === jobCandidateId
    //       ? { ...job, is_rejected: true, is_rejected_reason: approveRejectReason }
    //       : job
    //   ) || [];

    //   return { ...prevMap, [candidateId]: updatedJobs };
    // });


    // ✅ Delay for smooth UX
    setTimeout(() => {
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Candidate rejected successfully!",
      });
    }, 150);
     setSearchQuery("");
    setFilterJobTitle("");
    setFilterStatus("all");
    setFilterRecruiter("");
    setFilterStartDate("");
    setFilterEndDate(""); 
    setFilterPipelineStage("");
  await fetchApprovalRequests();
    await getCandidates(companyId, lazyParams.page, lazyParams.rows, searchQuery, filterStatus, filterJobTitle, filterRecruiter, filterStartDate, filterEndDate, filterPipelineStage);
    await getAllNotifications();
    window.dispatchEvent(new Event('notificationUpdated'));

  } catch (error) {
    Swal.fire(
      "Error",
      error?.response?.data?.error || "Failed to reject candidate",
      "error"
    );
  } finally {
    setIsApprovingRejecting(false);
  }
};

  const [isDuplicateEmail, setIsDuplicateEmail] = useState(false)

  const { register: registerJob, handleSubmit: handleSubmitJob, reset: resetJob, trigger: triggerJob, clearErrors: clearErrorsJob, formState: { errors: errorsJob }, setValue: setValueJob, getValues: getValuesJob, control: controlJob } = jobForm;
  // Restore general form helpers for other forms in this component
  const { register, handleSubmit, reset, trigger, clearErrors, formState: { errors }, setValue, getValues, control } = useForm();
  const { register: register1, formState: { errors: errors1 }, handleSubmit: handleSubmit1, getValues: getValues1, setValue: setValue1, trigger: trigger1, reset: reset1, } = useForm({ mode: "onBlur" });
  const [disable, setDisable] = useState(false);
  const { register: registerView, handleSubmit: handleSubmitView, reset: resetView, trigger: triggerView, clearErrors: clearErrorsView, formState: { errors: errorsView }, setValue: setValueView, getValues: getValuesView, control: controlView } = useForm();
  const { register: register2, formState: { errors: errors2 }, handleSubmit: handleSubmit2, getValues: getValues2, setValue: setValue2, trigger: trigger2, reset: reset2, } = useForm({ mode: "onBlur" });
  const { register: register3, formState: { errors: errors3 }, handleSubmit: handleSubmit3, getValues: getValues3, setValue: setValue3, trigger: trigger3, reset: reset3, } = useForm({ mode: "onBlur" });
  const { register: register4, formState: { errors: errors4 }, handleSubmit: handleSubmit4, getValues: getValues4, setValue: setValue4, trigger: trigger4, reset: reset4, } = useForm({ mode: "onBlur" });
  const { register: register5, formState: { errors: errors5 }, handleSubmit: handleSubmit5, getValues: getValues5, setValue: setValue5, trigger: trigger5, reset: reset5, } = useForm({ mode: "onBlur" });
  const intialcompanyId = userInfos.user_details.companies_data[0].company_id;
  const [companyId, setCompanyId] = useState(intialcompanyId);
  const [excelDownloading, setExcelDownloading] = useState(false);
 const handleDownloadExcel = async () => {
    try {
      setExcelDownloading(true);

      const response = await axios.get(
        `/api/v1/candidates/download/`,
        {
          baseURL: "https://ats.bharatpayroll.com/qxbox",
          
          params: {
            company_id: companyId,
            search: searchQuery || "",
            filter: filterStatus && filterStatus !== "all" ? filterStatus : "",
            from_date: filterStartDate || "",
            to_date: filterEndDate || "",
            created_by: filterRecruiter || "",
            job_id: filterJobTitle || "",
            pipeline_stage: filterPipelineStage || "",
          },

      
          responseType: "blob",
          transformResponse: [(data) => data],
        }
      );
      if (!response || !response.data) {
        throw new Error("Empty file received");
      }
      let fileName = "candidates";
      const disposition = response.headers["content-disposition"];

      if (disposition) {
        const match = disposition.match(/filename="?([^"]+)"?/);
        if (match?.[1]) fileName = match[1];
      }
      const blob = new Blob([response.data], {
        type:
          response.headers["content-type"] ||
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, fileName);

    } catch (error) {
      console.error("Download failed:", error);

      Swal.fire({
        icon: "error",
        title: "Download Failed",
        text:
          error?.response?.data?.message ||
          error.message ||
          "Something went wrong",
      });
    } finally {
      setExcelDownloading(false);
    }
  };
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
const [showApproveRejectModal, setShowApproveRejectModal] = useState(false);
const [selectedJobCandidateForApproveReject, setSelectedJobCandidateForApproveReject] = useState(null);
const [approveRejectReason, setApproveRejectReason] = useState("");
const [isApprovingRejecting, setIsApprovingRejecting] = useState(false);
const [actionType, setActionType] = useState(""); // "approve" or "reject"
const [selectedJobCandidateForDetails, setSelectedJobCandidateForDetails] = useState(null);
const [filterJobTitle, setFilterJobTitle] = useState(""); // selected job title
const [jobTitleList, setJobTitleList] = useState([]); // list of job titles
const [pipelineHistoryModalOpen, setPipelineHistoryModalOpen] = useState(false);
const [pipelineHistoryLoading, setPipelineHistoryLoading] = useState(false);
const [pipelineHistoryData, setPipelineHistoryData] = useState([]);
const [pipelineHistoryTitle, setPipelineHistoryTitle] = useState("Pipeline History");
const [selectedPipelineHistoryCandidate, setSelectedPipelineHistoryCandidate] = useState(null);
const [jobTitlesLoading, setJobTitlesLoading] = useState(false);
const [jobTitleSearch, setJobTitleSearch] = useState("");
const [showResumeUploadChoiceModal, setShowResumeUploadChoiceModal] = useState(false);
const [pendingResumeFiles, setPendingResumeFiles] = useState([]);
const activeParsingTaskIdRef = useRef("");
const parsingCancelledRef = useRef(false);
const [resumeUploadMode, setResumeUploadMode] = useState(null);
const [selectedResumeJob, setSelectedResumeJob] = useState(null);
const getJobTitles = async (companyId, page = 1, search = "") => {
  // if (!companyId || companyId === "All") {
  //   setJobTitleList([]);
  //   return;
  // }

  setJobTitlesLoading(true);
  try {
   const response = await axios.get(`/api/v1/create-job-order/`, {
      params: {
        ...(companyId && companyId !== "All" ? { company_id: companyId } : {}),
        page,
        size: 10,
        ...(search ? { search } : {}),
      },
    });

    const data = response.data?.results || response.data?.data || [];
    const totalCount = response.data?.count || 0;

    const jobMap = new Map();
    data.forEach(item => {
      const id = item.job_id ?? item.id;
      const title = item.job_title ?? item.position ?? item.job_order_id;
      if (id && title) {
        jobMap.set(String(id), { id, title });
      }
    });

    setJobTitleList(Array.from(jobMap.values()));
    setJobTitleTotalCount(totalCount);
    setJobTitlePage(page);
  } catch (error) {
    console.error("Error fetching job titles:", error);
    setJobTitleList([]);
  } finally {
    setJobTitlesLoading(false);
  }
};

useEffect(() => {
  getJobTitles(companyId, 1, jobTitleSearch); 
}, [companyId]);
const [filterPipelineStage, setFilterPipelineStage] = useState("");
const fetchStages = async () => {
  try {
    const response = await axios.get("/api/v1/get-all-stages/");
    setStagesList(response.data.results || []);
  } catch (err) {
    console.error("Failed to fetch stages", err);
  }
};
useEffect(() => {
  fetchStages();
}, []);
console.log("selectedJobCandidateForApproveReject",selectedJobCandidateForApproveReject) 
const candidateRequestRef = useRef(0);

const extractCandidateJobs = candidate => {
  const linkedJobs = Array.isArray(candidate?.linked_jobs) ? candidate.linked_jobs : [];

  if (linkedJobs.length > 0) {
    return linkedJobs
      .map(job => ({
        id: job?.job ?? job?.job_id ?? job?.id,
        title: job?.job_name || job?.job_title || job?.title || job?.job || "",
        job_number: job?.job_number || "",
        company_id: candidate?.company || job?.company || candidate?.company_id || null,
      }))
      .filter(job => job.id || job.title);
  }

  const directJobId =
    candidate?.job_id ??
    candidate?.job_ids ??
    candidate?.job?.job_id ??
    candidate?.job?.id ??
    candidate?.linked_job_id ??
    null

  if (directJobId) {
    const normalizedJobIds = String(directJobId)
      .split(",")
      .map(id => id.trim())
      .filter(Boolean)

    return [
      ...normalizedJobIds.map((jobId, index) => ({
        id: jobId,
        title:
          candidate?.job_titles?.split(",")?.[index]?.trim() ||
          candidate?.job_titles?.trim() ||
          candidate?.job_title?.trim() ||
          "",
        job_number: candidate?.job_number || "",
        company_id: candidate?.company || candidate?.company_id || null,
      })),
    ].filter(job => job.id || job.title)
  }

  if (candidate?.job_titles) {
    return String(candidate.job_titles)
      .split(",")
      .map(title => title.trim())
      .filter(Boolean)
      .map((title, index) => ({
        id: `${candidate?.candidate_id || "candidate"}-${index}`,
        title,
        job_number: "",
        company_id: candidate?.company || candidate?.company_id || null,
      }));
  }

  return [];
};

const extractJobTitleOptions = rows => {
  const seen = new Set();
  const jobs = [];

  rows?.forEach(candidate => {
    extractCandidateJobs(candidate).forEach(job => {
      const key = `${job.id || ""}-${job.title || ""}`;
      if (!seen.has(key)) {
        seen.add(key);
        jobs.push(job);
      }
    });
  });

  return jobs;
};

const formatPipelineDate = (value) => {
  if (!value) return "-";
  const parsedDate = new Date(value);
  if (!Number.isNaN(parsedDate.getTime())) {
    return parsedDate.toLocaleString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  }

  const match = value.match(
    /^(\d{2})-(\d{2})-(\d{4}) (\d{2}):(\d{2}) (AM|PM)$/
  );
  if (!match) return value;
  let [_, day, month, year, hour, minute, period] = match;
  hour = parseInt(hour, 10);
  if (period === "PM" && hour !== 12) hour += 12;
  if (period === "AM" && hour === 12) hour = 0;
  const parsed = new Date(year, month - 1, day, hour, minute);
  return parsed.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  })
};

const getPipelineJobId = rowData =>
  rowData?.linked_jobs?.[0]?.job ||
  rowData?.linked_jobs?.[0]?.job_id ||
  rowData?.job_id ||
  rowData?.job ||
  "";

const normalizePipelineHistory = (payload, rowData) => {
  const rawHistory = Array.isArray(payload?.data)
    ? payload.data
    : Array.isArray(payload?.results)
      ? payload.results
      : Array.isArray(payload)
        ? payload
        : [];

  if (!rawHistory.length) {
    return rowData
      ? [
          {
            stage: rowData.candidate_pipeline_status || "-",
            changed_at: rowData.updated_at || rowData.created_at || null,
            changed_by: rowData.created_by_name || "-",
            reason: "Current pipeline status",
          },
        ]
      : [];
  }

  return rawHistory.map(item => ({
    stage:
      item?.stage_name ||
      item?.stage ||
      item?.status ||
      item?.candidate_pipeline_status ||
      item?.pipeline_status ||
      "-",
    changed_at:
      item?.created_at ||
      item?.updated_at ||
      item?.change_date ||
      item?.date ||
      null,
    changed_by:
      item?.created_by_name ||
      item?.updated_by_name ||
      item?.changed_by_name ||
      item?.user_name ||
      "-",
    reason: item?.reason || item?.note || item?.comments || "",
  }));
};

 const getCandidates = async (companyId, page = 1, size = 10, search = "", filter = "all", jobId = "",recruiterId = "",startDate = "",
  endDate = "" ,pipelineStage = "") => {
  const requestId = ++candidateRequestRef.current;
  setIsCandidatesLoading(true);
  let url = `/api/v1/candidates/?page=${page}&size=${size}&company_id=${companyId}`;
  if (search) {
    url += `&search=${encodeURIComponent(search)}`;
  }
  if (filter && filter !== "all") {
    url += `&filter=${encodeURIComponent(filter)}`;
  }
  if (jobId) {
    url += `&job_id=${jobId}`;
  }
  if (recruiterId) url += `&created_by=${recruiterId}`
  if (startDate) url += `&from_date=${startDate}`
  if (endDate) url += `&to_date=${endDate}`
  if (pipelineStage) url += `&pipeline_stage=${pipelineStage}`;

  try {
    const response = await axios.get(url);
    if (requestId !== candidateRequestRef.current) return;
    const response_data = response.data.results;
    if (response_data) {
      const normalizedCandidates = response_data.map(candidate => ({
        ...candidate,
        resume_source_name: normalizeResumeSourceName(
          candidate?.resume_source_name ||
            candidate?.source_name ||
            candidate?.source
        ),
      }));

      setCandidateListData(normalizedCandidates);
      setTotalRecords(response.data.count);
    }
  } catch (error) {
    if (requestId !== candidateRequestRef.current) return;
    console.error("Error fetching candidates:", error);
  } finally {
    if (requestId === candidateRequestRef.current) {
      setIsCandidatesLoading(false);
    }
  }
};

const normalizeTalentScanResults = data => {
  if (Array.isArray(data?.results)) {
    const nestedResults = data.results.flatMap(item => {
      const nestedResults = item?.talent_scan_result?.results;
      return Array.isArray(nestedResults)
        ? nestedResults.map(test => ({
            ...test,
            job_candidate_id: item?.job_candidate_id,
            job_id: item?.job_id,
            ts_candidate_id: item?.ts_candidate_id,
            ts_sync_status: item?.ts_sync_status,
          }))
        : [];
    });

    if (nestedResults.length > 0) return nestedResults;
  }

  const result = data?.talent_scan_result ?? data?.results ?? data?.data ?? data;

  if (Array.isArray(result)) return result;
  if (Array.isArray(result?.results)) return result.results;

  return [];
};

const formatTalentScanDate = value => {
  if (!value) return "--";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;
  return parsed.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const formatTalentScanValue = value =>
  value === null || value === undefined || value === "" ? "--" : value;

const getTalentScanNumber = value => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const formatTalentScanScore = value => {
  const parsed = getTalentScanNumber(value);
  if (parsed === null) return formatTalentScanValue(value);
  return Number.isInteger(parsed) ? parsed : parsed.toFixed(2).replace(/\.?0+$/, "");
};

const formatTalentScanPercent = value => {
  const parsed = getTalentScanNumber(value);
  if (parsed === null) return formatTalentScanValue(value);
  return `${parsed.toFixed(2).replace(/\.?0+$/, "")}%`;
};

const getTalentScanScoreTone = value => {
  const parsed = getTalentScanNumber(value);
  if (parsed === null) return "neutral";
  if (parsed >= 70) return "good";
  if (parsed >= 50) return "mid";
  return "low";
};

const hasTalentScanResults = rowData =>
  normalizeTalentScanResults(rowData).length > 0 ||
  normalizeTalentScanResults(rowData?.talent_scan_result).length > 0;

const handleViewTalentScanResult = async rowData => {
  const candidateId = rowData?.candidate_id ?? rowData?.id;

  if (!candidateId) {
    Swal.fire("Error", "Candidate ID not found.", "error");
    return;
  }

  setLoadingTalentScanCandidateId(candidateId);

  try {
    const response = await axios.post(
      "/api/v1/candidate-ts-all-result/",
      { candidate_id: candidateId },
      {
        params: {
          company_id: companyId,
          page: 1,
          size: 10,
        },
      }
    );

    const results = normalizeTalentScanResults(response?.data);
    setSelectedResult(results);
    setShowResultSummary(true);
  } catch (error) {
    console.error("Error fetching Talent Scan result:", error);
    setSelectedResult([]);
    Swal.fire(
      "Error",
      error?.response?.data?.message ||
        error?.response?.data?.detail ||
        "Failed to fetch Talent Scan result.",
      "error"
    );
  } finally {
    setLoadingTalentScanCandidateId(null);
  }
};

const handleViewPipelineHistory = rowData => {
  setSelectedPipelineHistoryCandidate(rowData);
  setPipelineHistoryTitle("Pipeline History");

  const stageLogs = rowData?.stage_change_logs || [];
  const linkedJobRejectedRound = rowData?.linked_jobs?.find(job => job?.rejected_round)?.rejected_round || "";
  const allLogs = stageLogs.flatMap(jobEntry =>
    (jobEntry?.logs || []).map(log => ({
      stage: log?.to_stage || "-",
      rejected_round:
        log?.rejected_round ||
        jobEntry?.rejected_round ||
        rowData?.rejected_round ||
        linkedJobRejectedRound ||
        "",
      changed_at: log?.timestamp || null,
      changed_by: log?.created_by || "-",
      reason: log?.reason || "-",
      job_title: jobEntry?.job_title || "",
    }))
  );

  // If no logs exist, show current status as a single row
  if (!allLogs.length) {
    setPipelineHistoryData([{
      stage: rowData?.candidate_pipeline_status || "-",
      rejected_round: rowData?.rejected_round || linkedJobRejectedRound || "",
      changed_at: rowData?.updated_at || rowData?.created_at || null,
      changed_by: rowData?.created_by_name || "-",
      reason: "-",
      job_title: rowData?.job_titles || "",
    }]);
  } else {
    setPipelineHistoryData(allLogs);
  }

  setPipelineHistoryModalOpen(true);
};

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    if (value === "") {
    getCandidates(companyId, 1, 10, "", filterStatus, filterJobTitle, filterRecruiter, filterStartDate, filterEndDate, filterPipelineStage  );
    }
  };
  const [pageSize, setPageSize] = useState(5);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 10,
    page: 1,
  });
  const [sortState, setSortState] = useState({ field: null, order: null });

  const handlePageChange = (event) => {
    const { first, rows } = event;
    const page = Math.floor(first / rows) + 1;
    setLazyParams({ first, rows, page });
    getCandidates(companyId, page, rows, searchQuery, filterStatus, filterJobTitle, filterRecruiter, filterStartDate, filterEndDate, filterPipelineStage);
  };
  // useEffect(() => {
  //   getCandidates(companyId, 1, 10);
  // }, [pageSize, companyId]);
  const onSubmit = async (data) => {
    setCandidateLoading(true);
    setCandidateError("");

    // Prepare the payload
    const payload = {
      first_name: data.firstname, // Make sure this matches the field name in your form
      last_name: data.lastname,
      email: data.personal_email,
      mobile_phone: data.phone,
      job_title: data.jobtitle,
      current_company: data.Company, // This should be the selected company ID
      primary_skills: primarySkillsview, // Make sure this is an array of skill IDs
      relocation: data.relocation || false,
      private: data.private || false,
      resume: resumefileData,
      street_address: formData.street_address,
      street_address_line_2: formData.street_address_line_2,
      country: formData.country?.name,
      state: formData.state?.name,
      city: formData.city?.name,
      pincode: formData.pincode,
      address_label: formData.label?.label,
      source: formData.source,
      stage: formData.stage,
    };

    try {
      const response = await axios.post("/api/v1/candidates/", payload, {
      });

      if (response.data) {
        // Reset form and close sidebar on success
        Swal.fire({
          title: "Success!",
          text: "Candidate created successfully!",
          icon: "success",
          confirmButtonText: "OK",
        });

        reset();
        setCandidateSidebarVisible(false);
        // Optionally, refresh the candidate list
        getCandidates(companyId, 1, 10, "", filterStatus, filterJobTitle, filterRecruiter, filterStartDate, filterEndDate, filterPipelineStage);
      }
    } catch (error) {
      setCandidateError("Failed to create candidate. Please try again.");
      console.error("Error:", error.response?.data || error.message);
    } finally {
      setCandidateLoading(false);
    }
  };

  const handleCompanyChange = (company) => {
    // setSelectedCompany(company);
    if (company?.company_id) {
      setCompanyId(company?.company_id);
      // getCandidates(company.company_id);
    }
  };

  const changeBackdrop = (e) => {
    let { value } = e.target;
    if (value !== 'static') {
      value = JSON.parse(value);
    }
    setBackdrop(value);
  };

  const changeKeyboard = (e) => {
    setKeyboard(e.currentTarget.checked);
  };

const viewCandidateExperience = (rowData) => {
  const exp = rowData?.total_experience;

  if (!exp) return <span className="text-muted">—</span>;

  const [yearPart, monthPart = "0"] = exp.split(".");
  const years = Number(yearPart) || 0;
  const months = Number(monthPart[0]) || 0; // 👈 only ONE digit

  return (
    <span className="bg-light px-2 py-1 rounded d-inline-block" title={`${years} ${years === 1 ? "Year" : "Years"}${months > 0 ? ` ${months} ${months === 1 ? "Month" : "Months"}` : ""}`}>
      {years} {years === 1 ? "Year" : "Years"}
      {months > 0 && ` ${months} ${months === 1 ? "Month" : "Months"}`}
    </span>
  );
};
const formatExperience = (totalExperience) => {
  if (!totalExperience) return "—";

  const [yearPart, monthPart = "0"] = totalExperience.split(".");
  const years = Number(yearPart) || 0;
  const months = Number(monthPart[0]) || 0; 

  if (months > 0) {
    return `${years} ${years === 1 ? "Year" : "Years"} ${months} ${
      months === 1 ? "Month" : "Months"
    }`;
  }

  return `${years} ${years === 1 ? "Year" : "Years"}`;
};

  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [candidateDetailPanel, setCandidateDetailPanel] = useState("contact");
  const [viewCandidateIndex, setViewCandidateIndex] = useState(null);
  const onRowToggle = (e) => {
    console.log(e)
    setExpandedJobRows(e.data);
  };

    const ViewCandidateInfoCall = (candidate) => {
    const index = CandidateListData.findIndex(
      c => c.candidate_id === candidate.candidate_id
    );
    setSelectedCandidate(candidate);
    setViewCandidateIndex(index);
    setCandidateDetailPanel("contact");
    setViewCandidatePopupShow(true);
  };
  console.log(selectedCandidate)

  const ViewCandidatecancel = () => {
    setViewCandidatePopupShow(!true);
    setViewCandidatePopupShow(false);
  };
  // Button body renderer for "Candidate Details" column
  const viewCandidateDetails = (rowData) => (
    <Button
      className="btn btn-light"
      onClick={(e) => {
        e.stopPropagation(); // Prevent row expansion
        ViewCandidateInfoCall(rowData);
      }}
    >
      <FaRegEye />
    </Button>
  );

  const viewIsSelectedStatus = (rowData) => (
    <span
      className={`fw-semibold ${
        rowData.is_selected ? "text-success" : "text-danger"
      }`}
    >
      {rowData.is_selected ? "Yes" : "No"}
    </span>
  );
  useEffect(() => {
    setRecruiterList([]); 
    setLazyParams({ first: 0, rows: 10, page: 1 }); 

    getCandidates(
      companyId,
      1,
      lazyParams.rows,
      searchQuery,
      filterStatus,
      filterJobTitle,
      filterRecruiter,
      filterStartDate,
      filterEndDate,
      filterPipelineStage
    );
    fetchApprovalRequests();
    getRecruiters(companyId);
  }, [companyId]); 

  const candidateExpansionTemplate = rowData => {
    return (
      <>
        {rowData &&
        rowData.assigned_tests &&
        rowData.assigned_tests.length > 0 ? (
          <div className="p-3 bg-light border rounded mt-2">
            <Row
              className="py-2 bg-opacity-10 rounded-top text-dark"
              style={{ backgroundColor: "#dfe9ff" }}
            >
              <Col md={2}>Test Name</Col>
              <Col md={2}>Total Score</Col>
              <Col md={2}>Facial Gesture</Col>
              <Col md={2}>Submitted At</Col>
              <Col md={2}>View Test</Col>
              <Col md={2}>Actions</Col>
            </Row>

            {rowData.assigned_tests.map((test, index) => (
              <Row
                key={index}
                className="align-items-center py-2 border-bottom"
              >
                <Col md={2}>{test.test_name || "TEST-1"}</Col>
                <Col md={2}>{test.total_score || "0.00%"}</Col>
                <Col md={2}>{test.facial_gesture || "0"}</Col>
                <Col md={2}>{test.submitted_at || "Not Submitted"}</Col>
                <Col md={2}>
                  <Button color="light" size="sm" disabled>
                    View
                  </Button>
                </Col>
                <Col md={2}>
                  <Button
                    size="sm"
                    className="me-2"
                    style={{ backgroundColor: "#13deb9" }}
                  >
                    Resend Test
                  </Button>
                  <Button color="danger" size="sm" outline>
                    Link Expired
                  </Button>
                </Col>
              </Row>
            ))}

            <Row className="py-2 mt-3 bg-primary bg-opacity-10 rounded-top text-dark">
              <Col md={2}>Call Id</Col>
              <Col md={2}>Call Status</Col>
              <Col md={2}>Call Source</Col>
              <Col md={2}>Date</Col>
              <Col md={4}>First Screening Evaluation</Col>
            </Row>

            <Row className="text-center py-3">
              <Col md={12}>
                <span className="text-muted fw-semibold">No Calls Yet</span>
              </Col>
            </Row>
          </div>
        ) : (
          <div className="p-3 text-muted">No Tests Assigned</div>
        )}
      </>
    );
  };

  const [scheduleCommonPopup, setScheduleCommonPopup] = useState(false);
  const [dialogCompanyId, setDialogCompanyId] = useState(companyId);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [scheduleSubtype, setScheduleSubtype] = useState(null);

  // const [scheduleStartDate, setScheduleStartdate] = useState(new Date());
  // const [scheduleStartTime, setScheduleStarttime] = useState(new Date());
  // const [scheduleEndDate, setScheduleEndDate] = useState(new Date());
  // const [scheduleEndTime, setScheduleEndTime] = useState(new Date());
  const { start: initialScheduleStart, end: initialScheduleEnd } = getDefaultInterviewTimes();
  const [scheduleStartDate, setScheduleStartdate] = useState(initialScheduleStart);
  const [scheduleStartTime, setScheduleStarttime] = useState(initialScheduleStart);
  const [scheduleEndDate, setScheduleEndDate] = useState(initialScheduleEnd);
  const [scheduleEndTime, setScheduleEndTime] = useState(initialScheduleEnd);

  const [scheduleSubject, setScheduleSubject] = useState("");
  const [scheduleEventType, setScheduleEventType] = useState("");
  const [schedulePriority, setSchedulePriority] = useState(null);
  const [scheduleDuration, setScheduleDuration] = useState(null);
  const [schedulepopchecked2, setSchedulePopchecked2] = useState(false);
  const [popchecked, setPopchecked] = useState(false);
  const [popTextares, setPopTextares] = useState("");
  // const [scheduleFormErrors, setScheduleFormErrors] = useState({});
  const [scheduleFormErrors, setScheduleFormErrors] = useState({
  job: "",
  interviewer: "",
    candidates: "",
  subject: "",
  priority: "",
});

  const [subtypeCall, setSubTypeCall] = useState([]);
  const [selectedScheduleJobs, setSelectedScheduleJobs] = useState([]);
  const [selectedScheduleContacts, setSelectedScheduleContacts] = useState([]);
  const [selectedScheduleCandidates, setSelectedScheduleCandidates] = useState([]);
  const [userid, setUserid] = useState([]);
  const [scheduleRepeat, setScheduleRepeat] = useState(null);
  const [scheduleAutoFollowup, setScheduleAutoFollowup] = useState(null);
  const [scheduleReminder, setScheduleReminder] = useState(null);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [selectedInterviewCandidate, setSelectedInterviewCandidate] = useState(null);
  const [selectedCcUsers, setSelectedCcUsers] = useState([]);

  const closeSchedulePopup = () => {
    resetScheduleForm()
    setScheduleCommonPopup(false);
  };
  const handlePopupCheckbox = (e) => {
    setPopchecked(e.checked);
  };

  const handlePopupCheckbox2 = (e) => {
    setSchedulePopchecked2(e.checked);
  };
  const [candidateStatusModal, setCandidateStatusModal] = useState(false);
  const [selectedCandidateStatusId, setSelectedCandidateStatusId] = useState("");
  const [reason, setReason] = useState("");
  const [candidateStatusError, setCandidateStatusError] = useState("");
  const [candidateStatusLoader, setCandidateStatusLoader] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [selectedCandidateForStatus, setSelectedCandidateForStatus] = useState(null);
  const [stagesList, setStagesList] = useState([]);
  // const fetchStages = async () => {
  //   try {
  //     const response = await axios.get("/api/v1/get-all-stages/");
  //     setStagesList(response.data.results || []);
  //   } catch (err) {
  //     console.error("Failed to fetch stages", err);
  //   }
  // };
  // useEffect(() => {
  //   fetchStages();
  // }, []);

  const handleContextMenuScheduleChange = scheduleType => {
    const selectedOption = actScheduleOptions.find(
      opt => opt.name === scheduleType
    )
    if (selectedOption) {
      setSelectedSchedule(selectedOption)
      resetScheduleForm()
      setDialogCompanyId(companyId)
      setScheduleCommonPopup(true)
      if (selectedOption.code) {
        // fetchSubTypes(selectedOption.code); // Uncomment if you have this function
      }
    }
  };

  const getCandidateFullName = candidate =>
    [candidate?.first_name, candidate?.middle_name, candidate?.last_name]
      .filter(Boolean)
      .join(" ")
      .trim() || "Candidate";

  const getInterviewJobLabel = job =>
    [job?.title, job?.job_number]
      .filter(Boolean)
      .join(", ")
      .trim();

  const getCandidateJobTitles = candidate =>
    [
      ...new Set(
        String(candidate?.job_titles || "")
          .split(",")
          .map(title => title.trim())
          .filter(Boolean)
      ),
    ].join(" | ");

  const bindCandidateForInterview = candidate => {
    if (!candidate) return;

    setSelectedInterviewCandidate(candidate);
    const candidateCompanyId =
      candidate?.company || candidate?.company_id || companyId;
    setDialogCompanyId(candidateCompanyId);
    setSelectedCustomers([candidate]);
    const candidateJobs = extractCandidateJobs(candidate);
    setSelectedScheduleCandidates([candidate]);
    setSelectedScheduleJobs(candidateJobs);
    setScheduleFormErrors(prev => ({
      ...prev,
      candidates: "",
      job_id: candidateJobs.length ? "" : "No job found for the selected candidate",
    }));
  };

  const openScheduleInterview = () => {
    if (!selectedInterviewCandidate) {
      Swal.fire({
        icon: "warning",
        title: "Select a candidate",
        text: "Please choose a candidate before scheduling an interview.",
      });
      return;
    }

    bindCandidateForInterview(selectedInterviewCandidate);
    const { start, end } = getDefaultInterviewTimes();
      setScheduleStartdate(start);
      setScheduleStarttime(start);
      setScheduleEndDate(end);
      setScheduleEndTime(end);
    const candidateCompanyId =
      selectedInterviewCandidate?.company || selectedInterviewCandidate?.company_id || dialogCompanyId || companyId;

    setDialogCompanyId(candidateCompanyId);
    setSelectedScheduleContacts([]);
    if (!extractCandidateJobs(selectedInterviewCandidate).length) {
      Swal.fire({
        icon: "warning",
        title: "No job found",
        text: "The selected candidate does not have any job title linked in the candidate list.",
      });
      return;
    }
    fetchInterviewTypes();
    getRecruiters(candidateCompanyId);
    setScheduleCommonPopup(true);
  };

  const priorityValue = [
    { name: "Low", value: "low" },
    { name: "Medium", value: "medium" },
    { name: "High", value: "high" },
  ]
  const repeatOptions = [
    { label: "None", value: "" },
    { label: "Daily", value: "daily" },
    { label: "Weekly", value: "weekly" },
    { label: "Monthly", value: "monthly" },
  ]

  const candidateStatusOptions = [
    { label: "Active", value: "Active" },
    { label: "InActive", value: "InActive" },
    { label: "DND(Do Not Disturb)", value: "DND(Do Not Disturb)" },
    { label: "Blacklisted", value: "Blacklisted" },
    { label: "Opt Out", value: "Opt-Out" },
  ];
  const autoFollowupOptions = [
    { label: "None", value: "" },
    { label: "1 Day", value: "1" },
    { label: "2 Days", value: "2" },
    { label: "3 Days", value: "3" },
  ]
  const reminderOptions = [
    { label: "None", value: "" },
    { label: "5 min", value: 5 },
    { label: "10 min", value: 10 },
    { label: "15 min", value: 15 },
    { label: "30 min", value: 30 },
    { label: "1 hour", value: 60 },
  ]
  const [interviewTypes, setInterviewTypes] = useState([]);
  const [scheduleTypeId, setScheduleTypeId] = useState(null);

  const fetchInterviewTypes = async () => {
    try {
      const response = await axios.get(
        "/api/v1/get-all-schedule-type/?interview=true"
      );

      if (response.status === 200) {
        const transformedData = response.data.results.map(type => ({
          name: type.schedule_type,
          code: type.id,
        }));
        setInterviewTypes(transformedData);
        const interviewType = transformedData.find(t => t.name === "Interview");
        if (interviewType) {
          setScheduleTypeId(interviewType.code);
          fetchSubTypes(interviewType.code); // fetch immediately instead of via effect
        }
      }
    } catch (error) {
      console.error("Error fetching interview types:", error);
    }
  };
  const fetchSubTypes = async id => {
    if (!id) return

    try {
      const response = await axios.get(
        `/api/v1/get-all-schedule-sub-type/?schedule_id=${id}`
      )
      const scheduleData = response.data?.results || []
      const transformedSubTypes = scheduleData.map(schedule => ({
        name: schedule.schedule_subtype || "Unnamed Sub-Type",
        code: schedule.id || "",
      }))
      setSubTypeCall(transformedSubTypes);
      const videoInterviewOption = transformedSubTypes.find(
        opt => opt.name?.trim().toLowerCase() === "video interview"
      );
      setScheduleSubtype(videoInterviewOption || null);
    } catch (error) {
      console.error("Error fetching sub-types:", error);
    }
  };

  // useEffect(() => {
  //   fetchInterviewTypes();
  // }, []);
  // useEffect(() => {
  //   if (scheduleTypeId) {
  //     fetchSubTypes(scheduleTypeId);
  //   }
  // }, [scheduleTypeId]);

  //   const handleScheduleChange = e => {
  //   resetScheduleFields()
  //   const selectedOption = e.value
  //   setSelectedSchedule(selectedOption)

  //   // Fetch subtypes based on the selected schedule ID
  //   if (selectedOption.code) {
  //     fetchSubTypes(selectedOption.code)
  //   }

  //   // Open the dialog
  //   setScheduleCommonPopup(true)
  // }
  const [typeInterviewval, settypeInterviewval] = useState([])
  const [typeInterviewcontact, settypeInterviewcontact] = useState([])
  const [allcontacts, setAllContacts] = useState([])
  const getallactivecontacts1 = async (page = 1, size = 10) => {
    try {
      const response = await axios.get(
        `/api/v1/contacts/?page=${page}&size=${size}&status=Active&company_id=${companyId}`
      );
      const transformedData = response.data.results?.map(contact => ({
        name: `${contact?.first_name} ${contact?.last_name || ""}`,
        id: contact?.id,
      }));
      settypeInterviewcontact(transformedData);
      setAllContacts(response.data.results);
    } catch (error) {
      console.error("Error fetching contacts:", error);
      // Optionally, show a toast or error message
    }
  };
  const initialAddressState = {
    street_address: "",
    street_address_line_2: "",
    country: null,
    state: null,
    city: null,
    pincode: "",
    label: null,
    source: null,
    stage: null,
  }
  const [formData, setFormData] = useState(initialAddressState);
  const [tempAddressData, setTempAddressData] = useState(initialAddressState);
  const [visible, setVisible] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [addressLabels, setAddressLabels] = useState([]);
  const [resumeSourceOptions, setResumeSourceOptions] = useState([]);
  const [primarySkillsview, setprimarySkillsview] = useState([]);
  const [selectedCategoryNode, setSelectedCategoryNode] = useState(null);
  const [selectedGroupNode, setSelectedGroupNode] = useState(null);
  const [categoryNodes, setCategoryNodes] = useState([]);
  const [groupNodes, setGroupNodes] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);

  // Additional candidate form states from AllActiveemp
  const [resumefileData, setResumeFileData] = useState([]);
  const [candidateError, setCandidateError] = useState("");
  const [candidateLoading, setCandidateLoading] = useState(false);
  const [candidatePrimarySkillsget, setCandidatePrimarySkillsget] = useState([]);
  const [candidateUniqueUserId, setCandidateUniqueUserId] = useState("");
  const [selectedCity, setSelectedCity] = useState(null);
  const [candidateSidebarVisible, setCandidateSidebarVisible] = useState(false);
  const [duplicateCandidateId, setDuplicateCandidateId] = useState(null);
  const [emailError, setEmailError] = useState("");
  const [resumeError, setResumeError] = useState("");
  const [stages, setStages] = useState([]);
  const openAddressDialog = () => {
    setTempAddressData({
      street_address: formData.street_address,
      street_address_line_2: formData.street_address_line_2,
      country: formData.country,
      state: formData.state,
      city: formData.city,
      pincode: formData.pincode,
      label: formData.label,
    })
    setVisible(true)
  }
  const handleAddressDialogCancel = () => {
    setTempAddressData({
      street_address: formData.street_address,
      street_address_line_2: formData.street_address_line_2,
      country: formData.country,
      state: formData.state,
      city: formData.city,
      pincode: formData.pincode,
      label: formData.label,
    });
    setVisible(false);
    setFormErrors({});
  };

  // File handling for candidate resume - match AllActiveemp exactly
  const handleCandidateFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // File size validation (5MB limit)
    const maxSize = 5 * 1024 * 1024; // 5MB in bytes
    if (file.size > maxSize) {
      setResumeError("File size must be less than 5MB");
      event.target.value = "";
      return;
    }

    // File type validation - match AllActiveemp exactly
    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "image/jpeg",
      "image/png",
    ];

    if (!allowedTypes.includes(file.type)) {
      setResumeError("Invalid file type. Please upload PDF, DOC, DOCX, JPEG, or PNG files only.");
      event.target.value = "";
      return;
    }

    // Prevent folder uploads
    if (file.size === 0 || !file.type) {
      setResumeError("Folders are not allowed. Please upload a valid file.");
      event.target.value = "";
      return;
    }

    try {
      const base64 = await getCandidateBase64(file);
      // Match AllActiveemp structure exactly
      setResumeFileData({
        file_name: file.name,
        file_data: base64.split(",")[1], // Remove data:mime;base64, prefix like in AllActiveemp
        type: file.type,
        size: file.size
      });
      setResumeError("");
      setCandidateError(""); // Clear general error
    } catch (error) {
      setResumeError("Failed to process file");
      setCandidateError("Failed to process file");
      event.target.value = "";
    }
  };
  const emailDebounceRef = useRef(null);
  const handleAddressDialogOk = () => {
    const errors = {};

    // Validate required fields
    if (!tempAddressData.street_address) {
      errors.street_address = "Street address is required";
    }
    if (!tempAddressData.country) {
      errors.country = "Country is required";
    }
    if (!tempAddressData.state) {
      errors.state = "State is required";
    }
    if (!tempAddressData.city) {
      errors.city = "City is required";
    }

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    // Update main form data with temp data
    const fullAddress = `${tempAddressData.street_address}${tempAddressData.street_address_line_2 ? ', ' + tempAddressData.street_address_line_2 : ''}, ${tempAddressData.city?.name}, ${tempAddressData.state?.name}, ${tempAddressData.country?.name}${tempAddressData.pincode ? ', ' + tempAddressData.pincode : ''}`;

    setFormData(prev => ({
      ...prev,
      ...tempAddressData,
      address: fullAddress
    }));

    setVisible(false);
    setFormErrors({});
  };

  const getCandidateBase64 = file => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    })
  }
  const [jobActualEnddate, setjobActualEnddate] = useState(null);
  const [primartkey, setprimartkey] = useState([]);
  const [successAlert, setSuccessAlert] = useState(false);
  const [deleteRowId, setDeleteRowID] = useState(null) // end date value
  const [jobStatusOptions, setJobStatusOptions] = useState([]);
  const [uniqueUserId, setUniqueUserId] = useState("");
  const [uniquemailID, setuniquemailID] = useState([]);
  const [errorjobs, seterrorjobs] = useState("");
  const [addPermission, setAddPermission] = useState(false);
  const [editPermission, setEditPermission] = useState(false);
  const [deletePermission, setDeletePermission] = useState(false);
  const [viewPermission, setViewPermission] = useState(false);
  const [primarySkillsget, setprimarySkillsget] = useState([]);
  const getMinEndDate = () => {
    if (!jobStartDate) return null
    const minDate = new Date(jobStartDate)
    minDate.setDate(minDate.getDate() + 1)
    return minDate
  }

  const getPrimarySkills = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-skills/`)
      const transformedData = response?.data?.results?.map(skill => ({
        name: skill?.skill_name,
        id: skill?.skill_id,
      }))
      setCandidatePrimarySkillsget(transformedData)
    } catch (error) {
      console.error("Failed to fetch primary skills", error)
    }
  }
  useEffect(() => {
  console.log("Modal open:", showUploadedResumeModal);
}, [showUploadedResumeModal]);

  // const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [showDetailsModal, setShowDetailsModal] = useState(false)
  const [uploadedResumeData, setUploadedResumeData] = useState(null)
  const uploadResult = getUploadResult(uploadedResumeData)
  const shouldShowNotificationWarning =
    uploadResult?.automation_enabled === true &&
    Array.isArray(uploadResult?.disabled_notification_channels) &&
    uploadResult.disabled_notification_channels.length > 0
  const getUploadTaskId = data =>
    data?.task_ids?.attachments_task ||
    data?.task_ids?.task_id ||
    data?.attachments_task ||
    data?.task_id ||
    "";

  const getAlreadyLinkedResponse = data => {
    const sources = [
      data,
      data?.result,
      data?.results,
      data?.data,
      data?.data?.result,
      data?.data?.results,
    ].filter(Boolean);
    const nestedItems = sources.flatMap(source => [
      ...(Array.isArray(source?.failed) ? source.failed : []),
      ...(Array.isArray(source?.failed_files) ? source.failed_files : []),
      ...(Array.isArray(source?.failed_resumes) ? source.failed_resumes : []),
    ]);
    return [...sources, ...nestedItems].find(item => item?.already_linked === true) || null;
  };

  const getUploadStatus = data =>
    data?.status ?? data?.data?.status ?? "";

  const isUploadSuccessStatus = data => {
    const status = String(getUploadStatus(data) || "").trim().toUpperCase();
    return !status || status === "SUCCESS";
  };

  const normalizeUploadedResumeData = data => {
    const result = getUploadResult(data);
    const createdCandidates =
      result.created_candidates ||
      result.created ||
      result.success_files ||
      [];
    const failedFiles =
      result.failed_files ||
      result.failed ||
      result.failed_resumes ||
      [];

    const normalizedCreatedCandidates = Array.isArray(createdCandidates) ? createdCandidates : [];
    const normalizedFailedFiles = Array.isArray(failedFiles) ? failedFiles : [];
    const duplicate = getAlreadyLinkedResponse(data);
    if (duplicate && !normalizedFailedFiles.some(item => item === duplicate || item?.email === duplicate.email)) {
      normalizedFailedFiles.push(duplicate);
    }

    return {
      ...result,
      created_candidates: normalizedCreatedCandidates,
      failed_files: normalizedFailedFiles,
      created_count: Number(result.created_count ?? result.success_count ?? normalizedCreatedCandidates.length),
      failed_count: Number(result.failed_count ?? normalizedFailedFiles.length),
    };
  };

  const notificationChannelLabel = channel => ({
    email: "Email OFF",
    sms: "SMS OFF",
    whatsapp: "WhatsApp OFF",
  }[String(channel).toLowerCase()] || `${channel} OFF`);

 const cancelResumeParsing = async () => {
  const taskId = activeParsingTaskIdRef.current;
  if (!taskId) return;
  try {
    await axios.post(`/api/v1/resume-parsing/${taskId}/cancel/`, {});
    parsingCancelledRef.current = true;
    activeParsingTaskIdRef.current = "";
    Swal.close();
    setIsImportingResume(false);
    setPendingResumeFiles([]);
    await Swal.fire("Resume parsing cancelled.", "You can upload another batch.", "success");
  } catch (error) {
    const status = error?.response?.status;
    Swal.fire("Error", status === 409 ? "This parsing task has already completed." : status === 404 ? "Parsing task was not found." : "Unable to cancel parsing. Please try again.", "error");
  }
 };
 const showResumeUploadProcessingToast = (progress = 0) => {
  Swal.fire({
    toast: true,
    customClass: { popup: "resume-processing-toast" },
    position: "top-end",
    icon: "info",
    title: "Processing...",
    text: "Please wait while we fetch the result.",
    showConfirmButton: false,
    // confirmButtonText: "Cancel Parsing",
    // confirmButtonColor: "#dc3545",
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => {
      Swal.showLoading();

      // Append progress bar below toast content
      const container = Swal.getHtmlContainer()?.parentElement;

      if (container) {
        const progressWrapper = document.createElement("div");
        progressWrapper.style.width = "100%";
        progressWrapper.style.marginTop = "12px";

        progressWrapper.innerHTML = `
          <div style="
            width:100%;
            height:8px;
            background:#e2e8f0;
            border-radius:999px;
            overflow:hidden;
          ">
            <div
              id="resume-upload-progress-bar"
              style="
                width:${progress}%;
                height:100%;
                background:#6366f1;
                transition:width .4s ease;
              "
            ></div>
          </div>

          <div
            id="resume-upload-progress-text"
            style="
              text-align:right;
              font-size:11px;
              color:#64748b;
              margin-top:4px;
            "
          >
            ${progress}%
          </div>
        `;

        container.appendChild(progressWrapper);
      }
    },
  }).then(result => {
    if (result.isConfirmed) cancelResumeParsing();
  });
};

 const waitForUploadTask = taskId => {
  activeParsingTaskIdRef.current = taskId;
  parsingCancelledRef.current = false;
  return new Promise((resolve, reject) => {
    let progress = 10;

    const check = async () => {
      if (parsingCancelledRef.current) {
        reject(new Error("Resume parsing cancelled."));
        return;
      }
      try {
        // Increase progress by 25 on every API call
        progress = Math.min(progress + 25, 90);

        const progressBar = document.getElementById(
          "resume-upload-progress-bar"
        );

        const progressText = document.getElementById(
          "resume-upload-progress-text"
        );

        if (progressBar) {
          progressBar.style.width = `${progress}%`;
        }

        if (progressText) {
          progressText.innerText = `${progress}%`;
        }

        const response = await axios.get(
          `/api/v1/task-status/${taskId}/`
        );

        const taskData = response?.data || {};
        const status = String(taskData?.status || "").toUpperCase();

        if (status === "SUCCESS") {
          if (progressBar) {
            progressBar.style.width = `100%`;
          }

          if (progressText) {
            progressText.innerText = `100%`;
          }
            Swal.close();
          resolve(taskData);

        } else if (
          status === "FAILURE" ||
          status === "FAILED"
        ) {
          Swal.close();

          reject(
            new Error(
              taskData?.error ||
                "Resume upload task failed."
            )
          );

        } else {
          setTimeout(check, 1000);
        }

      } catch (err) {
        Swal.close();
        reject(err);
      }
    };

    check();
  });
};

  const uploadResumeFiles = async (files, job = null) => {
    if (await hasLegacyWordDocument(files)) {
      await Swal.fire({
        icon: "warning",
        title: "Microsoft Word 97-2003 Document",
        text: "This .doc file cannot be parsed. Please upload the resume in PDF or DOCX format.",
        confirmButtonText: "OK",
      });
      return false;
    }

    setShowResumeUploadChoiceModal(false)
    setIsImportingResume(true)
    let isBackgroundProcessing = false

    try {
      const attachments = await Promise.all(
        files.map(async file => {
          const base64 = await getBase64(file)
          return {
            file_name: file.name,
            file_data: base64.split(",")[1],
          }
        })
      )

      const response = await axios.post(
        job
          ? `/api/v1/candidates/upload-resumes/`
          : `/api/v1/candidates/upload-resumes/?without_job=true`,
        job
          ? { attachments, company_id: companyId, job_id: job.id }
          : { attachments, company_id: companyId }
      )

      if (response.data) {
        let uploadResult = response.data
        const taskId = getUploadTaskId(response.data)

        isBackgroundProcessing = true
        setIsImportingResume(false)
        showResumeUploadProcessingToast(10)

        if (taskId) {
          uploadResult = await waitForUploadTask(taskId)
        } else if (!isUploadSuccessStatus(uploadResult)) {
          throw new Error(uploadResult?.error || uploadResult?.message || "Resume upload task failed.")
        }

        const normalizedUploadResult = normalizeUploadedResumeData(uploadResult)
        const smsWarnings = (Array.isArray(getUploadResult(normalizedUploadResult)?.invited)
          ? getUploadResult(normalizedUploadResult).invited
          : [])
          .filter(candidate => candidate?.notification_warning)
          .map(candidate => {
            const name = candidate?.candidate_name || candidate?.name || `Candidate ${candidate?.candidate_id}`
            return `${name}: ${candidate.notification_warning}`
          })
        setUploadedResumeData(normalizedUploadResult)
        Swal.close()
        if (smsWarnings.length > 0) {
          await Swal.fire({
            icon: "warning",
            title: "Some SMS Notifications Were Not Sent",
            text: smsWarnings.join("\n"),
            confirmButtonText: "OK",
          })
        }
        setShowUploadedResumeModal(true)
        await getCandidates(companyId, 1, 10, "", filterStatus, filterJobTitle, filterRecruiter, filterStartDate, filterEndDate, filterPipelineStage)
      }
    } catch (error) {
      console.error("Error uploading resumes:", error)
      if (isBackgroundProcessing) Swal.close()
      if (parsingCancelledRef.current) return
      Swal.fire({
        title: "Error",
        text: error?.response?.data?.error || error?.response?.data?.message || "Failed to upload resumes. Please try again.",
        icon: "error",
      })
    } finally {
      if (!isBackgroundProcessing) setIsImportingResume(false)
      setPendingResumeFiles([])
      setResumeUploadMode(null)
      setSelectedResumeJob(null)
    }
  }

  const handleImportResumeChange = async event => {
    const files = Array.from(event.target.files)
    if (files.length === 0) return
    // Validate file types and sizes
    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "image/jpeg",
      "image/png",
    ]
    const maxSize = 5 * 1024 * 1024 // 5MB
    const validFiles = []
    const invalidFiles = []

    for (const file of files) {
      if (!allowedTypes.includes(file.type)) {
        invalidFiles.push(file.name)
        continue
      }
      if (file.size > maxSize) {
        invalidFiles.push(file.name)
        continue
      }
      validFiles.push(file)
    }

    if (invalidFiles.length > 0) {
      Swal.close()
      setResumeError(
        `Invalid files: ${invalidFiles.join(
          ", "
        )}. Only PDF, DOC, DOCX, JPEG, or PNG files under 5MB are allowed.`
      )
      setIsImportingResume(false)
      return
    }
    if (!resumeUploadMode) {
      setPendingResumeFiles(validFiles)
      setShowResumeUploadChoiceModal(true)
      return
    }

    if (resumeUploadMode === "job" && !selectedResumeJob) {
      setPendingResumeFiles(validFiles)
      setShowResumeUploadChoiceModal(true)
      return
    }

    await uploadResumeFiles(validFiles, resumeUploadMode === "job" ? selectedResumeJob : null)
    event.target.value = null
  }

  const handleTempAddressChange = (field, value) => {
    setTempAddressData(prev => ({
      ...prev,
      [field]: value,
    }))
    if (formErrors[field]) {
      setFormErrors(prev => ({
        ...prev,
        [field]: "",
      }))
    }
  }
  useEffect(() => {
    if (tempAddressData.country?.country_id) {
      fetchStates(tempAddressData.country.country_id)
      setTempAddressData(prev => ({
        ...prev,
        state: null,
        city: null,
      }))
    }
  }, [tempAddressData.country])

  useEffect(() => {
    if (tempAddressData.state?.state_id) {
      fetchCities(tempAddressData.state.state_id)
      setTempAddressData(prev => ({
        ...prev,
        city: null,
      }))
    }
  }, [tempAddressData.state])
  // useEffect(() => {
  //   // getallactivecontacts1()
  //   // fetchSubTypes()
  //   getCompanydata()
  // }, [])
  // Helper function to convert file to base64
  const getBase64 = file => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = error => reject(error)
    })
  }
  const fetchCandidateStages = async () => {
    try {
      const response = await axios.get("/api/v1/get-all-stages/")
      if (response?.data?.results) {
        const stageOptions = response.data.results
          .sort((a, b) => a.order - b.order)
          .map(stage => ({
            label: stage.name,
            value: stage.name,
          }))
        setStageOptions(stageOptions)
      }
    } catch (error) {
      console.error("Failed to fetch stages for candidate form", error)
    }
  }

  // Candidate form API functions

  const getCategories = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-categories/`)
      if (response?.data && response?.data?.results) {
        const transformedData = transformCategoriesToTree(response.data.results)
        setCategoryNodes(transformedData)
      }
    } catch (error) {
      console.error("Failed to fetch categories", error)
    }
  }

  const getGroups = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-groups/`)
      if (response?.data && response?.data?.results) {
        const transformedData = transformGroupsToTree(response.data.results)
        setGroupNodes(transformedData)
      }
    } catch (error) {
      console.error("Failed to fetch groups", error)
    }
  }

  const getCountries = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-countries/`)
      const transformedData = response?.data?.results?.map(country => ({
        name: country?.name,
        country_id: country?.country_id,
      }))
      setCountries(transformedData)
    } catch (error) {
      console.error("Failed to fetch countries", error)
    }
  }

  // Address dropdown API calls
  const fetchStates = async countryId => {
    try {
      const response = await axios.get(
        `/api/v1/get-all-states/?country_id=${countryId}`
      )
      const transformedData = response?.data?.results?.map(state => ({
        name: state?.name,
        state_id: state?.state_id,
      }))
      setStates(transformedData)
    } catch (error) {
      console.error("Failed to fetch states", error)
      setStates([])
    }
  }

  const fetchCities = async stateId => {
    try {
      const response = await axios.get(
        `/api/v1/get-all-cities/?state_id=${stateId}`
      )
      const transformedData = response?.data?.results?.map(city => ({
        name: city?.name,
        city_id: city?.city_id,
      }))
      setCities(transformedData)
    } catch (error) {
      console.error("Failed to fetch cities", error)
      setCities([])
    }
  }

  const getAddressLabels = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-address-label/`)
      if (response?.data?.results) {
        setAddressLabels(
          response.data.results.map(label => ({
            label: label.address_label,
            value: label.id,
          }))
        )
      }
    } catch (error) {
      console.error("Failed to fetch address labels", error)
    }
  }

  const fetchResumeSource = async () => {
    try {
      const response = await axios.get("/api/v1/resume-source/")
      if (response?.data?.results) {
        setResumeSourceOptions(
          response.data.results.map(source => ({
            label: source.resume_source,
            value: source.source_id,
          }))
        )
      }
    } catch (error) {
      console.error("Error fetching resume sources:", error)
    }
  }
const normalizeApprovalJob = job => ({
  job_candidate_id: job.job_candidate_id,
  candidate_id: job.candidate,
  candidate_name: job.candidate_name,
  job_id: job.job,
  job_name: job.job_name,
  send_for_approval_reason: job.send_for_approval_reason,
  is_approved_reason: job.is_approved_reason,
  is_rejected_reason: job.is_rejected_reason,
  is_approved: job.is_approved,
  is_rejected: job.is_rejected,
});

  // Transform categories to tree structure
  const transformCategoriesToTree = categories => {
    return categories?.map(category => ({
      key: category.category_id,
      label: category.name, // Use 'name' field from API response
      data: category,
      children: category.subcategories
        ? transformCategoriesToTree(category.subcategories)
        : [],
    }))
  }

  // Transform groups to tree structure
  const transformGroupsToTree = groups => {
    return groups?.map(group => ({
      key: group.group_id,
      label: group.name, // Use 'name' field from API response
      data: group,
      children: group.subgroups ? transformGroupsToTree(group.subgroups) : [],
    }))
  }
  const [activePipelineTab, setActivePipelineTab] = useState("received")
  // Track active pipeline tab for each job in expanded rows
  const [jobActivePipelineTabs, setJobActivePipelineTabs] = useState({})
  const [selectedJobsData, setSelectedJobsData] = useState([])
  const [selectedactivity, setselectedactivity] = useState([])
  const [jobidsslect, setjobidsslect] = useState([])
  const [candidateidsslect, setcandidateidsslect] = useState([])
  const [jobidsslectnames, setjobidsslectnames] = useState([])
  const [successAlertlink, setsuccessAlertlink] = useState(false)
  const [selectedJobListname, setselectedJobListname] = useState([])
  const location = useLocation()
  const currentpath = location.pathname
  const handleViewActionLogs = async userId => {
    try {
      const response = await axios.get(
        `/api/v1/action-logs/?page=1&size=10&candidate_id=${userId}`
      )
      navigate("/candidate-time-line", {
        state: { timelineData: response.data.data, isfrom: currentpath },
      })
    } catch (error) {
      console.error("Error fetching action logs:", error)
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No Action Logs Found!.",
        confirmButtonColor: "#d33",
      })
    }
  }

  useEffect(() => {
    if (candidateSidebarVisible) {
      getPrimarySkills()
      getCategories()
      getGroups()
      getCountries()
      getAddressLabels()
      fetchResumeSource()
      fetchCandidateStages()

      // Auto-populate stage field based on active pipeline tab when opening candidate form
      const currentJobId =
        selectedJobsData.length > 0 ? selectedJobsData[0]?.job_id : null
      let stageToSet = null

      if (currentJobId && jobActivePipelineTabs[currentJobId]) {
        // Use the active tab for the specific job
        stageToSet = jobActivePipelineTabs[currentJobId]
      } else if (activePipelineTab) {
        // Use the global active pipeline tab
        stageToSet = activePipelineTab
      } else if (stages?.length > 0) {
        // Fallback to first stage
        stageToSet = stages[0]?.name || stages[0]
      }

      if (stageToSet) {
        setFormData(prev => ({
          ...prev,
          stage: stageToSet,
        }))
      }
    }
  }, [
    candidateSidebarVisible,
    activePipelineTab,
    stages,
    jobActivePipelineTabs,
    selectedJobsData,
    companyId,
  ])
  const dispatch = useDispatch()
  const onlyNumbers = /^[0-9]+$/
  const [companies, setcompanies] = useState([])
  const getCompanydata = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-companies/`, {})
      const transformedData = response?.data?.results?.map(company => ({
        name: company?.company_name,
        id: company?.company_id,
      }))
      setcompanies(transformedData)
    } catch (error) {}
  }
  const handleCandidateInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value,
    }))

    // Clear validation error when user selects a value for mandatory fields
    if ((field === "source" || field === "stage") && value) {
      setFormErrors(prev => ({
        ...prev,
        [field]: "",
      }))
    }
  }
  const [isImportingResume, setIsImportingResume] = useState(false)
  // const validateScheduleForm = () => {
  //   const errors = {}
  //   if (!scheduleSubtype) errors.event_sub_type = "Sub-Type is required"
  //   // if (!scheduleStartDate) errors.start_date = "Start date is required";
  //   // if (!scheduleStartTime) errors.start_time = "Start time is required";
  //   // if (!scheduleEndDate) errors.end_date = "End date is required";
  //   // if (!scheduleEndTime) errors.end_time = "End time is required";
  //   if (!selectedScheduleContacts || selectedScheduleContacts.length === 0) {
  //       errors.selectedScheduleContacts = "Interviewer is required";
  //       // isValid = false;
  //     } else {
  //       errors.selectedScheduleContacts = "";
  //     }
  //   if (!selectedScheduleJobs.length) errors.job_id = "Job is required";
  //   // if(!event_priority) errors.event_priority="Priority is Required"
  //   // if (!selectedScheduleCandidates.length) errors.candidates = "Candidate is required";
  //   if (!scheduleSubject) errors.subject = "Subject is required";
  //   // if (!scheduleDuration) errors.duration = "Duration is required";
  //   console.log("err", errors)

  //   setScheduleFormErrors(errors)
  //   return Object.keys(errors).length === 0
  // }
  const validateScheduleForm = () => {
  const errors = {};
  const now = new Date();

  if (!scheduleSubtype) errors.event_sub_type="Sub-Type is required"

  if (!selectedScheduleContacts || selectedScheduleContacts.length === 0) {
    errors.interviewer = "Interviewer is required";
  }

  if (!selectedScheduleJobs || selectedScheduleJobs.length === 0) {
    errors.job_id = "Job is required";
  }
  if (!selectedScheduleCandidates.length) errors.candidates = "Candidate is required";
  if (!scheduleSubject || scheduleSubject.trim() === "") {
    errors.subject = "Subject is required";
  }
  if (!scheduleEventType || scheduleEventType.trim() === "") {
    errors.event_type = "Type is required";
  }

  if (!schedulePriority) {
    errors.priority = "Priority is required";
  }
if (
    scheduleStartDate &&
    scheduleStartTime &&
    scheduleEndDate &&
    scheduleEndTime
  ) {
    const startDateTime = new Date(scheduleStartDate);
    startDateTime.setHours(
      scheduleStartTime.getHours(),
      scheduleStartTime.getMinutes(),
      0
    );

    const resolvedEndDate =
      scheduleEndDate && scheduleEndDate >= scheduleStartDate
        ? scheduleEndDate
        : scheduleStartDate;
    const endDateTime = new Date(resolvedEndDate);
    endDateTime.setHours(
      scheduleEndTime.getHours(),
      scheduleEndTime.getMinutes(),
      0
    );
    if (startDateTime < now) {
      errors.start_time = "Start Time cannot be in the Past Time";
    }
    if (endDateTime <= startDateTime) {
      errors.end_time = "End Time must be after Start Time";
    }
  }
  setScheduleFormErrors(errors);
  return Object.keys(errors).length === 0;
};

  const handleCandidateStatusUpdate = async () => {
    setIsSubmitted(true)
    setCandidateStatusLoader(true)
    if (!selectedCandidateStatusId) {
      setCandidateStatusLoader(false)
      return setCandidateStatusError("Select a status")
    }
    if (reason.trim() === "") {
      setCandidateStatusLoader(false)
      return
    }
    const selectedStage = stagesList.find(
      stage => stage.id == selectedCandidateStatusId
    )
    if (!selectedStage) {
      setCandidateStatusLoader(false)
      return setCandidateStatusError("Invalid stage selected")
    }

    try {
      await axios.put(
        `/api/v1/change-stage/${selectedCandidateForStatus.candidate_id}/?company_id=${companyId}`,
        {
          stage: selectedStage.name,
          reason: reason,
        }
      )
      Swal.fire({
        title: "Success!",
        text: "Candidate stage updated successfully!",
        icon: "success",
        confirmButtonText: "OK",
      })
      setCandidateStatusModal(false)
      setCandidateStatusLoader(false)
      setCandidateStatusError("")
      setReason("")
      setIsSubmitted(false)
      await getCandidates(companyId, 1, 10, "", filterStatus, filterJobTitle, filterRecruiter, filterStartDate, filterEndDate, filterPipelineStage)
    } catch (err) {
      console.error(err)
      setCandidateStatusLoader(false)
      setCandidateStatusModal(false)
      setCandidateStatusError("")
      Swal.fire({
        title: "Error!",
        text: err.response?.data?.error || "Failed to update candidate stage",
        icon: "error",
        confirmButtonText: "OK",
      })
    }
  }

  const [loadingSave, setLoadingSave] = useState(false)
  const resolveCandidateId = candidate =>
    candidate?.candidate_id ?? candidate?.id ?? candidate?.value ?? null

  const resolveCandidateJobId = candidate => {
    const linkedJobId = Array.isArray(candidate?.linked_jobs)
      ? candidate.linked_jobs
          .map(job => job?.job_id ?? job?.job ?? job?.id)
          .find(Boolean)
      : null

    const directJobId =
      candidate?.job_id ??
      candidate?.job_ids ??
      candidate?.job?.job_id ??
      candidate?.job?.id ??
      candidate?.linked_job_id ??
      null

    if (directJobId) {
      return String(directJobId).split(",").map(id => id.trim()).filter(Boolean)[0] || null
    }

    return (
      linkedJobId ??
      null
    )
  }

  const handleSaveSchedule = async () => {
    if (!validateScheduleForm()) {
      return
    }
    setLoadingSave(true)
    const apiUrl = `api/v1/events/?company_id=${companyId}`

    const payload = {
      event_sub_type: scheduleSubtype?.name || "Screening Call",
      event_type: scheduleEventType?.trim() || "Interview",
      end_date: formatDate(
        scheduleEndDate && scheduleEndDate >= scheduleStartDate
          ? scheduleEndDate
          : scheduleStartDate
      ),
      start_date: formatDate(scheduleStartDate),
      start_time: formatTime(scheduleStartTime),
      end_time: formatTime(scheduleEndTime),
      candidate_id: selectedScheduleCandidates
        .map(resolveCandidateId)
        .filter(Boolean),
      candidates: selectedScheduleCandidates
        .map(candidate => candidate.email)
        .filter(Boolean),
      cc_users: selectedCcUsers,
      subject: scheduleSubject,
      job_id: [
        ...new Set(
          selectedScheduleCandidates
            .map(resolveCandidateJobId)
            .concat(
              selectedScheduleJobs.map(job => job?.id ?? job?.job_id ?? job?.job)
            )
            .filter(Boolean)
        ),
      ],
      event_time: new Date(
        `${formatDate(scheduleStartDate)}T${formatTime(scheduleStartTime)}`
      ).toISOString(),
      event_priority: schedulePriority || "Low",
      private: popchecked,
      completed: false,
      body: popTextares,
      contact_id: selectedScheduleContacts,
      reminder: scheduleReminder?.value || 10,
      // duration:`${scheduleDuration} Minutes`
    }

    try {
      const response = await axios.post(apiUrl, payload, {})
      if (!isSuccessfulDelivery(response, [200, 201, 202])) {
        throw Object.assign(new Error(deliveryErrorMessage(response.data)), { response })
      }
      console.log("Event saved successfully:", response.data)
      for (const candidate of selectedScheduleCandidates) {
        try {
          const candidateId = resolveCandidateId(candidate)
          const candidateJobId = resolveCandidateJobId(candidate) || selectedScheduleJobs[0]?.id
          await axios.post(
            // "/api/v1/candidate-interview-mail/",
            {
              candidate_email: candidate.email,
              job_id: candidateJobId,
              interview_date: formatDate(scheduleStartDate),
              interview_time: formatTime(scheduleStartTime),
              subject: scheduleSubject,
              body: popTextares,
              contact_id: selectedScheduleContacts,
              candidate_id: candidateId ? [candidateId] : [],
            }
          )
        } catch (emailError) {
          console.error(
            `Failed to send email to ${candidate.email}:`,
            emailError
          )
        }
      }
      Swal.fire({
        title: "Success!",
        text: "Interview scheduled successfully!",
        icon: "success",
        confirmButtonText: "OK",
      })
      resetScheduleForm()
      closeSchedulePopup()
    } catch (error) {
      console.error("Error saving event:", error)
      const errorMessage = deliveryErrorMessage(error?.response?.data)
      console.log("errorMessage", errorMessage)
      Swal.fire({
        title: "Error!",
        text: `${errorMessage}`,
        icon: "error",
        confirmButtonText: "OK",
      })
    } finally {
      setLoadingSave(false)
    }
  }

  const formatDate = date => {
    if (!date) return ""
    const d = new Date(date)
    const year = d.getFullYear()
    const month = String(d.getMonth() + 1).padStart(2, "0")
    const day = String(d.getDate()).padStart(2, "0")
    return `${year}-${month}-${day}`
  }

  const formatTime = time => {
    if (!time) return ""
    const t = new Date(time)
    const hours = String(t.getHours()).padStart(2, "0")
    const minutes = String(t.getMinutes()).padStart(2, "0")
    const seconds = String(t.getSeconds()).padStart(2, "0")
    return `${hours}:${minutes}:${seconds}`
  }
  const formatDisplayName = name =>
    name
      ? String(name)
          .toLowerCase()
          .replace(/\b\w/g, char => char.toUpperCase())
      : ""
  const getNameInitials = name =>
    name
      ? String(name)
          .trim()
          .split(/\s+/)
          .map(part => part[0])
          .slice(0, 2)
          .join("")
          .toUpperCase()
      : "?"
  const getInitialsStyle = name => {
    const avatarColors = [
      "#0d6efd",
      "#7c3aed",
      "#059669",
      "#d97706",
      "#dc2626",
      "#0891b2",
    ]
    let hash = 0
    const text = String(name || "")
    for (let i = 0; i < text.length; i++) {
      hash = text.charCodeAt(i) + ((hash << 5) - hash)
    }
    return {
      background: avatarColors[Math.abs(hash) % avatarColors.length],
      color: "#fff",
    }
  }

  const [isLoading, setIsLoading] = useState(false)
  const [loadingStates, setLoadingStates] = useState({})
  const handleClick = (e, rowData) => {
    e.stopPropagation()
    setLoadingStates(prev => ({
      ...prev,
      [rowData.candidate_id]: true,
    }))
    setTimeout(() => {
      navigate(`/candidate-editform?candidate_id=${rowData.candidate_id}`)
      setLoadingStates(prev => ({
        ...prev,
        [rowData.candidate_id]: false,
      }))
    }, 500)
  }
  const [isCandidatesLoading, setIsCandidatesLoading] = useState(false)
  const otherSkills = Array.isArray(selectedCandidate?.other_skill_names)
    ? selectedCandidate.other_skill_names
    : selectedCandidate?.other_skill_names
    ? selectedCandidate.other_skill_names.split(",").map(s => s.trim())
    : []
  const resetScheduleForm = () => {
    setScheduleSubtype(null)
    // setScheduleStartdate(new Date())
    // setScheduleStarttime(new Date())
    // setScheduleEndDate(new Date())
    // setScheduleEndTime(new Date())
    const { start, end } = getDefaultInterviewTimes();
    setScheduleStartdate(start)
    setScheduleStarttime(start)
    setScheduleEndDate(end)
    setScheduleEndTime(end)
    setScheduleSubject("")
    setScheduleEventType("")
    setSchedulePriority(null)
    setScheduleDuration(null)
    setSchedulePopchecked2(false)
    setPopchecked(false)
    setPopTextares("")
    setSelectedScheduleJobs([])
    setSelectedScheduleContacts([])
    setSelectedScheduleCandidates([])
    setSelectedCcUsers([])
    setScheduleFormErrors({})
    setScheduleRepeat(null)
    setScheduleAutoFollowup(null)
    setScheduleReminder(null)
  }

  const getSelectedCandidateName = () =>
    [
      selectedCandidate?.first_name,
      selectedCandidate?.middle_name,
      selectedCandidate?.last_name,
    ]
      .filter(Boolean)
      .join(" ") || "Candidate"

  const getCandidateInitials = () =>
    getSelectedCandidateName()
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map(name => name.charAt(0).toUpperCase())
      .join("")

  const toSkillList = value => {
    if (Array.isArray(value)) return value.filter(Boolean)
    if (typeof value === "string") {
      return value
        .split(",")
        .map(skill => skill.trim())
        .filter(Boolean)
    }
    return []
  }

  const renderCandidateSkillChips = skills => {
    const skillList = toSkillList(skills)

    if (!skillList.length) {
      return <span style={{ color: "#94a3b8", fontSize: 13 }}>--</span>
    }

    return (
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
        {skillList.map(skill => (
          <span
            key={skill}
            style={{
              background: "#eef6ff",
              border: "1px solid #cfe4ff",
              borderRadius: 6,
              color: "#1a5fa8",
              fontSize: 12,
              fontWeight: 600,
              padding: "5px 9px",
            }}
          >
            {skill}
          </span>
        ))}
      </div>
    )
  }

  const renderCandidateInfoItem = (label, value) => (
    <Col md={6}>
      <div
        style={{
          border: "1px solid #e2e8f0",
          borderRadius: 8,
          background: "#fbfdff",
          padding: "12px 14px",
          height: "100%",
        }}
      >
        <div style={{ color: "#64748b", fontSize: 12, fontWeight: 600, marginBottom: 4 }}>
          {label}
        </div>
        <div style={{ color: "#0f172a", fontSize: 14, fontWeight: 600, wordBreak: "break-word" }}>
          {value || "--"}
        </div>
      </div>
    </Col>
  )

  const renderTalentScanResults = () => {
    if (!selectedResult?.length) {
    return (
      <div className="ts-result-empty">
        <div className="ts-result-empty-icon">i</div>
        <div className="ts-result-empty-title">No Talent Scan result</div>
        <div className="ts-result-empty-copy">
          The candidate has not attempted the Talent Scan assessment yet.
        </div>
      </div>
    );
  }

    return (
      <div className="ts-result-list">
        {selectedResult.map((result, index) => {
          const qualified = !!result?.ats_details?.is_test_qualified
          const attempted = !!result?.is_attempted
          const sectionScores = Array.isArray(result?.score_info)
            ? result.score_info
            : []
          const totalSecured =
            result?.ats_details?.total_score_secured ?? result?.total_candidate_score
          const actualTotal =
            result?.ats_details?.actual_total_score ?? result?.total_test_score
          const overallPercentage =
            result?.ats_details?.percentage_score ?? result?.candidate_percentage_score
          const behaviouralPercentage = result?.total_behavioural_score

          return (
            <div
              key={`${result.id || result.attempt_id || index}`}
              className="ts-result-shell"
            >
              <div className="ts-result-header">
                <div className="ts-result-header-main">
                  <div className="ts-result-title">
                    {formatTalentScanValue(result?.test_info?.name)}
                  </div>
                  <div className="ts-result-subtitle">
                    <span>Test {index + 1}</span>
                    <span>{formatTalentScanValue(result?.test_info?.test_designation)}</span>
                  </div>
                </div>

                <div className="ts-result-header-badges">
                  <span
                    className={`ts-result-badge ${attempted ? "success" : "neutral"}`}
                  >
                    {attempted ? "Attempted" : "Not Attempted"}
                  </span>
                  <span
                    className={`ts-result-badge ${qualified ? "success" : "danger"}`}
                  >
                    {qualified ? "Qualified" : "Not Qualified"}
                  </span>
                </div>
              </div>

              <div className="ts-result-content">
                <div className="ts-result-metrics ts-result-metrics-four">
                  <div className="ts-result-metric info">
                    <div className="ts-result-metric-val">
                      {formatTalentScanScore(totalSecured)} / {formatTalentScanScore(actualTotal)}
                    </div>
                    <div className="ts-result-metric-label">Secured / Actual</div>
                  </div>
                  <div className={`ts-result-metric ${getTalentScanScoreTone(overallPercentage)}`}>
                    <div className="ts-result-metric-val">
                      {formatTalentScanPercent(overallPercentage)}
                    </div>
                    <div className="ts-result-metric-label">Overall Percentage</div>
                  </div>
                  <div className={`ts-result-metric ${qualified ? "good" : "low"}`}>
                    <div className="ts-result-metric-val">
                      {qualified ? "Qualified" : "Not Qualified"}
                    </div>
                    <div className="ts-result-metric-label">Qualification</div>
                  </div>
                  <div className={`ts-result-metric ${getTalentScanScoreTone(behaviouralPercentage)}`}>
                    <div className="ts-result-metric-val">
                      {formatTalentScanPercent(behaviouralPercentage)}
                    </div>
                    <div className="ts-result-metric-label">Behavioural</div>
                  </div>
                </div>

                <Row className="g-3">
                  <Col lg={5}>
                    <div className="ts-result-card ts-result-info-table h-100">
                      <div className="ts-result-info-table-heading">Candidate information</div>
                      <div className="ts-result-grid-2">
                        {[
                          { label: "Name", value: result?.candidate_info?.name },
                          { label: "Email", value: result?.candidate_info?.email },
                          { label: "Phone", value: result?.candidate_info?.phone },
                          {
                            label: "Experience",
                            value:
                              result?.candidate_info?.experience !== null &&
                              result?.candidate_info?.experience !== undefined
                                ? `${result.candidate_info.experience} yrs`
                                : "--",
                          },
                          { label: "Candidate ID", value: result?.job_candidate_id },
                        ].map(item => (
                          <div className="ts-result-kv-row" key={item.label}>
                            <span className="ts-result-kv-key">{item.label}</span>
                            <span className="ts-result-kv-val">
                              {formatTalentScanValue(item.value)}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </Col>

                  <Col lg={7}>
                    <div className="ts-result-card ts-result-info-table h-100">
                      <div className="ts-result-info-table-heading">Test timeline</div>
                      <div className="ts-result-grid-2">
                        {[
                          { label: "Sent", value: result?.is_sent ? "Yes" : "No" },
                          { label: "Submitted", value: result?.is_submitted ? "Yes" : "No" },
                          { label: "Attempted", value: formatTalentScanDate(result?.attempted_at) },
                          { label: "Evaluated", value: formatTalentScanDate(result?.evaluated_at) },
                          { label: "Submitted At", value: formatTalentScanDate(result?.submitted_at) },
                          { label: "Link Status", value: result?.link_deactivated ? "Deactivated" : "Active" },
                        ].map(item => (
                          <div className="ts-result-kv-row" key={item.label}>
                            <span className="ts-result-kv-key">{item.label}</span>
                            <span className="ts-result-kv-val">
                              {formatTalentScanValue(item.value)}
                            </span>
                          </div>
                        ))}
                      </div>

                    </div>
                  </Col>
                </Row>

                <div className="ts-result-card">
                  <div className="d-flex align-items-center justify-content-between gap-3 mb-2 flex-wrap">
                    <div>
                      <div className="ts-result-section-label mb-1">Section scores</div>
                      <div style={{ color: "#667085", fontSize: 12 }}>
                        Score split by section and qualification status
                      </div>
                    </div>
                    <span className="ts-result-badge neutral">
                      {sectionScores.length} section{sectionScores.length === 1 ? "" : "s"}
                    </span>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-sm table-bordered align-middle mb-0">
                      <thead className="table-light">
                        <tr>
                          <th className="text-center">Section</th>
                          <th className="text-center">Questions</th>
                          <th className="text-center">Attempted</th>
                          <th className="text-center">Total</th>
                          <th className="text-center">Cutoff</th>
                          <th className="text-center">Secured</th>
                          <th className="text-center">Score %</th>
                          <th className="text-center">Behavioural %</th>
                          <th className="text-center">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sectionScores.length ? (
                          sectionScores.map((section, sectionIndex) => (
                            <tr key={`${section?.section__name || "section"}-${sectionIndex}`}>
                              <td className="text-center fw-semibold">
                                {formatTalentScanValue(section?.section__name)}
                              </td>
                              <td className="text-center">{formatTalentScanValue(section?.no_of_questions)}</td>
                              <td className="text-center">{formatTalentScanValue(section?.no_of_questions_attempted)}</td>
                              <td className="text-center">{formatTalentScanValue(section?.total_score)}</td>
                              <td className="text-center">{formatTalentScanValue(section?.cutoff_score)}</td>
                              <td className="text-center">{formatTalentScanValue(section?.score_secured)}</td>
                              <td className="text-center">
                                <span className={`ts-result-score-pill ${getTalentScanScoreTone(section?.percentage)}`}>
                                  {formatTalentScanPercent(section?.percentage)}
                                </span>
                              </td>
                              <td className="text-center">
                                {formatTalentScanPercent(section?.behavioural_score)}
                              </td>
                              <td className="text-center">
                                <span className={`ts-result-badge ${section?.is_qualified ? "success" : "danger"}`}>
                                  {section?.is_qualified ? "Qualified" : "Not Qualified"}
                                </span>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="9" className="text-center text-muted py-4">
                              No section scores found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    )
  }
// useEffect(() => {
//   getCandidates(companyId, 1, 10, "", "all");
// }, [companyId]);

const sectionLabel = {
  margin: "0 0 8px",
  fontSize: 11,
  fontWeight: 800,
  textTransform: "uppercase",
  letterSpacing: "0.07em",
  color: "#94a3b8",
};

const sectionDivider = {
  border: "1px solid #e6e9f0",
  borderRadius: 12,
  padding: "14px 16px",
  marginBottom: 14,
  background: "#fbfbfe",
};

const SkillPill = ({ label, color }) => {
  const colorMap = {
    blue:  { background: "#eef6ff", border: "1px solid #cfe4ff", color: "#1a5fa8" },
    teal:  { background: "#e6faf6", border: "1px solid #b2ead8", color: "#0d7a5f" },
    gray:  { background: "#f1f5f9", border: "1px solid #e2e8f0", color: "#475569" },
  };
  const styles = colorMap[color] || colorMap.gray;
  return (
    <span style={{ ...styles, borderRadius: 6, fontSize: 12, fontWeight: 600, padding: "4px 9px" }}>
      {label}
    </span>
  );
};

 const getCandidateResumePreviewUrl = url => {
  if (!url) return "";
  const cleanUrl = String(url).split("?")[0].toLowerCase();
  if (cleanUrl.endsWith(".doc") || cleanUrl.endsWith(".docx")) {
    return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`;
  }
  if (cleanUrl.endsWith(".pdf")) {
    return url; 
  }
  return `https://docs.google.com/gview?url=${encodeURIComponent(url)}&embedded=true`;
};
const [jobTitlePage, setJobTitlePage] = useState(1);
const [jobTitleHasMore, setJobTitleHasMore] = useState(true);
const [jobTitleTotalCount, setJobTitleTotalCount] = useState(0);
const totalJobTitlePages = Math.max(1, Math.ceil(jobTitleTotalCount / 10));

const renderCandidateHistoryItems = (items, type) => {
  // console.info("Rendering history items for type:", type, "with items:", items);
  if (!Array.isArray(items) || !items.length) {
    return <span className="text-muted" style={{ fontSize: 13 }}>—</span>;
  }
  return (
    <div className="d-flex flex-column gap-2">
      {items.map((item, i) => (
        <div key={i} className="ats-candidate-history-item" style={{ fontSize: 12, padding: "9px 11px", background: "#fff", borderRadius: 10, border: "1px solid #e6e9f0" }}>
          {type === "education" && (
  <>
    <div className="fw-semibold">
      {item.degree || item.course || item.education_level || "—"}
    </div>

    <div className="text-muted">
      {item.school_name || item.institution || item.university || item.school || "—"}
    </div>

    <div className="text-muted" style={{ fontSize: 11 }}>
      {item.start_year || item.from_year || ""}
      {item.end_year || item.to_year ? ` – ${item.end_year || item.to_year}` : ""}
    </div>
  </>
)}
         {type === "employment" && (
  <>
    <div className="fw-semibold">
      {item.job_title || item.designation || item.position || "—"}
    </div>

    <div className="text-muted">
      {item.company_name || item.company || item.employer || "—"}
    </div>

    <div className="text-muted" style={{ fontSize: 11 }}>
      {item.start_date || item.from_date || ""}
      {item.end_date || item.to_date
        ? ` – ${item.end_date || item.to_date}`
        : item.is_current
        ? " – Present"
        : ""}
    </div>
  </>
)}
          {type === "certificates" && (
            <>
              <div className="fw-semibold">{item.certificate_name || item.name || item.title || "—"}</div>
              <div className="text-muted">{item.issuing_organization || item.issued_by || item.organization || "—"}</div>
              <div className="text-muted" style={{ fontSize: 11 }}>{item.issue_date || item.date || ""}</div>
            </>
          )}
        </div>
      ))}
    </div>
  );
};
const selectedPrimarySkills = toSkillList(selectedCandidate?.primary_skill_names);
const selectedSecondarySkills = toSkillList(selectedCandidate?.secondary_skill_names);
const selectedOtherSkills = toSkillList(selectedCandidate?.other_skill_names);
const selectedEducationHistory = Array.isArray(selectedCandidate?.education)
  ? selectedCandidate.education
  : [];

const selectedEmploymentHistory = Array.isArray(selectedCandidate?.employment)
  ? selectedCandidate.employment
  : [];

const selectedCertificateHistory = Array.isArray(selectedCandidate?.certificates)
  ? selectedCandidate.certificates
  : [];
  return (
    <React.Fragment>
      <div className="page-content allact-tabs manager-dash agent-page candidate-outcome-page">
        <Container fluid>
          <div className="page-title-box mb-0 recruiter-dashboard actjobsum">
            <div className="agent-list-hero candidate-outcome-hero candidate-outcome-hero-selected candidate-all-hero">
              <div className="agent-list-title">
                <div className="agent-list-hero-icon">
                  <FaBusinessTime size={21} />
                </div>
                <div>
                  <h1>All Candidates</h1>
                  <p>Search, filter, and manage candidate profiles across every job order.</p>
                </div>
              </div>
              <div className="candidate-all-hero-actions">
                <div className="candidate-all-field candidate-all-company">
                  <Label className="d-block">Select Company</Label>
                  <CompanySelector
                    onCompanyChange={handleCompanyChange}
                    showAllOption={true}
                  />
                </div>

                <div className="candidate-all-field candidate-all-search">
                  <Label className="d-block">Search Candidate</Label>
                  <div>
                    <InputGroup>
                      <Input
                        placeholder="Search Name, Email or Phone..."
                        value={searchQuery}
                        onChange={handleSearchChange}
                        onKeyDown={e => {
                          if (e.key === "Enter")
                            getCandidates(companyId, 1, 10, searchQuery, filterStatus, filterJobTitle, filterRecruiter, filterStartDate, filterEndDate, filterPipelineStage)
                        }}
                      />
                      {searchQuery !== "" && (
                        <InputGroupText
                          style={{
                            cursor: "pointer",
                            background: "transparent",
                            borderLeft: "none",
                          }}
                          onClick={() => {
                            setSearchQuery("")
                            getCandidates(companyId, 1, 10, "", filterStatus, filterJobTitle, filterRecruiter, filterStartDate, filterEndDate, filterPipelineStage)
                          }}
                        >
                          <FaTimes
                            style={{ fontSize: "14px", color: "#6c757d" }}
                          />
                        </InputGroupText>
                      )}

                      <Button
                        className="btn searchIconBtn"
                        onClick={() =>
                          getCandidates(companyId, 1, 10, searchQuery, filterStatus, filterJobTitle, filterRecruiter, filterStartDate, filterEndDate, filterPipelineStage)
                        }
                      >
                        <i className="fa fa-search" />
                      </Button>
                    </InputGroup>
                  </div>
                </div>

                <div className="agent-list-count-card candidate-all-count-card">
                  <span>Total Candidates</span>
                  <strong>{totalRecords || 0}</strong>
                </div>
              </div>
            </div>
              {/* <Col xxl={9}>
                <div className="d-flex justify-content-end align-items-center">
                  <div className="me-2" style={{ width: "250px" }}>
                    <InputGroup>
                      <Input
                        placeholder="Search Name, Email or Phone..."
                        value={searchQuery}
                        onChange={handleSearchChange}
                        onKeyDown={e => {
                          if (e.key === "Enter")
                            getCandidates(companyId, 1, 10, searchQuery)
                        }}
                      />
                      {searchQuery !== "" && (
                        <InputGroupText
                          style={{
                            cursor: "pointer",
                            background: "transparent",
                            borderLeft: "none",
                          }}
                          onClick={() => {
                            setSearchQuery("")
                            getCandidates(companyId, 1, 10, "")
                          }}
                        >
                          <FaTimes
                            style={{ fontSize: "14px", color: "#6c757d" }}
                          />
                        </InputGroupText>
                      )}

                      <Button
                        className="btn searchIconBtn"
                        onClick={() =>
                          getCandidates(companyId, 1, 10, searchQuery)
                        }
                      >
                        <i className="fa fa-search" />
                      </Button>
                    </InputGroup>
                  </div>
                </div>
              </Col> */}

            <Card
              className="mb-3 shadow-md border-0"
              id="CandidateList_CardView"
            >
              {/* <Row className="align-items-center mb-3">
                <Col xxl={2} xl={4} lg={4} md={4} sm={12}>
                  <h5 className="fw-semibold mb-0">Candidate List</h5>
                </Col>
                 <Col xxl={2} xl={3} lg={3} md={6} sm={6} className="mb-2">
                      <div className="formField">
                        <label className="form-label mb-1">Recruiter</label>
                        <select
                          className="form-select form-select-sm"
                          value={filterRecruiter}
                          disabled={recruitersLoading}
                          onChange={(e) => {
                            const recruiterId = e.target.value;
                            setFilterRecruiter(recruiterId);
                            getCandidates(companyId, 1, lazyParams.rows, searchQuery, filterStatus, filterJobTitle, recruiterId);
                          }}
                        >
                          <option value="">
                            {recruitersLoading ? "Loading..." : "All Recruiters"}
                          </option>
                          {recruiterList.map((recruiter) => (
                            <option key={recruiter.id} value={recruiter.id}>
                              {recruiter.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Col>
                 <Col xxl={2} xl={3} lg={3} md={6} sm={6} className="mb-2">
                      <div className="formField">
                        <label className="form-label mb-1">Job Title</label>
                        <select
                          className="form-select form-select-sm"
                          value={filterJobTitle}
                          onChange={(e) => {
                            const jobId = e.target.value;
                            setFilterJobTitle(jobId);
                            getCandidates(companyId, 1, lazyParams.rows, searchQuery, filterStatus, jobId, filterRecruiter);
                          }}
                        >
                          <option value="">All Jobs</option>
                          {jobTitleList.map((job) => (
                            <option key={job.id} value={job.id}>
                              {job.title}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Col>
                <Col xxl={2} xl={4} lg={4} md={4} sm={6}>
                  <div className='formField'>
                      <label className="me-2 mt-1">
                        Status
                      </label>
                     <select
                        // style={{ width: "180px" }}
                        className="form-select"
                        id="dStatusLeaveLogFilter"
                        aria-label="dStatusLeaveLogFilter"
                        name="dStatusLeaveLogFilter"
                        value={filterStatus}
                        onChange={(e) => {
                          const selectedFilter = e.target.value;
                          setFilterStatus(selectedFilter);
                          getCandidates(companyId, 1, 10, searchQuery, selectedFilter,filterJobTitle, filterRecruiter);
                        }}
                      >
                        <option value="" disabled>
                          Select Status
                        </option>
                        <option value="all">All</option>
                        <option value="approved">Approved</option>
                        <option value="pending">Pending</option>
                        <option value="rejected">Rejected</option>
                      </select>
                  </div>
                </Col>
         
                <Col xxl={4} xl={12} lg={12} md={12} sm={12}>
                    <label className="mt-1 invisible">Job Title</label>
                    <div className="d-flex justify-content-start flex-wrap">
                      
                  <Button className="btn btn-primary my-2  me-2 my-2" 
                    title="Reset Filters" 
                        onClick={() => {
                            setSearchQuery("");
                            setFilterJobTitle("");
                            setFilterStatus("all");
                            setFilterRecruiter(""); 
                            getCandidates(companyId, 1, 10, "", "all","", "");
                          }}>
                    <i
                      className="fa fa-refresh me-2"
                    />
                    Reset
                    </Button>
                    <Button
                      label="Schedule"
                    onClick={openScheduleInterview}
                    className="btn btn-primary me-2 my-2"
                    style={{
                      background: "linear-gradient(90deg, #0e527d, #1a87cb)",
                      border: "none",
                    }}
                  >
                    Schedule Interview
                  </Button>
                  <div className=" my-2">
                    <input
                      type="file"
                      id="resume-import-upload"
                      style={{ display: "none" }}
                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                      multiple
                      onChange={handleImportResumeChange}
                    />

                    <button
                      type="button"
                      onClick={() => {
                        if (!isImportingResume) {
                          setResumeUploadMode(null)
                          setSelectedResumeJob(null)
                          setPendingResumeFiles([])
                          setShowResumeUploadChoiceModal(true)
                        }
                      }}
                      className="btn btn-primary me-2 import-res-btn"
                      style={{
                        background: "linear-gradient(90deg, #0e527d, #1a87cb)",
                        border: "none",
                      }}
                      disabled={isImportingResume}
                    >
                      {isImportingResume ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Importing...
                        </>
                      ) : (
                        <>
                          Upload Resume's{" "}
                          <i
                            className="ms-2 pi pi-info-circle"
                            style={{ fontSize: "0.8rem" }}
                          ></i>
                        </>
                      )}
                    </button>
                  </div>
                  <Button
                      label="Add Candidate"
                      // onClick={() => setCandidateSidebarVisible(true)}
                      onClick={() => navigate("/add-candidate")}
                      className="btn btn-primary me-2 my-2"
                      style={{
                        background: "linear-gradient(90deg, #0e527d, #1a87cb)",
                        border: "none",
                      }}
                    >
                      Add Candidate
                    </Button>

                    <Button
                      onClick={() => navigate("/importfromcsv-candidates")}
                      className="btn btn-primary my-2 me-2"
                      style={{
                        background: "linear-gradient(90deg, #0e527d, #1a87cb)",
                        border: "none",
                      }}
                    >
                      Import Candidate
                    </Button>
                    {/* <Button className="btn btn-primary my-2" 
                    title="Refresh" 
                        onClick={() => {
                            setSearchQuery("");
                            setFilterJobTitle("");
                            setFilterStatus("all");
                            getCandidates(companyId, 1, 10, "", "all");
                          }}>
                    <i
                      className="fa fa-refresh me-2"
                    />
                    Reset
                    </Button> */}
                    
                  {/* Chandu */}
                {/* </div>
                </Col>
              </Row> */} 
                {/* ── Single toolbar row ── */}
                <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  flexWrap: "nowrap",
                  gap: 7,
                  padding: "10px 14px",
                  borderBottom: "1px solid #e2e8f0",
                  overflowX: "auto",
                }}
                >
                  {/* Title */}
                  <h5
                    className="fw-semibold mb-0"
                    style={{ whiteSpace: "nowrap", fontSize: 16, marginRight: 4 }}
                  >
                    Candidate List
                  </h5>

                  <div style={{ width: 1, height: 24, background: "#e2e8f0", flexShrink: 0 }} />

                  {/* Recruiter */}
                  <Calendar
                        dateFormat="dd-mm-yy"
                        placeholder="DD-MM-YYYY"
                        inputClassName="form-control form-control-sm"
                        style={{ width: 140, fontSize: 12 }}
                        value={filterStartDate ? new Date(`${filterStartDate}T00:00:00`) : null}
                        maxDate={filterEndDate ? new Date(`${filterEndDate}T00:00:00`) : new Date()}
                        onChange={(e) => {
                          const date = e.value;
                          const startDate = date ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}` : "";
                          setFilterStartDate(startDate);

                          // if end date is already set and is less than new start date, clear end date
                          if (filterEndDate && filterEndDate < startDate) {
                            setFilterEndDate("");
                          }

                          getCandidates(
                            companyId, 1, lazyParams.rows,
                            searchQuery, filterStatus, filterJobTitle,
                            filterRecruiter, startDate, filterEndDate && filterEndDate >= startDate ? filterEndDate : "",
                            filterPipelineStage
                          );
                        }}
                      />

                      {/* End Date */}
                      <Calendar
                        dateFormat="dd-mm-yy"
                        placeholder="DD-MM-YYYY"
                        inputClassName="form-control form-control-sm"
                        style={{ width: 140, fontSize: 12 }}
                        value={filterEndDate ? new Date(`${filterEndDate}T00:00:00`) : null}
                        minDate={filterStartDate ? new Date(`${filterStartDate}T00:00:00`) : undefined}
                        maxDate={new Date()}
                        disabled={!filterStartDate}
                        title={!filterStartDate ? "Please select a start date first" : ""}
                        onChange={(e) => {
                          const date = e.value;
                          const endDate = date ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}` : "";

                          if (filterStartDate && endDate < filterStartDate) {
                            Swal.fire({
                              icon: "warning",
                              title: "Invalid Date Range",
                              text: "End date must be greater than or equal to start date.",
                              confirmButtonColor: "#1a5fa8",
                            });
                            return;
                          }

                          setFilterEndDate(endDate);
                          getCandidates(
                            companyId, 1, lazyParams.rows,
                            searchQuery, filterStatus, filterJobTitle,
                            filterRecruiter, filterStartDate, endDate,filterPipelineStage
                          );
                        }}
                      />
                  

                  {/* Job Title */}
                 {/* <div className="d-flex align-items-center gap-1">
                    <select
                      className="form-select form-select-sm"
                      style={{ width: 150, fontSize: 13 }}
                      value={filterJobTitle}
                      disabled={jobTitlesLoading}
                      onChange={(e) => {
                        const jobId = e.target.value;
                        setFilterJobTitle(jobId);
                        getCandidates(
                          companyId, 1, lazyParams.rows,
                          searchQuery, filterStatus, jobId,
                          filterRecruiter, filterStartDate, filterEndDate
                        );
                      }}
                    >
                      <option value="">All Jobs</option>
                      {jobTitleList.map((job) => (
                        <option key={job.id} value={job.id}>{job.title}</option>
                      ))}
                    </select>

                      <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Search job..."
                        style={{ width: 110, fontSize: 12 }}
                        value={jobTitleSearch}
                        onChange={(e) => setJobTitleSearch(e.target.value)}
                      />

                      <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary"
                        disabled={jobTitlesLoading || jobTitlePage <= 1}
                        onClick={handleJobTitlePrev}
                        title="Previous"
                      >
                        ‹
                      </button>
                      <span style={{ fontSize: 11, whiteSpace: "nowrap" }}>
                        {jobTitlePage}/{totalJobTitlePages}
                      </span>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary"
                        disabled={jobTitlesLoading || jobTitlePage >= totalJobTitlePages}
                        onClick={handleJobTitleNext}
                        title="Next"
                      >
                        ›
                      </button>
                  </div> */}
                  <Dropdown
                    value={filterJobTitle}
                    options={jobTitleList}
                    optionLabel="title"
                    optionValue="id"
                    showClear
                    placeholder="All Jobs"
                    style={{ width: 160, fontSize: 13 }}
                    className="job-title-filter-dropdown"
                    loading={jobTitlesLoading}
                    emptyMessage={jobTitlesLoading ? "Loading job orders..." : "No jobs found"}
                    filter
                    filterBy="title"
                    filterInputAutoFocus={false}
                    filterPlaceholder="Search job..."
                    onChange={(e) => {
                      const jobId = e.value;
                      setFilterJobTitle(jobId);
                      getCandidates(
                        companyId,
                        1,
                        lazyParams.rows,
                        searchQuery,
                        filterStatus,
                        jobId,
                        filterRecruiter,
                        filterStartDate,
                        filterEndDate,filterPipelineStage
                      );
                    }}
                    filterTemplate={() => (
                      <div
                        className="d-flex align-items-center gap-1 px-2 py-2"
                        style={{ borderBottom: "1px solid #e2e8f0" }}
                        onMouseDown={(e) => e.stopPropagation()}
                      >
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Search job & press Enter..."
                          value={jobTitleSearch}
                          onChange={(e) => {
                            const value = e.target.value;
                            setJobTitleSearch(value);
                            if (!value.trim()) {
                              getJobTitles(companyId, 1, "");
                            }
                          }}
                          onKeyDown={(e) => {
                            e.stopPropagation(); 
                            if (e.key === "Enter") {
                              e.preventDefault();
                              getJobTitles(companyId, 1, jobTitleSearch);
                            }
                          }}
                          style={{ flex: 1 }}
                        />
                        {jobTitlesLoading && (
                          <ProgressSpinner
                            style={{ width: 18, height: 18 }}
                            strokeWidth="6"
                            animationDuration=".8s"
                          />
                        )}
                        {jobTitleSearch && (
                          <button
                            type="button"
                            className="btn btn-sm btn-link p-0 text-secondary"
                            title="Clear search"
                            disabled={jobTitlesLoading}
                            onMouseDown={(e) => {
                              e.preventDefault();   
                              e.stopPropagation();
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation(); 
                              setJobTitleSearch("");
                              getJobTitles(companyId, 1, "");
                            }}
                          >
                            <FaTimes size={12} />
                          </button>
                        )}
                      </div>
                    )}
                    panelFooterTemplate={
                      <div
                        className="d-flex align-items-center justify-content-between px-2 py-2"
                        style={{ borderTop: "1px solid #e2e8f0" }}
                        onMouseDown={(e) => e.stopPropagation()}
                      >
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                          disabled={jobTitlesLoading || jobTitlePage <= 1}
                          onClick={() => getJobTitles(companyId, jobTitlePage - 1, jobTitleSearch)}
                        >
                          ‹ Prev
                        </button>
                        <span style={{ fontSize: 11 }}>
                          {jobTitlesLoading ? "Loading..." : `Page ${jobTitlePage} / ${Math.max(1, Math.ceil(jobTitleTotalCount / 10))}`}
                        </span>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                          disabled={
                            jobTitlesLoading ||
                            jobTitlePage >= Math.max(1, Math.ceil(jobTitleTotalCount / 10))
                          }
                          onClick={() => getJobTitles(companyId, jobTitlePage + 1, jobTitleSearch)}
                        >
                          Next ›
                        </button>
                      </div>
                    }
                  />
                  <select
                    className="form-select form-select-sm"
                    style={{ width: 140, fontSize: 16 }}
                    value={filterPipelineStage}
                    onChange={(e) => {
                      const stage = e.target.value;
                      setFilterPipelineStage(stage);
                      getCandidates(
                        companyId,
                        1,
                        lazyParams.rows,
                        searchQuery,
                        filterStatus,
                        filterJobTitle,
                        filterRecruiter,
                        filterStartDate,
                        filterEndDate,
                        stage
                      );
                    }}
                  >
                    <option value="">All Stages</option>
                    {stagesList.map((stage) => (
                      <option key={stage.id} value={stage.name}>
                        {stage.name}
                      </option>
                    ))}
                  </select>
                  <select
                    className="form-select form-select-sm"
                    style={{ width: 140, fontSize: 16 }}
                    value={filterRecruiter}
                    disabled={recruitersLoading}
                    onChange={(e) => {
                      const recruiterId = e.target.value;
                      setFilterRecruiter(recruiterId);
                      getCandidates(companyId, 1, lazyParams.rows, searchQuery, filterStatus, filterJobTitle, recruiterId, filterStartDate, filterEndDate, filterPipelineStage);
                    }}
                  >
                    <option value="">{recruitersLoading ? "Loading..." : "All Recruiters"}</option>
                    {recruiterList.map((r) => (
                      <option key={r.id} value={r.id}>{r.label}</option>
                    ))}
                  </select>
                  {/* Status */}
                  <select
                    className="form-select form-select-sm"
                    style={{ width: 130, fontSize: 16 }}
                    value={filterStatus}
                    onChange={(e) => {
                      const val = e.target.value;
                      setFilterStatus(val);
                      getCandidates(companyId, 1, lazyParams.rows, searchQuery, val, filterJobTitle, filterRecruiter, filterStartDate, filterEndDate, filterPipelineStage);
                    }}
                  >
                    <option value="all">All Status</option>
                    <option value="approved">Approved</option>
                    <option value="pending">Pending</option>
                    <option value="rejected">Rejected</option>
                  </select>

                  <div style={{ width: 1, height: 24, background: "#e2e8f0", flexShrink: 0 }} />

                  {/* Reset */}
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                    style={{ fontSize: 12, whiteSpace: "nowrap", padding: "4px 9px", flexShrink: 0 }}
                    title="Reset Filters"
                    onClick={() => {
                      setSearchQuery("");
                      setFilterJobTitle("");
                      setFilterStatus("all");
                      setFilterRecruiter("");
                      setFilterStartDate("");
                      setFilterEndDate("");
                      setFilterPipelineStage("");        
                      setJobTitleSearch("");   
                      setLazyParams({ first: 0, rows: 10, page: 1 });
                      setJobTitlePage(1);
                      setJobTitleHasMore(true);
                      getCandidates(companyId, 1, 10, "", "all", "", "", "","", "");
                      getJobTitles(companyId, 1, "");
                    }}
                  >
                    <i className="fa fa-refresh me-1" />
                    Reset
                  </button>

                  {/* Schedule Interview */}
                  <button
                    type="button"
                    className="btn btn-sm btn-primary"
                    style={{
                      fontSize: 12,
                      whiteSpace: "nowrap",
                      padding: "4px 9px",
                      background: "linear-gradient(90deg, #0e527d, #1a87cb)",
                      border: "none",
                      flexShrink: 0,
                    }}
                    onClick={openScheduleInterview}
                  >
                    Schedule Interview
                  </button>

                  {/* Upload Resumes */}
                  <Tooltip
                    target=".import-res-btn"
                    content="You can upload one or multiple resumes at once"
                    position="top"
                  />
                  <input
                    type="file"
                    id="resume-import-upload"
                    style={{ display: "none" }}
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    multiple
                    onChange={handleImportResumeChange}
                  />
                  <button
                    type="button"
                    className="btn btn-sm btn-primary import-res-btn"
                    style={{
                      fontSize: 12,
                      whiteSpace: "nowrap",
                      padding: "4px 9px",
                      background: "linear-gradient(90deg, #0e527d, #1a87cb)",
                      border: "none",
                      flexShrink: 0,
                    }}
                    disabled={isImportingResume}
                    onClick={() => {
                      if (!isImportingResume) {
                        setResumeUploadMode(null)
                        setSelectedResumeJob(null)
                        setPendingResumeFiles([])
                        setShowResumeUploadChoiceModal(true)
                      }
                    }}
                  >
                    {isImportingResume ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-1"
                          role="status"
                          aria-hidden="true"
                        />
                        Importing...
                      </>
                    ) : (
                      <>
                        Upload Resumes
                        <i className="ms-1 pi pi-info-circle" style={{ fontSize: "0.75rem" }} />
                      </>
                    )}
                  </button>

                  {/* Add Candidate */}
                  <button
                    type="button"
                    className="btn btn-sm btn-primary"
                    style={{
                      fontSize: 12,
                      whiteSpace: "nowrap",
                      padding: "4px 9px",
                      background: "linear-gradient(90deg, #0e527d, #1a87cb)",
                      border: "none",
                      flexShrink: 0,
                    }}
                    onClick={() => navigate("/add-candidate")}
                  >
                    Add Candidate
                  </button>

                  {/* Import Candidate */}
                  <button
                    type="button"
                    className="btn btn-sm btn-primary"
                    style={{
                      fontSize: 12,
                      whiteSpace: "nowrap",
                      padding: "4px 9px",
                      background: "linear-gradient(90deg, #0e527d, #1a87cb)",
                      border: "none",
                      flexShrink: 0,
                    }}
                    onClick={() => navigate("/importfromcsv-candidates")}
                  >
                    Import Candidate
                  </button>
                  {/* <button
                    type="button"
                    className="btn btn-sm btn-success"
                    style={{
                      fontSize: 12,
                      whiteSpace: "nowrap",
                      padding: "4px 9px",
                      background: "linear-gradient(90deg, #198754, #20c997)",
                      border: "none",
                      flexShrink: 0,
                    }}
                    onClick={handleDownloadExcel}
                  >
                    {excelDownloading ? "Downloading..." : "Download Excel"}
                  </button> */}
                </div>

              <Row>
                <Col xxl={12}>
                  {isCandidatesLoading ? (
                    <OrgTableShimmer columns={6} rows={7} titleWidth="220px" />
                  ) : (
                    <DataTable
                      className="CandidateListTableView"
                      value={CandidateListData}
                      totalRecords={totalRecords}
                      dataKey="candidate_id"
                      rowExpansionMode="single"
                      tableStyle={{ width: "100%", tableLayout: "fixed" }}
                      selectionMode="checkbox"
                      selection={selectedCandidates}
                      onSelectionChange={e => setselectedCandidates(e.value)}
                      rowClassName={rowData => {
                        const sourceValues = [
                          rowData?.applied_from,
                          rowData?.added_from,
                          rowData?.source,
                          rowData?.resume_source_name,
                          rowData?.source_name,
                          rowData?.created_by_name,
                        ]
                          .filter(Boolean)
                          .map(value => String(value).trim().toLowerCase().replace(/[_-]+/g, " "))

                        return sourceValues.some(value =>
                          value === "website" ||
                          value === "website applicant" ||
                          value.includes("website applicant")
                        )
                          ? "website-applicant-row"
                          : ""
                      }}
                      expandedRows={expandedJobRows}
                      onRowToggle={onRowToggle}
                      onPage={handlePageChange}
                      sortField={sortState.field}
                      sortOrder={sortState.order}
                      onSort={event => {
                        setSortState({ field: event.sortField, order: event.sortOrder });
                        setCandidateListData(rows => sortCandidateRows(rows, event.sortField, event.sortOrder));
                      }}
                      first={lazyParams.first}
                      rows={lazyParams.rows}
                      lazy
                      paginator
                      //  rows={pageSize}
                      rowsPerPageOptions={[10, 20, 30, 50, totalRecords]}
                      emptyMessage={
                        <div className="candidate-empty-state">
                          <i className="pi pi-users" aria-hidden="true" />
                          <strong>No candidates available</strong>
                          <span>Try changing the filters or upload a resume.</span>
                        </div>
                      }
                      rowExpansionTemplate={candidateExpansionTemplate}
                      id="AllCandidates_TableView"
                    >
                      {/* <Column expander style={{ width: "3rem" }} /> */}
                      {/* <Column
                        field="first_name"
                        header="Name"
                        body={rowData => rowData.first_name || "–"}
                      /> */}
                      {/* <Column
                        header="Name"
                        body={rowData => {
                          const fullName = [
                            rowData.first_name,
                            rowData.middle_name,
                            rowData.last_name
                          ]
                            .filter(Boolean)
                            .join(" ");

                          return (
                            <span
                              title={fullName || "–"}     
                              style={{
                                display: "inline-block",
                                maxWidth: "180px",        
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                cursor: "pointer"
                              }}
                            >
                              {fullName || "–"}
                            </span>
                          );
                        }}
                      /> */}
                      <Column
                        header=""
                        body={rowData => (
                          <RadioButton
                            inputId={`candidate-radio-${rowData.candidate_id}`}
                            name="selectedInterviewCandidate"
                            checked={
                              selectedInterviewCandidate?.candidate_id ===
                              rowData.candidate_id
                            }
                            onChange={() => bindCandidateForInterview(rowData)}
                          />
                        )}
                        style={{ width: "44px" }}
                        bodyStyle={{ width: "44px", minWidth: "44px", maxWidth: "44px" }}
                      />
                     
                      <Column
                      header="Candidate Name"
                      sortable
                      sortField="first_name"
                      style={{ width: "215px" }}
                      bodyStyle={{ width: "215px", minWidth: "215px" }}
                      body={(rowData) => {
                        const fullName =
                          [rowData.first_name, rowData.middle_name, rowData.last_name]
                            .filter(Boolean)
                            .join(" ");

                        return (
                           <div className="JobName_AllCandidates candidate-name-with-initials">
                            <span
                              className="candidate-name-initials"
                              style={getInitialsStyle(fullName)}
                            >
                              {getNameInitials(fullName)}
                            </span>
                            <span
                                title={fullName || "–"}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  ViewCandidateInfoCall(rowData);
                                }}
                                style={{
                                  color: "#334155",
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                  fontWeight: 600,
                                }}
                              >
                                {fullName || "–"}
                              </span>
                          </div>
                        );
                      }}
                    />
                      <Column
                        field="email"
                        header="Email"
                        sortable
                        style={{ width: "185px" }}
                        bodyStyle={{ width: "185px", minWidth: "185px" }}
                        body={rowData => (
                          <div className="JobEmail_AllCandidates">
                            <span title={rowData.email || "–"}>
                              {rowData.email || "-"}
                            </span>
                          </div>
                        )}
                      />
                      <Column
                        field="mobile_phone"
                        header="Phone"
                        sortable
                        style={{ width: "145px" }}
                        bodyStyle={{ width: "145px", minWidth: "145px" }}
                        body={rowData => (
                          <div className="JobPhone_AllCandidates">
                            <span title={rowData.mobile_phone || "–"}>
                              {rowData.mobile_phone || "–"}
                            </span>
                          </div>
                        )}
                      />
                 <Column
                        field="Source"
                        header="Source"
                        sortable
                        sortField="resume_source_name"
                        style={{ width: "150px", minWidth: "150px" }}
                        bodyStyle={{ width: "150px", minWidth: "150px" }}
                        body={rowData => (
                          <div
                            className="JobSource_AllCandidates"
                            style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                          >
                            <span
                              className="rounded py-1 px-2 fw-semibold"
                              title={rowData.resume_source_name || "Others"}
                            >
                              {rowData.resume_source_name || "Others"}
                            </span>
                          </div>
                        )}
                      />
                      <Column
                        width="150px"
                        field="job_titles"
                        header="Job Title"
                        sortable
                        style={{ width: "230px" }}
                        bodyStyle={{ width: "230px", minWidth: "230px" }}
                        body={rowData => (
                          <div className="JobTitle_AllCandidates">
                            <span title={rowData.job_titles || "–"}>
                              {rowData.job_titles || "–"}
                            </span>
                          </div>
                        )}
                      />
                      <Column
                        field="total_experience"
                        header="Experience"
                        sortable
                        body={viewCandidateExperience}
                      />
                      <Column
                        header="Created By"
                        sortable
                        sortField="created_by_name"
                        style={{ width: "190px" }}
                        bodyStyle={{ width: "190px", minWidth: "190px" }}
                        body={rowData => {
                          if (rowData.created_by_name && rowData.created_at) {
                            const createdByName = formatDisplayName(rowData.created_by_name)
                            const date = new Date(rowData.created_at)
                            const day = String(date.getDate()).padStart(2, "0")
                            const month = String(date.getMonth() + 1).padStart(2, "0")
                            const year = date.getFullYear()
                            let hours = date.getHours()
                            const minutes = String(date.getMinutes()).padStart(2, "0")
                            const seconds = String(date.getSeconds()).padStart(2, "0")
                            const ampm = hours >= 12 ? "PM" : "AM"
                            hours = hours % 12 || 12 
                            const formattedTime = `${String(hours).padStart(2, "0")}:${minutes}:${seconds} ${ampm}`
                            return (
                              <div className="JobCreateBy_AllCandidates">
                                <div title={rowData.created_by_name}>
                                  {createdByName}
                                </div>
                                <div style={{ fontSize: "11px", fontWeight: "500" }} title={date.toLocaleString()}>
                                  {`${day}-${month}-${year} ${formattedTime}`}
                                </div>
                              </div>
                            )
                          }
                          return "–"
                        }}
                        />
                      {/* <Column header="Candidate Details" body={viewCandidateDetails} /> */}
                      {/* <Column field="CandidatePipline Status" header="Candidate Pipeline Status" body={(rowData) => rowData.candidate_pipeline_status || "-"} /> */}
                      <Column
                          header="Candidate Pipeline Stage"
                          sortable
                          sortField="candidate_pipeline_status"
                          body={rowData => {
                            const status = rowData.candidate_pipeline_status?.trim();
                            const jobTitle = rowData.job_titles?.trim();
                            const hasJob = jobTitle && jobTitle !== "-" && jobTitle !== "–";
                            const displayStatus = hasJob && status ? status : "-";
                            const showIcon = hasJob && status && status !== "Received";
                            return(
                            <div className={`candidate-pipeline-stage-cell ${showIcon ? "" : "no-history"}`}>
                              
                              {/* Status */}
                              <span
                                className="candidate-pipeline-stage-text"
                                title={displayStatus}
                                onClick={e => {
                                  if (!showIcon) return;
                                  e.stopPropagation();
                                  handleViewPipelineHistory(rowData);
                                }}
                                style={{ cursor: showIcon ? "pointer" : "default" }}
                              >
                                {displayStatus}
                              </span>
                              {showIcon && (
                                  <Button
                                    className="candidate-pipeline-history-btn"
                                    title="View pipeline history"
                                    onClick={e => {
                                      e.stopPropagation();
                                      handleViewPipelineHistory(rowData);
                                    }}
                                  >
                                    <FaHistory />
                                  </Button>
                              )}
                            </div>
                          )}}
                        />
                      {/* <Column
                        field="HRMS Status"
                        header="HRMS Status"
                        body={rowData => rowData.candidate_hrms_status || "-"}
                      /> */}
                      {/* <Column field="Reffered Hrms ID" header="Reffered Hrms ID" body={"-"} /> */}
                      {/* <Column field="Referred Hrms Email" header="Referred Hrms Email" body={"-"} /> */}
                      {/* <Column field="is_selected" header="Is Selected" body={viewIsSelectedStatus} /> */}
                      {/* <Column
                        field="Actions"
                        header="Actions"
                        body={rowData => (
                          <div className="d-flex gap-2">
                            <Button
                              className="btn btn-light p-1"
                              onClick={e => handleClick(e, rowData)}
                              title="Edit Candidate"
                              disabled={loadingStates[rowData.candidate_id]}
                            >
                              {loadingStates[rowData.candidate_id] ? (
                                <i className="fa-solid fa-spinner fa-spin"></i>
                              ) : (
                                <i className="fa-regular fa-pen-to-square"></i>
                              )}
                            </Button>

                            <Button
                              className="btn btn-light p-1"
                              title="View Candidate"
                              onClick={e => {
                                e.stopPropagation()
                                ViewCandidateInfoCall(rowData)
                              }}
                            >
                              <FaRegEye />
                            </Button>

                            <RSButton
                              color="light"
                              size="sm"
                              className="p-1"
                              title="Candidate Action Logs"
                              onClick={() =>
                                handleViewActionLogs(rowData.candidate_id)
                              }
                            >
                              <FaBusinessTime />
                            </RSButton>

                            {rowData.linked_jobs &&
                              rowData.linked_jobs.length > 0 &&
                              rowData.linked_jobs.map((job, index) => (
                                <div key={index} className="d-flex gap-1">
                                  {job.send_for_approval &&
                                    !job.is_approved &&
                                    !job.is_rejected && (
                                      <Button
                                        className="btn btn-sm btn-light p-1 text-success"
                                        title={`Approve for ${job.job_name}`}
                                        onClick={e => {
                                          e.stopPropagation()
                                          setSelectedJobCandidateForApproveReject(
                                            {
                                              ...job,
                                              job_id: job.job,
                                              candidate_id:
                                                rowData.candidate_id,
                                              job_name: job.job_name,
                                            }
                                          )
                                          setActionType("approve")
                                          setShowApproveRejectModal(true)
                                        }}
                                      >
                                        Approve
                                      </Button>
                                    )}

                                  {job.send_for_approval &&
                                    !job.is_approved &&
                                    !job.is_rejected && (
                                      <Button
                                        className="btn btn-sm btn-light p-1 text-danger"
                                        title={`Reject for ${job.job_name}`}
                                        onClick={e => {
                                          e.stopPropagation()
                                          setSelectedJobCandidateForApproveReject(
                                            {
                                              ...job,
                                              job_id: job.job,
                                              candidate_id:
                                                rowData.candidate_id,
                                              job_name: job.job_name,
                                            }
                                          )
                                          setActionType("reject")
                                          setShowApproveRejectModal(true)
                                        }}
                                      >
                                        Reject
                                      </Button>
                                    )}

                                  {(job.is_approved || job.is_rejected) && (
                                    <Button
                                      className="btn btn-sm btn-light p-1 text-info"
                                      title={`View details for ${job.job_name}`}
                                      onClick={e => {
                                        e.stopPropagation()
                                        setSelectedJobCandidateForDetails({
                                          job_name: job.job_name,
                                          is_approved: job.is_approved,
                                          is_rejected: job.is_rejected,
                                          is_approved_reason:
                                            job.is_approved_reason,
                                          is_rejected_reason:
                                            job.is_rejected_reason,
                                        })
                                        setShowDetailsModal(true)
                                      }}
                                    >
                                      View Details
                                    </Button>
                                  )}
                                </div>
                              ))}
                          </div>
                        )}
                      /> */}
                      {/* <Column
  field="Actions"
  header="Actions"
  body={rowData => {
    // Check if any job requires approval (not yet approved/rejected)
    const hasPendingApproval = rowData.linked_jobs?.some(
      job => job.send_for_approval && !job.is_approved && !job.is_rejected
    );

    // Check if any job is approved or rejected
    const hasApprovalHistory = rowData.linked_jobs?.some(
      job => job.is_approved || job.is_rejected
    );

    return (
      <div className="">
        <div className="d-flex gap-2 justify-content-center mb-2">
          <Button
            className="btn btn-light p-1"
            onClick={e => handleClick(e, rowData)}
            title="Edit Candidate"
            disabled={loadingStates[rowData.candidate_id]}
          >
            {loadingStates[rowData.candidate_id] ? (
              <i className="fa-solid fa-spinner fa-spin"></i>
            ) : (
              <i className="fa-regular fa-pen-to-square"></i>
            )}
          </Button>

          <Button
            className="btn btn-light p-1"
            title="View Candidate"
            onClick={e => {
              e.stopPropagation();
              ViewCandidateInfoCall(rowData);
            }}
          >
            <FaRegEye />
          </Button>

          <RSButton
            color="light"
            size="sm"
            className="p-1"
            title="Candidate Action Logs"
            onClick={() => handleViewActionLogs(rowData.candidate_id)}
          >
            <FaBusinessTime />
          </RSButton>
        </div>
        <div className="d-flex gap-2 justify-content-center">
          {hasPendingApproval && (
            <>
              <Button
                className="btn btn-sm btn-light p-1 text-success"
                title="Approve"
                onClick={e => {
                  e.stopPropagation();
                  const job = rowData.linked_jobs.find(
                    j => j.send_for_approval && !j.is_approved && !j.is_rejected
                  );
                  setSelectedJobCandidateForApproveReject({
                    ...job,
                    job_id: job.job,
                    candidate_id: rowData.candidate_id,
                    job_name: job.job_name,
                  });
                  setActionType("approve");
                  setShowApproveRejectModal(true);
                }}
              >
                Approve
              </Button>
              <Button
                className="btn btn-sm btn-light p-1 text-danger"
                title="Reject"
                onClick={e => {
                  e.stopPropagation();
                  const job = rowData.linked_jobs.find(
                    j => j.send_for_approval && !j.is_approved && !j.is_rejected
                  );
                  setSelectedJobCandidateForApproveReject({
                    ...job,
                    job_id: job.job,
                    candidate_id: rowData.candidate_id,
                    job_name: job.job_name,
                  });
                  setActionType("reject");
                  setShowApproveRejectModal(true);
                }}
              >
                Reject
              </Button>
            </>
          )}

          {hasApprovalHistory && (
            <Button
              className="btn btn-sm btn-light p-1 text-info"
              title="View Details"
              onClick={e => {
                e.stopPropagation();
                setSelectedCandidateForDetails(rowData);
                setShowDetailsModal(true);
              }}
            >
              View
            </Button>
          )}
        </div>
      </div>
    );
  }}
/> */}
{/* <Column
  header={<span style={{ whiteSpace: "nowrap" }}>Talent Scan</span>}
  title="View Talent Scan Result"
  style={{ width: "120px" }}
  bodyStyle={{ width: "130px", minWidth: "130px", textAlign: "center" }}
  body={rowData => {
    const candidateId = rowData?.candidate_id ?? rowData?.id;
    const isTalentScanLoading = loadingTalentScanCandidateId === candidateId;

    return (
      <button
        type="button"
        className="btn btn-primary talent-scan-view-result-btn"
        style={{ padding: "4px 10px", fontSize: 12, whiteSpace: "nowrap" }}
        disabled={isTalentScanLoading}
        onClick={() => {
          handleViewTalentScanResult(rowData);
        }}
      >
        {isTalentScanLoading ? "Loading..." : "View"}
      </button>
    );
  }}
/> */}

<Column
  header="Actions"
  style={{ width: "125px" }}
  bodyStyle={{ width: "125px", minWidth: "125px", textAlign: "center" }}
  body={rowData => {
    const approvalJobs = approvalMap[rowData.candidate_id] || [];

    const pendingApprovalJob = approvalJobs.find(
      j => j.send_for_approval && !j.is_approved && !j.is_rejected
    );

    const hasApprovalHistory = approvalJobs.some(
      j => j.is_approved || j.is_rejected
    );

    return (
      <div className="candidate-actions-cell">
        <div className="candidate-actions-main">
          <Button
            className="btn btn-light candidate-action-icon-btn"
            onClick={e => {
              e.stopPropagation();
              handleClick(e, rowData);
            }}
          >
            <i className="fa-regular fa-pen-to-square" />
          </Button>

          <Button
            className="btn btn-light candidate-action-icon-btn"
            onClick={e => {
              e.stopPropagation();
              ViewCandidateInfoCall(rowData);
            }}
          >
            <FaRegEye />
          </Button>

          <RSButton
            color="light"
            size="sm"
            className="candidate-action-icon-btn"
            onClick={e => {
              e.stopPropagation();
              handleViewActionLogs(rowData.candidate_id);
            }}
          >
            <FaBusinessTime />
          </RSButton>
        </div>
        <div className="candidate-actions-approval">

          {pendingApprovalJob && (
            <>
              <Button
                className="candidate-approval-btn candidate-approval-btn--approve"
                title="Approve"
                onClick={e => {
                  e.stopPropagation();
                  openApproveRejectModal(pendingApprovalJob, "approve");
                }}
              >
                <FaCheckCircle />
              </Button>

              <Button
                className="candidate-approval-btn candidate-approval-btn--reject"
                title="Reject"
                onClick={e => {
                  e.stopPropagation();
                  openApproveRejectModal(pendingApprovalJob, "reject");
                }}
              >
                <FaTimes />
              </Button>
            </>
          )}

        {hasApprovalHistory && !pendingApprovalJob && (
              <Button
                className="candidate-approval-btn candidate-approval-btn--view"
                title="View Approval/Rejection Details"
                onClick={e => {
                  e.stopPropagation();

                  setSelectedCandidateForDetails({
                    candidate_id: rowData.candidate_id,
                    first_name: rowData.first_name,
                    last_name: rowData.last_name,
                    // approval_jobs: approvalJobs.filter(
                    //   job => job.is_approved || job.is_rejected
                    // ),
                     approval_jobs: rowData.linked_jobs.filter(
                        job => job.is_approved || job.is_rejected
                      ),
                  });

                  setShowDetailsModal(true);
                }}
              >
                <FaRegEye />
              </Button>
            )}

        </div>
      </div>
    );
  }}
/>




                      {/* <Button className="btn btn-light p-1" title="View History"><FaClock  /></Button> */}
                    </DataTable>
                  )}
                </Col>
              </Row>
            </Card>
          </div>
        </Container>
      </div>
      {/* <Modal isOpen={ViewCandidatePopupShow} toggle={ViewCandidatecancel} size="xl" backdrop={backdrop} keyboard={keyboard}>
        <ModalHeader toggle={ViewCandidatecancel}>{selectedCandidate?.first_name} {selectedCandidate?.last_name}</ModalHeader>
        <ModalBody>
          <Card title="Candidate Analysis" className="mb-3 shadow-sm border-0">
            <Row>
              <Col xxl={3}>First Name</Col>
              <Col xxl={1}>:</Col>
              <Col xxl={8}>{selectedCandidate?.first_name}</Col>
            </Row>
            <Row>
              <Col xxl={3}>Last Name</Col>
              <Col xxl={1}>:</Col>
              <Col xxl={8}>{selectedCandidate?.last_name}</Col>
            </Row>
            <Row>
              <Col xxl={3}>Total Experience</Col>
              <Col xxl={1}>:</Col>
              <Col xxl={8}>{selectedCandidate?.total_experience}</Col>
            </Row>
          </Card>

          <Card title="Contact Info" className="mb-3 shadow-sm border-0">
            <Row>
              <Col xxl={3}>Email</Col>
              <Col xxl={1}>:</Col>
              <Col xxl={8}>{selectedCandidate?.email}</Col>
            </Row>
            <Row>
              <Col xxl={3}>Phone</Col>
              <Col xxl={1}>:</Col>
              <Col xxl={8}>{selectedCandidate?.mobile_phone}</Col>
            </Row>
          </Card>

          <Card title="Skills" className="mb-3 shadow-sm border-0">
            <Row>
              <Col xxl={3}>Primary Skills</Col>
              <Col xxl={1}>:</Col>
              <Col xxl={8}>{selectedCandidate?.primary_skill_names}</Col>
            </Row>
            <Row>
              <Col xxl={3}>Secondary Skills</Col>
              <Col xxl={1}>:</Col>
              <Col xxl={8}>{selectedCandidate?.secondary_skill_names}</Col>
            </Row>
            <Row>
              <Col xxl={3}>Other Skills</Col>
              <Col xxl={1}>:</Col>
              <Col xxl={8}>{selectedCandidate?.other_skill_names}</Col>
            </Row>
          </Card>
        </ModalBody>
        <ModalFooter>
          <Button color="warning" onClick={ViewCandidatecancel}>Cancel</Button>
        </ModalFooter>
      </Modal> */}
      <Modal
  isOpen={ViewCandidatePopupShow}
  toggle={() => setViewCandidatePopupShow(false)}
  size="xl"
  centered
  className="candidate-modal"
  style={{ maxWidth: "96vw", width: "96vw" }}
  contentClassName="d-flex flex-column"
>
  {/* HEADER */}
  <ModalHeader
    toggle={() => setViewCandidatePopupShow(false)}
    style={{
      border: "none",
      paddingBottom: 12,
      background: "linear-gradient(135deg, #eef2ff, #f5f3ff)",
      borderRadius: "0.3rem 0.3rem 0 0",
    }}
  >
    <div className="d-flex align-items-center gap-3">
      <div
        style={{
          width: 40, height: 40, borderRadius: "50%",
          background: "linear-gradient(135deg, #6366f1, #7c3aed)", display: "flex",
          alignItems: "center", justifyContent: "center",
          fontWeight: 700, color: "#fff", fontSize: 13,
          boxShadow: "0 6px 14px rgba(99,102,241,0.35)",
        }}
      >
        {selectedCandidate?.first_name?.[0]}
        {selectedCandidate?.last_name?.[0]}
      </div>
      <div>
        <h5 className="mb-0" style={{ fontWeight: 700, color: "#0f172a", fontSize: 16, lineHeight: 1.25 }}>
          {selectedCandidate?.first_name}{" "}
          {selectedCandidate?.middle_name || ""}{" "}
          {selectedCandidate?.last_name}
        </h5>
        <small style={{ color: "#64748b", fontSize: 12.5, lineHeight: 1.35 }}>
          {selectedCandidate?.current_company || "—"} ·{" "}
          {formatExperience(selectedCandidate?.total_experience)} Experience
        </small>
      </div>
    </div>
  </ModalHeader>

  {/* BODY */}
  <ModalBody className="p-0 d-flex flex-column" style={{ flex: "1 1 auto", minHeight: 0 }}>
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "0.65fr 1.85fr",
        height: "calc(100vh - 190px)",
        minHeight: "62vh",
        maxHeight: "72vh",
      }}
    >

      {/* LEFT PANEL */}
      <div className="ats-candidate-detail-side" style={{ borderRight: "1px solid #e6e9f0" }}>
        <div
          className="ats-candidate-detail-switch"
          style={{
            display: "flex",
            gap: 6,
            padding: 14,
            background: "#f1f5f9",
            margin: 14,
            borderRadius: 10,
          }}
        >
          <button
            type="button"
            className={candidateDetailPanel === "contact" ? "active" : ""}
            onClick={() => setCandidateDetailPanel("contact")}
            style={{
              flex: 1,
              border: "none",
              borderRadius: 8,
              padding: "8px 10px",
              fontSize: 13,
              fontWeight: 600,
              cursor: "pointer",
              background: candidateDetailPanel === "contact" ? "#fff" : "transparent",
              color: candidateDetailPanel === "contact" ? "#4f46e5" : "#64748b",
              boxShadow: candidateDetailPanel === "contact" ? "0 2px 10px rgba(15, 23, 42, 0.06)" : "none",
            }}
          >
            Contact & History
          </button>
          <button
            type="button"
            className={candidateDetailPanel === "skills" ? "active" : ""}
            onClick={() => setCandidateDetailPanel("skills")}
            style={{
              flex: 1,
              border: "none",
              borderRadius: 8,
              padding: "8px 10px",
              fontSize: 13,
              fontWeight: 600,
              cursor: "pointer",
              background: candidateDetailPanel === "skills" ? "#fff" : "transparent",
              color: candidateDetailPanel === "skills" ? "#4f46e5" : "#64748b",
              boxShadow: candidateDetailPanel === "skills" ? "0 2px 10px rgba(15, 23, 42, 0.06)" : "none",
            }}
          >
            Skills
          </button>
        </div>
        <div className="ats-candidate-detail-content" style={{ padding: "0 18px 18px" }}>

        {/* Contact */}
        {candidateDetailPanel === "contact" && (
  <section style={sectionDivider}>
    <p style={sectionLabel}>Contact</p>

    <div className="d-flex flex-column gap-2">
      {[
        { Icon: FiMail, val: selectedCandidate?.email },
        { Icon: FiPhone, val: selectedCandidate?.mobile_phone },
        {
          Icon: FiBriefcase,
          val: `${formatExperience(selectedCandidate?.total_experience)} Total Experience`,
        },
      ].map(({ Icon, val }, index) => (
        <div
          key={index}
          className="d-flex align-items-start gap-2"
          style={{ fontSize: 13 }}
        >
          <Icon
            size={16}
            color="#4f46e5"
            className="candidate-contact-icon mt-1"
            style={{ minWidth: 16, color: "#4f46e5", stroke: "#4f46e5" }}
          />
          <span style={{ color: "#0f172a", fontSize: 13.5, wordBreak: "break-all" }}>
            {val || "—"}
          </span>
        </div>
      ))}
    </div>
  </section>
)}

        {/* Skills */}
        {candidateDetailPanel === "skills" && (
        <>
        <section style={sectionDivider}>
          <p style={sectionLabel}>Primary Skills</p>
          <div className="d-flex flex-wrap gap-2">
            {selectedPrimarySkills.length > 0
              ? selectedPrimarySkills.map((s, i) => <SkillPill key={i} label={s} color="blue" />)
              : <span className="text-muted" style={{ fontSize: 13 }}>—</span>}
          </div>
        </section>

        <section style={sectionDivider}>
          <p style={sectionLabel}>Secondary Skills</p>
          <div className="d-flex flex-wrap gap-2">
            {selectedSecondarySkills.length > 0
              ? selectedSecondarySkills.map((s, i) => <SkillPill key={i} label={s} color="teal" />)
              : <span className="text-muted" style={{ fontSize: 13 }}>—</span>}
          </div>
        </section>

        <section style={sectionDivider}>
          <p style={sectionLabel}>Other Skills</p>
          <div className="d-flex flex-wrap gap-2">
            {selectedOtherSkills.length > 0
              ? selectedOtherSkills.map((s, i) => <SkillPill key={i} label={s} color="gray" />)
              : <span className="text-muted" style={{ fontSize: 13 }}>—</span>}
          </div>
        </section>
        </>
        )}

        {/* History */}
        {candidateDetailPanel === "contact" && (
        <>
        <section style={sectionDivider}>
          <p style={sectionLabel}>Education</p>
          {renderCandidateHistoryItems(selectedEducationHistory, "education")}
        </section>

        <section style={sectionDivider}>
          <p style={sectionLabel}>Employment</p>
          {renderCandidateHistoryItems(selectedEmploymentHistory, "employment")}
        </section>

        <section style={sectionDivider}>
          <p style={sectionLabel}>Certificates</p>
          {renderCandidateHistoryItems(selectedCertificateHistory, "certificates")}
        </section>
        </>
        )}
        </div>
      </div>

      {/* RIGHT PANEL */}
      <ResumePreviewPanel resumeUrl={selectedCandidate?.resume} minHeight="100%" />

    </div>
  </ModalBody>

  {/* FOOTER */}
<ModalFooter
  className="justify-content-center"
  style={{
    border: "none",
    gap: 10,
    padding: "1rem 1.5rem 1.25rem",
    background: "#fff",
    display: "flex",
    alignItems: "center",
    flex: "0 0 auto",
  }}
>
  <div style={{ fontSize: 13, color: "#718096" }}>
    {viewCandidateIndex !== null && (
      <>{viewCandidateIndex + 1} / {CandidateListData.length}</>
    )}
  </div>
  <div style={{ display: "flex", gap: 10, justifyContent: "center", alignItems: "center", margin: "0 auto" }}>
    <Button
      disabled={viewCandidateIndex === null || viewCandidateIndex === 0}
      style={{ background: "#fff", color: "#0f172a", border: "1px solid #e6e9f0", borderRadius: 10 }}
      onClick={() => {
        const prevIndex = viewCandidateIndex - 1;
        if (prevIndex >= 0) {
          setSelectedCandidate(CandidateListData[prevIndex]);
          setViewCandidateIndex(prevIndex);
          setCandidateDetailPanel("contact");
        }
      }}
    >
      ← Prev
    </Button>
    <Button
      onClick={() => setViewCandidatePopupShow(false)}
      style={{ background: "#4f46e5", border: "none", borderRadius: 10, padding: "0.45rem 1.35rem" }}
    >
      Close
    </Button>
    <Button
      disabled={
        viewCandidateIndex === null ||
        viewCandidateIndex >= CandidateListData.length - 1
      }
      style={{ background: "#fff", color: "#0f172a", border: "1px solid #e6e9f0", borderRadius: 10 }}
      onClick={() => {
        const nextIndex = viewCandidateIndex + 1;
        if (nextIndex < CandidateListData.length) {
          setSelectedCandidate(CandidateListData[nextIndex]);
          setViewCandidateIndex(nextIndex);
          setCandidateDetailPanel("contact");
        }
      }}
    >
      Next →
    </Button>
  </div>
</ModalFooter>
</Modal>

      <Dialog
        header="Schedule Interview"
        visible={scheduleCommonPopup}
        className="interview-popup"
        style={{ width: "50vw" }}
        onHide={closeSchedulePopup}
      >
        <form>
          <p className="bg-form">
            <div className="mb-4">
              <Row className="mb-2">
                <Col xl={6}>
                  <div className="p-field flex flex-column">
                    <label htmlFor="eventType">
                      Type <span className="text-danger">*</span>
                    </label>
                    <InputText
                      id="eventType"
                      value={scheduleEventType}
                      onChange={e => {
                        const nextType = e.target.value
                        setScheduleEventType(nextType)
                        setScheduleSubject(current => {
                          const separatorIndex = current.indexOf(" - ")
                          return separatorIndex >= 0
                            ? `${nextType.trim() || "Interview"}${current.slice(separatorIndex)}`
                            : current
                        })
                        setScheduleFormErrors(prev => ({ ...prev, event_type: "" }))
                      }}
                      placeholder="Enter interview type"
                      className={scheduleFormErrors.event_type ? "p-invalid" : ""}
                    />
                    {scheduleFormErrors.event_type && (
                      <small className="p-error">{scheduleFormErrors.event_type}</small>
                    )}
                  </div>
                </Col>
                <Col xl={6}>
                  <div
                    className="p-field flex flex-column"
                    id="SubTypeDropdown"
                  >
                    <label htmlFor="integer" className="block">
                      Sub-Type <span className="text-danger">*</span>
                    </label>
                    <Dropdown
                      value={scheduleSubtype}
                      // onChange={(e) => setScheduleSubtype(e.value)}
                      onChange={e => {
                        setScheduleSubtype(e.value)
                        setScheduleFormErrors(prev => ({
                          ...prev,
                          event_sub_type: "",
                        })) // Clear error on change
                      }}
                      options={subtypeCall}
                      optionLabel="name"
                      placeholder="Subtype"
                      className="w-full search-option"
                    />
                    {scheduleFormErrors.event_sub_type && (
                      <small className="p-error">
                        {scheduleFormErrors.event_sub_type}
                      </small>
                    )}
                  </div>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col xl={5}>
                  <div className="p-field flex-auto">
                    <label htmlFor="startDate" className="block">
                      Start Date <span className="text-danger">*</span>
                    </label>
                    <Calendar
                      id="startDate"
                      className="w-100"
                      value={scheduleStartDate}
                      onChange={e => {
                        setScheduleStartdate(e.value)
                        setScheduleEndDate(e.value)
                        setScheduleFormErrors(prev => ({
                          ...prev,
                          start_time: "",
                          end_time: "",
                        }))
                      }}
                      showIcon
                      minDate={new Date()}
                      dateFormat="yy-mm-dd"
                      icon={() => <i className="pi pi-calendar" />}
                    />
                    {scheduleFormErrors.start_date && (
                      <small className="p-error">
                        {scheduleFormErrors.start_date}
                      </small>
                    )}
                  </div>
                </Col>
                <Col xl={4}>
                  <div className="p-field flex-auto">
                    <label htmlFor="startTime" className="block">
                      Start Time <span className="text-danger">*</span>
                    </label>
                    <Calendar
                      id="startTime"
                      className="w-100"
                      value={scheduleStartTime}
                      onChange={e => {
                        setScheduleStarttime(e.value)
                        setScheduleFormErrors(prev => ({
                          ...prev,
                          start_time: "",
                          end_time: "",
                        }))
                      }}
                      showIcon
                      timeOnly
                      hourFormat="12" 
                      icon={() => <i className="pi pi-clock" />}
                    />
                    {scheduleFormErrors.start_time && (
                      <small className="p-error">
                        {scheduleFormErrors.start_time}
                      </small>
                    )}
                  </div>
                </Col>
                <Col xl={3}>
                  <div className="flex-auto">
                    <label htmlFor="endTime" className="block">
                      End Time <span className="text-danger">*</span>
                    </label>
                    <Calendar
                      id="endTime"
                      value={scheduleEndTime}
                      onChange={e => {
                        setScheduleEndTime(e.value)
                        setScheduleFormErrors(prev => ({ ...prev, end_time: "" }))
                      }}
                      showIcon
                      timeOnly
                      hourFormat="12" 
                      icon={() => <i className="pi pi-clock" />}
                    />
                    {scheduleFormErrors.end_time && (
                      <small className="p-error">
                        {scheduleFormErrors.end_time}
                      </small>
                    )}
                  </div>
                </Col>
              </Row>
              {/* <Row> */}
              {/* <Row>
                  {/* <Col xl={12}>                   
                  </Col> */}
              {/* <Col xl={6}> */}
              {/* <Row className="mb-2"> */}
              {/* <Col xl={6}> */}
              {/* <div className="flex-auto">
                          <label htmlFor="endDate" className="block">
                            End date <span className="text-danger">*</span>
                          </label>
                          <Calendar
                            id="endDate"
                            value={scheduleEndDate}
                            onChange={(e) => setScheduleEndDate(e.value)}
                            showIcon
                            minDate={scheduleStartDate || new Date()}
                            dateFormat="yy-mm-dd"
                            icon={() => <i className="pi pi-calendar" />}
                          />
                          {scheduleFormErrors.end_date && (
                            <small className="p-error">{scheduleFormErrors.end_date}</small>
                          )}
                        </div> */}
              {/* </Col> */}
              {/* <Col xl={6}>
                        <div className="flex-auto">
                          <label htmlFor="endTime" className="block">
                            Time <span className="text-danger">*</span>
                          </label>
                          <Calendar
                            id="endTime"
                            value={scheduleEndTime}
                            onChange={(e) => setScheduleEndTime(e.value)}
                            showIcon
                            timeOnly
                            icon={() => <i className="pi pi-clock" />}
                          />
                          {scheduleFormErrors.end_time && (
                            <small className="p-error">{scheduleFormErrors.end_time}</small>
                          )}
                        </div>
                      </Col> */}
              {/* </Row> */}
              {/* </Col> */}
              {/* </Row> */}
              {/* </Row> */}
            </div>
            <div>
              <Row>
                <Col xl={12}>
                  <div>
                    <label htmlFor="Company">Select Company</label>
                    <CompanySelector
                      selectedCompanyId={dialogCompanyId}
                      disabled
                      onCompanyChange={(company) => {
                        if (company?.company_id) {
                          setDialogCompanyId(company.company_id);
                          setSelectedInterviewCandidate(null);
                          setSelectedCustomers([]);
                          setSelectedScheduleCandidates([]);
                          setSelectedScheduleJobs([]);
                          setScheduleFormErrors(prev => ({
                            ...prev,
                            candidates: "",
                            job_id: "",
                          }));
                        }
                      }}
                      className="mt-2"
                    />
                  </div>
                </Col>
              </Row>
            </div>
            <div className="mb-4">
              <Row className="mb-2">
                <LinkContactsPopup
                  hideJobSelector
                  onSelectedJobsChange={jobs => {
                    setSelectedScheduleCandidates([])
                    setSelectedScheduleJobs(jobs)
                    setScheduleFormErrors(prev => ({ ...prev, job_id: "" }))
                  }}
                  errorJob={scheduleFormErrors.job_id}
                  setSelectedScheduleContacts={contacts => {
                    setSelectedScheduleContacts(contacts)
                    setScheduleFormErrors(prev => ({ ...prev, interviewer: "" }))
                  }}
                  setSelectedCcUsers={setSelectedCcUsers}
                   clearInterviewerError={() =>
                      setScheduleFormErrors(prev => ({ ...prev, interviewer: "" }))
                    }
                  errorContact={scheduleFormErrors.interviewer}
                  companyId={
                    selectedInterviewCandidate?.company ||
                    selectedInterviewCandidate?.company_id ||
                    dialogCompanyId
                  }
                  jobLabel={<span>Jobs <span className="text-danger">*</span></span>}
                />
              </Row>
              <Row className="mb-2">
                <Col xl={6}>
                  <div className="field">
                    <label htmlFor="selectedCandidate" style={{ marginBottom: "4px" }}>
                      Candidate <span className="text-danger">*</span>
                    </label>
                    <InputText
                      id="selectedCandidate"
                      disabled
                      className="w-full"
                      value={
                        selectedCustomers?.length > 0
                          ? selectedCustomers.map(candidate => getCandidateFullName(candidate)).join(" | ")
                          : ""
                      }
                      placeholder="Select a candidate from the radio button"
                    />
                    {scheduleFormErrors.candidates && (
                      <small className="p-error">{scheduleFormErrors.candidates}</small>
                    )}
                  </div>
                </Col>
                <Col xl={6}>
                  <div className="field">
                    <label htmlFor="selectedJob" style={{ marginBottom: "4px" }}>
                      Job <span className="text-danger">*</span>
                    </label>
                    <InputText
                      id="selectedJob"
                      disabled
                      className="w-full"
                      value={
                        selectedScheduleJobs?.length > 0
                          ? [...new Set(selectedScheduleJobs.map(getInterviewJobLabel).filter(Boolean))].join(" | ")
                          : getCandidateJobTitles(selectedInterviewCandidate)
                      }
                      placeholder="Job titles will appear here"
                    />
                    {scheduleFormErrors.job_id && (
                      <small className="p-error">{scheduleFormErrors.job_id}</small>
                    )}
                  </div>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col xl={6}>
                  <div className="p-field flex flex-column">
                    <label htmlFor="username">Subject <span className="text-danger">*</span></label>
                    <InputText
                      placeholder="Subject"
                      value={scheduleSubject}
                      onChange={e => {
                        setScheduleSubject(e.target.value);

                        if (scheduleFormErrors.subject) {
                          setScheduleFormErrors(prev => ({
                            ...prev,
                            subject: "",
                          }));
                        }
                      }}
                    />

                    {scheduleFormErrors.subject && (
                      <small className="p-error">{scheduleFormErrors.subject}</small>
                    )}
                  </div>
                </Col>
                <Col xl={6}>
                  <div
                    className="p-field flex flex-column"
                    id="PriorityDropdown"
                  >
                    <label htmlFor="Priority" className="block">
                      Priority <span className="text-danger">*</span>
                    </label>
                    <Dropdown
                      value={schedulePriority}
                      onChange={e => {
                        setSchedulePriority(e.value);

                        if (scheduleFormErrors.priority) {
                          setScheduleFormErrors(prev => ({
                            ...prev,
                            priority: "",
                          }));
                        }
                      }}
                      options={priorityValue}
                      optionLabel="name"
                      placeholder="Priority"
                      className="w-full search-option"
                    />

                    {scheduleFormErrors.priority && (
                      <small className="p-error">{scheduleFormErrors.priority}</small>
                    )}
                  </div>
                </Col>
              </Row>
              {/* Note field removed: not used in schedule interview flow.
              <Row className="mb-2">
                <Col xl={12}>
                  <div className="">
                    <label htmlFor="username">Note :</label>
                    <Editor
                      value={popTextares}
                      onTextChange={e => setPopTextares(e.htmlValue || "")}
                      onBlur={() => setPopTextares(prev => linkifyEditorHtml(prev))}
                      onPaste={() => setTimeout(() => setPopTextares(prev => linkifyEditorHtml(prev)), 50)}
                      placeholder="Interview Test"
                      style={{ height: "140px" }}
                    />
                  </div>
                </Col>
              </Row>
              */}
            </div>
            <div>
              <Row className="mb-2">
                <Col lg={6}>
                  <Row>
                    <Col xl={6} className="d-none">
                      <div
                        className="p-field flex flex-column"
                        id="PriorityDropdown"
                      >
                        <label htmlFor="Priority" className="block">
                          Priority <span className="text-danger">*</span>
                        </label>
                        <Dropdown
                          value={schedulePriority}
                          onChange={e => {
                            setSchedulePriority(e.value);

                            if (scheduleFormErrors.priority) {
                              setScheduleFormErrors(prev => ({
                                ...prev,
                                priority: "",
                              }));
                            }
                          }}
                          options={priorityValue}
                          optionLabel="name"
                          placeholder="Priority"
                          className="w-full search-option"
                        />

                        {scheduleFormErrors.priority && (
                            <small className="p-error">{scheduleFormErrors.priority}</small>
                          )}
                      </div>
                    </Col>
                    <Col xl={6}>
                      <div className="p-field flex flex-column d-none">
                        <label htmlFor="Duration" className="block">
                          Duration <span className="text-danger">*</span>
                        </label>
                        <Dropdown
                          value={scheduleDuration}
                          onChange={e => {
                            setScheduleDuration(e.value)
                            setScheduleFormErrors(prev => ({
                              ...prev,
                              duration: "",
                            }))
                          }}
                          options={[
                            { duration: "15 mins", value: 15 },
                            { duration: "30 mins", value: 30 },
                            { duration: "45 mins", value: 45 },
                            { duration: "60 mins", value: 60 },
                          ]}
                          optionLabel="duration"
                          placeholder="Duration"
                          className="w-full search-option"
                        />
                      </div>
                      {scheduleFormErrors.duration && (
                        <small className="p-error d-none">
                          {scheduleFormErrors.duration}
                        </small>
                      )}
                    </Col>

                    <Col lg={6}>
                      <Row className="mt-2">
                        <Col xl={6}>
                          <div className="d-flex align-items-center mt-4 d-none">
                            <Checkbox
                              inputId="checkbox"
                              checked={popchecked}
                              onChange={handlePopupCheckbox}
                            />
                            <label htmlFor="username" className="ms-1 mt-2">
                              Completed
                            </label>
                          </div>
                        </Col>
                        <Col xl={6} className="d-none">
                          <div className="d-flex align-items-center mt-4">
                            <Checkbox
                              inputId="checkbox"
                              checked={schedulepopchecked2}
                              onChange={handlePopupCheckbox2}
                            />
                            <label htmlFor="username" className="ms-1 mt-2">
                              Private
                            </label>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
                <Col xl={6} className="d-none">
                  <label htmlFor="username">User Id's</label>
                  <Chips
                    value={userid}
                    onChange={e => setUserid(e.value)}
                    readOnly
                    className="w-full"
                  />
                </Col>
                <Col xl={6} className="d-none">
                  <div className="p-field flex flex-column d-none">
                    <label htmlFor="reminder">Reminder</label>
                    <Dropdown
                      id="reminder"
                      value={scheduleReminder}
                      onChange={e => setScheduleReminder(e.value)}
                      options={reminderOptions}
                      optionLabel="label"
                      placeholder="Reminder"
                      className="w-full search-option"
                    />
                  </div>
                </Col>
              </Row>
            </div>
            <Row className="mb-2">
              {(selectedSchedule?.name?.toLowerCase() === "meeting" ||
                selectedSchedule?.name?.toLowerCase() === "call") && (
                <>
                  <Col xl={4}>
                    <div className="p-field flex flex-column">
                      <label htmlFor="repeat">Repeat</label>
                      <Dropdown
                        id="repeat"
                        value={scheduleRepeat}
                        onChange={e => {
                          setScheduleRepeat(e.value)
                          setScheduleFormErrors(prev => ({
                            ...prev,
                            repeat: "",
                          }))
                        }}
                        options={repeatOptions}
                        optionLabel="label"
                        placeholder="Repeat"
                        className="w-full search-option"
                      />
                      {scheduleFormErrors.repeat && (
                        <small className="p-error">
                          {scheduleFormErrors.repeat}
                        </small>
                      )}
                    </div>
                  </Col>
                  <Col xl={4}>
                    <div className="p-field flex flex-column">
                      <label htmlFor="autofollowup">Auto Followup</label>
                      <Dropdown
                        id="autofollowup"
                        value={scheduleAutoFollowup}
                        onChange={e => {
                          setScheduleAutoFollowup(e.value)
                          setScheduleFormErrors(prev => ({
                            ...prev,
                            auto_followup: "",
                          }))
                        }}
                        options={autoFollowupOptions}
                        optionLabel="label"
                        placeholder="Auto Followup"
                        className="w-full search-option"
                      />
                      {scheduleFormErrors.auto_followup && (
                        <small className="p-error">
                          {scheduleFormErrors.auto_followup}
                        </small>
                      )}
                    </div>
                  </Col>
                  {/* <Col xl={4}>
                          <div className="p-field flex flex-column">
                            <label htmlFor="reminder">Reminder</label>
                            <Dropdown
                              id="reminder"
                              value={scheduleReminder}
                              onChange={(e) => setScheduleReminder(e.value)}
                              options={reminderOptions}
                              optionLabel="label"
                              placeholder="Reminder"
                              className="w-full search-option"
                            />
                          </div>
                        </Col> */}
                </>
              )}
              {selectedSchedule?.name?.toLowerCase() !== "meeting" &&
                selectedSchedule?.name?.toLowerCase() !== "call" && (
                  <Col xl={4} className="d-none">
                    <div className="p-field flex flex-column">
                      <label htmlFor="reminder">Reminder</label>
                      <Dropdown
                        id="reminder"
                        value={scheduleReminder}
                        onChange={e => setScheduleReminder(e.value)}
                        options={reminderOptions}
                        optionLabel="label"
                        placeholder="Reminder"
                        className="w-full search-option"
                      />
                    </div>
                  </Col>
                )}
            </Row>
            <Row className="">
              <Col xl={12}>
                <div className="d-flex justify-content-center">
                  <button
                    type="button"
                    className="btn btn-primary waves-effect waves-light me-2"
                    onClick={closeSchedulePopup}
                  >
                    <i className="pi pi-times me-1"></i>
                    Cancel
                  </button>
                   <button
                    type="button"
                    className="btn btn-primary waves-effect waves-light btn btn-primary me-2 btn-main"
                    onClick={handleSaveSchedule}
                    disabled={loadingSave}
                  >
                    <i className="pi pi-save me-1"></i>
                    {loadingSave ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Saving...
                      </>
                    ) : (
                      "Save"
                    )}
                  </button>
                </div>
              </Col>
            </Row>
          </p>
        </form>
      </Dialog>
      <Sidebar
        visible={candidateSidebarVisible}
        position="right"
        className="sidebar"
      >
        <div className="sidebar-header">
          <h3>Create a Candidate</h3>
          <div className="d-flex align-items-center">
            {/* <Link to="/candidate-editform">
                              <p className="mb-0 text-white">
                                {" "}
                                <i class="fa-regular fa-pen-to-square me-3"></i>{" "}
                              </p> */}
            {/* </Link> */}
            <p
              className="mb-0 text-white"
              onClick={() => setCandidateSidebarVisible(false)}
              style={{ cursor: "pointer" }}
            >
              <i className="fa fa-close me-3" />
            </p>
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card sidebardetails">
            <Row className="mb-3">
              <Col lg={6}>
                <label className="mb-0">
                  First Name <span className="text-danger">*</span>
                </label>
                <InputText
                  {...register("firstname", {
                    required: "First name is required *",
                    pattern: {
                      value: /^[A-Za-z][A-Za-z-\s&,]+$/,
                      message:
                        "This field allows only alphabets and spaces, but does not accept a space as the first character.",
                    },
                    maxLength: {
                      value: 100,
                      message: "Minimum 100 Characters Are Allowed",
                    },
                    minLength: {
                      value: 1,
                      message: "Minimum 1 Characters Are Allowed",
                    },
                  })}
                  onKeyUp={() => {
                    trigger("firstname")
                  }}
                />
                {errors.firstname && (
                  <small
                    id="personalEmailHelp"
                    className="form-text text-danger"
                  >
                    {errors.firstname.message}
                  </small>
                )}
              </Col>
              <Col lg={6}>
                <label htmlFor="lastName" className="mb-0">
                  Last Name
                </label>
                <InputText
                  id="lastName"
                  name="lastName"
                  {...register("lastname", {
                    // required: "Last name is required",
                    pattern: {
                      value: /^[A-Za-z][A-Za-z-\s&]+$/,
                      message:
                        "This field allows only alphabets and spaces, but does not accept a space as the first character.",
                    },
                    maxLength: {
                      value: 100,
                      message: "Minimum 100 Characters Are Allowed",
                    },
                    minLength: {
                      value: 1,
                      message: "Minimum 1 Characters Are Allowed",
                    },
                  })}
                  onKeyUp={() => {
                    trigger("lastname")
                  }}
                />
                {errors.lastname && (
                  <small
                    id="personalEmailHelp"
                    className="form-text text-danger"
                  >
                    {errors.lastname.message}
                  </small>
                )}
              </Col>
            </Row>
            <Row className="mb-3">
              <Col lg={6}>
                <label htmlFor="email" className="mb-0">
                  Email <span className="text-danger">*</span>
                </label>
                {/* sais code */}
                <InputText
                  id="email"
                  name="email"
                  inputRef={emailInputRef}
                  {...register("personal_email", {
                    required: "Email is required *",
                    pattern: emailValidation,
                    onChange: async event => {
                      const value = event.target.value.toLowerCase()
                      setValue("personal_email", value)

                      // Debounce logic starts here
                      if (emailDebounceRef.current) {
                        clearTimeout(emailDebounceRef.current)
                      }
                      emailDebounceRef.current = setTimeout(async () => {
                        if (value) {
                          try {
                            const response = await axios.post(
                              "/api/v1/candidates/check-email/",
                              { email: value }
                            )
                            if (response.data.duplicate) {
                              setIsDuplicateEmail(true)
                              setDuplicateCandidateId(
                                response.data.candidate_id
                              )
                              setEmailError(
                                "Candidate with this email already exists."
                              )
                            } else {
                              setIsDuplicateEmail(false)
                              setDuplicateCandidateId(null)
                              setEmailError("")
                            }
                          } catch (err) {
                            setIsDuplicateEmail(false)
                            setDuplicateCandidateId(null)
                            setEmailError("Failed to check duplicate email.")
                          }
                        } else {
                          setIsDuplicateEmail(false)
                          setDuplicateCandidateId(null)
                          setEmailError("")
                        }
                      }, 700) // 700ms debounce
                      // Debounce logic ends here
                    },
                  })}
                />
                {(isDuplicateEmail && duplicateCandidateId) || emailError ? (
                  <div className="mt-2">
                    <small className="form-text text-danger">
                      {emailError ||
                        "Candidate with this email already exists."}
                    </small>
                    {isDuplicateEmail && duplicateCandidateId && (
                      <Button
                        className="btn btn-warning ms-2"
                        onClick={() => {
                          dispatch(setCandidateSidebarVisible(false)) // Hide sidebar
                          navigate(
                            `/candidate-editform?candidate_id=${duplicateCandidateId}`
                          )
                        }}
                      >
                        Edit Candidate
                      </Button>
                    )}
                  </div>
                ) : null}

                {errors.personal_email && (
                  <small
                    id="personalEmailHelp"
                    className="form-text text-danger"
                  >
                    {errors.personal_email.message}
                  </small>
                )}
              </Col>

              <Col lg={6}>
                <label htmlFor="phoneNumber" className="mb-0">
                  Phone Number <span className="text-danger">*</span>
                </label>
                <InputText
                  id="phoneNumber"
                  name="phoneNumber"
                  {...register("phone", {
                    required: "Phone number is required *",
                    pattern: {
                      value: onlyNumbers,
                      message:
                        "Phone number must be exactly 10 digits and only numbers are allowed",
                    },
                    validate: {
                      notAllZeros: value =>
                        !/^0+$/.test(value) ||
                        "Mobile number cannot be all zeros",
                      exactLength: value =>
                        value.length === 10 ||
                        "Mobile number must be exactly 10 digits",
                    },
                  })}
                  onChange={e => {
                    // Allow only numbers and limit to 10 digits
                    const value = e.target.value.replace(/\D/g, "").slice(0, 10)
                    setValue("phone", value) // Update the form value
                    trigger("phone") // Trigger validation
                  }}
                />
                {errors.phone && (
                  <small id="phoneNoHelp" className="form-text text-danger">
                    {errors.phone.message}
                  </small>
                )}
              </Col>
            </Row>
            <Row className="mb-3">
              <Col lg={6}>
                <label htmlFor="jobTitle" className="mb-0">
                  Job Title
                </label>
                <InputText
                  id="jobTitle"
                  name="jobTitle"
                  {...register("jobtitle", {
                    //   required: "This field is required",
                    pattern: onlyAlphabetsandSpaces,
                  })}
                  onKeyUp={() => {
                    trigger("jobtitle")
                  }}
                />
                {errors.jobtitle && (
                  <small id="emailHelp" className="form-text text-danger">
                    {errors.jobtitle.message}
                  </small>
                )}
              </Col>
              <Col lg={6}>
                <label htmlFor="company" className="mb-0">
                  Company
                </label>
                <Controller
                  name="Company"
                  control={control}
                  render={({ field }) => (
                    <Dropdown
                      {...field}
                      value={field.value}
                      options={companies}
                      optionLabel="name"
                      optionValue="id"
                      placeholder="Select Company"
                      className="w-full border border-gray-300 rounded-md bg-white"
                      onChange={e => field.onChange(e.value)}
                      filter
                      showClear
                    />
                  )}
                />
                {errors.Company && (
                  <small id="emailHelp" className="form-text text-danger">
                    {errors.Company.message}
                  </small>
                )}
              </Col>
            </Row>
            <Row className="mb-3">
              <Col lg={6}>
                <label htmlFor="source" className="mb-0">
                  Source <span className="text-danger">*</span>
                </label>
                <Dropdown
                  id="source"
                  value={formData.source}
                  options={resumeSourceOptions}
                  placeholder="Select Source"
                  className={`w-full border border-gray-300 rounded-md bg-white ${
                    formErrors.source ? "p-invalid" : ""
                  }`}
                  onChange={e => handleCandidateInputChange("source", e.value)}
                  filter
                  showClear={!!formData.source}
                  optionLabel="label"
                  optionValue="value"
                />
                {formErrors.source && (
                  <small className="text-danger d-block mt-1">
                    {formErrors.source}
                  </small>
                )}
              </Col>
              <Col lg={6}>
                <label htmlFor="primarySkills" className="mb-0">
                  Primary Skills
                </label>
                {/* <Dropdown
                                  id="jobLocation"
                                  value={primarySkillsview}
                                  onChange={(e) => setprimarySkillsview(e.value)}
                                  options={primarySkillsget}
                                  optionLabel="name"
                                  optionValue="id"
                                  filter
                                  filterPlaceholder="Search Location"
                                  className="w-full activejobdrop"
                                  placeholder="Enter job location..."
                                /> */}
                <MultiSelect
                  id="primarySkills"
                  value={primarySkillsview}
                  onChange={e => setprimarySkillsview(e.value)} // e.value will be an array of selected IDs
                  options={candidatePrimarySkillsget}
                  optionLabel="name"
                  optionValue="id"
                  filter
                  display="chip" // optional: shows chips for selected values
                  className="w-full activejobdrop"
                  placeholder="Select primary skills..."
                />
              </Col>
            </Row>
            <Row className="mb-3">
              {/* <Col lg={6}>
                                <label htmlFor="stage" className="mb-0">
                                  Stage <span className="text-danger">*</span>
                                </label>
                                <Dropdown
                                  id="stage"
                                  value={formData.stage}
                                  options={stages.filter(stage => stage).map(stage => ({
                                    label: stage.charAt(0).toUpperCase() + stage.slice(1), // Capitalize first letter
                                    value: stage
                                  }))}
                                  placeholder="Select Stage"
                                  className={`w-full border border-gray-300 rounded-md bg-white ${formErrors.stage ? 'p-invalid' : ''}`}
                                  onChange={e => handleCandidateInputChange('stage', e.value)}
                                  filter
                                  showClear={!!formData.stage}
                                  optionLabel="label"
                                  optionValue="value"
                                />
                                {formErrors.stage && (
                                  <small className="text-danger d-block mt-1">
                                    {formErrors.stage}
                                  </small>
                                )}
                              </Col> */}
            </Row>
            <Row className="mb-3">
              {/* <Col lg={6} className="mb-2">
                                <label htmlFor="country" className="mb-0">
                                  Country
                                </label>
                                <Dropdown
                                  id="country"
                                  value={selectedCountry}
                                  onChange={(e) => { setSelectedCountry(e.value) }}
                                  options={addCountry}
                                  optionLabel="name"
                                  filter
                                  filterPlaceholder="Search Country"
                                  className="w-full activejobdrop"
                                  placeholder="Enter Country details..."
                                />
                              </Col>
                              <Col lg={6} className="mb-2">
                                <label htmlFor="state" className="mb-0">
                                  State
                                </label>
                                <Dropdown
                                  id="state"
                                  value={selectedState}
                                  onChange={(e) => { setSelectedState(e.value) }}
                                  options={addStates}
                                  optionLabel="name"
                                  filter
                                  filterPlaceholder="Search "
                                  className="w-full activejobdrop"
                                  placeholder="Enter state details..."
                                />
                              </Col> */}
              {/* <Col lg={6}>
                                <label htmlFor="city" className="mb-0">
                                  City
                                </label>
                                <Dropdown
                                  id="city"
                                  value={selectedCity}
                                  onChange={e => {
                                    setSelectedCity(e.value)
                                  }}
                                  optionValue="city_id"
                                  options={addCities}
                                  optionLabel="name"
                                  filter
                                  filterPlaceholder="Search City"
                                  className="w-full activejobdrop"
                                  placeholder="Enter city details..."
                                />
                              </Col> */}

              <Col lg={12}>
                <label htmlFor="availabilityDate" className="mb-0 avbdate">
                  Availability Date
                </label>
                <input
                  type="date"
                  id="availabilityDate"
                  name="availabilityDate"
                  className="form-control"
                  min={new Date().toISOString().split("T")[0]}
                  // max={MaxDateOfBith}
                  {...register("Availability", {})}
                />
                {errors.Availability && (
                  <small id="emailHelp" className="form-text text-danger">
                    {errors.Availability.message}
                  </small>
                )}
              </Col>
            </Row>
            {/* sai's code */}
            <Row className="mb-3">
              <Col lg={12}>
                <div
                  className="p-field companie-add"
                  style={{ position: "relative" }}
                >
                  <label htmlFor="address">Address</label>
                  <InputTextarea
                    id="address"
                    value={formData.address}
                    readOnly
                    style={{ paddingRight: "2rem" }}
                    rows={3}
                    cols={30}
                    className={
                      formErrors.address ? "p-invalid w-full" : "w-full"
                    }
                  />
                  <i
                    className="pi pi-pencil"
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "70%",
                      transform: "translateY(-50%)",
                      color: "#6c757d",
                      cursor: "pointer",
                    }}
                    onClick={openAddressDialog}
                  />
                  <Dialog
                    header="Edit Address"
                    className="address-popup"
                    visible={visible}
                    onHide={handleAddressDialogCancel}
                    style={{ width: "30vw" }}
                    breakpoints={{
                      "960px": "75vw",
                      "641px": "100vw",
                    }}
                    footer={
                      <div>
                        <button
                          label="OK"
                          icon="pi pi-check"
                          onClick={handleAddressDialogOk}
                          className="btn btn-primary me-2 sidebarbtn btn btn-primary"
                        >
                          OK
                        </button>
                      </div>
                    }
                  >
                    <div className="card sidebardetails">
                      <form>
                        <Row className="mb-3">
                          <Col lg={6}>
                            <div className="p-field">
                              <label htmlFor="street_address">Street 1</label>
                              <InputText
                                id="street_address"
                                value={tempAddressData.street_address}
                                onChange={e =>
                                  handleTempAddressChange(
                                    "street_address",
                                    e.target.value
                                  )
                                }
                                placeholder="Enter Street 1"
                                className={
                                  formErrors.street_address
                                    ? "p-invalid w-full activejobdrop"
                                    : "w-full activejobdrop"
                                }
                              />
                              {formErrors.street_address && (
                                <small className="p-error">
                                  {formErrors.street_address}
                                </small>
                              )}
                            </div>
                          </Col>
                          <Col lg={6}>
                            <div className="p-field">
                              <label htmlFor="street_address_line_2">
                                Street 2
                              </label>
                              <InputText
                                id="street_address_line_2"
                                value={tempAddressData.street_address_line_2}
                                onChange={e =>
                                  handleTempAddressChange(
                                    "street_address_line_2",
                                    e.target.value
                                  )
                                }
                                placeholder="Enter Street 2 (Optional)"
                                className={
                                  formErrors.street_address_line_2
                                    ? "p-invalid w-full activejobdrop"
                                    : "w-full activejobdrop"
                                }
                              />
                              {formErrors.street_address_line_2 && (
                                <small className="p-error">
                                  {formErrors.street_address_line_2}
                                </small>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col lg={6}>
                            <div className="p-field">
                              <label htmlFor="country">Country</label>
                              <Dropdown
                                id="country"
                                value={tempAddressData.country}
                                onChange={e =>
                                  handleTempAddressChange("country", e.value)
                                }
                                options={countries}
                                optionLabel="name"
                                optionValue={option => option}
                                filter
                                filterPlaceholder="Search Country"
                                className={
                                  formErrors.country
                                    ? "p-invalid w-full activejobdrop"
                                    : "w-full activejobdrop"
                                }
                                placeholder="Select Country"
                                // disabled={!countries.length}
                              />
                              {formErrors.country && (
                                <small className="p-error">
                                  {formErrors.country}
                                </small>
                              )}
                            </div>
                          </Col>
                          <Col lg={6}>
                            <div className="p-field">
                              <label htmlFor="state">State</label>
                              <Dropdown
                                id="state"
                                value={tempAddressData.state}
                                onChange={e =>
                                  handleTempAddressChange("state", e.value)
                                }
                                options={states}
                                optionLabel="name"
                                optionValue={option => option}
                                filter
                                filterPlaceholder="Search State"
                                className={
                                  formErrors.state
                                    ? "p-invalid w-full activejobdrop"
                                    : "w-full activejobdrop"
                                }
                                placeholder="Select State"
                                // disabled={
                                //   !tempAddressData.country ||
                                //   !states.length
                                // }
                              />
                              {formErrors.state && (
                                <small className="p-error">
                                  {formErrors.state}
                                </small>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col lg={6}>
                            <div className="p-field">
                              <label htmlFor="city">City</label>
                              <Dropdown
                                id="city"
                                value={tempAddressData.city}
                                onChange={e =>
                                  handleTempAddressChange("city", e.value)
                                }
                                options={cities}
                                optionLabel="name"
                                optionValue={option => option}
                                filter
                                filterPlaceholder="Search City"
                                className={
                                  formErrors.city
                                    ? "p-invalid w-full activejobdrop"
                                    : "w-full activejobdrop"
                                }
                                placeholder="Select City"
                                // disabled={
                                //   !tempAddressData.state ||
                                //   !cities.length
                                // }
                              />
                              {formErrors.city && (
                                <small className="p-error">
                                  {formErrors.city}
                                </small>
                              )}
                            </div>
                          </Col>
                          <Col lg={6}>
                            <div className="p-field">
                              <label htmlFor="pincode">Postal Code</label>
                              <InputText
                                id="pincode"
                                value={tempAddressData.pincode}
                                // onChange={e =>
                                //   handleTempAddressChange(
                                //     "pincode",
                                //     e.target.value
                                //   )
                                // }
                                onChange={e => {
                                  const value = e.target.value
                                    .replace(/\D/g, "")
                                    .slice(0, 6)
                                  handleTempAddressChange("pincode", value)
                                }}
                                placeholder="Enter Postal Code"
                                className={
                                  formErrors.pincode
                                    ? "p-invalid w-full activejobdrop"
                                    : "w-full activejobdrop"
                                }
                              />
                              {formErrors.pincode && (
                                <small className="p-error">
                                  {formErrors.pincode}
                                </small>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col lg={12}>
                            <div className="pist-field">
                              <label htmlFor="label">Label</label>
                              <Dropdown
                                id="label"
                                value={tempAddressData.label}
                                onChange={e =>
                                  handleTempAddressChange("label", e.value)
                                }
                                options={addressLabels}
                                optionLabel="label"
                                optionValue="value"
                                placeholder="Select Label"
                                className={
                                  formErrors.label
                                    ? "p-invalid w-full activejobdrop"
                                    : "w-full activejobdrop"
                                }
                              />
                              {formErrors.label && (
                                <small className="p-error">
                                  {formErrors.label}
                                </small>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </div>
                  </Dialog>
                </div>
              </Col>
            </Row>

            {/* <Row className="mb-3">
                              <Col lg={12}>
                                <label
                                  htmlFor="availabilityDate"
                                  className="mb-0 avbdate"
                                >
                                  Resume Attachment
                                </label>
              
                                <input
                                  type="file"
                                  accept="image/jpg,image/jpeg,image/png,application/pdf"
                                  className="form-control addEmp_ProfilePhoto"
                                  id="MyPro_UploadedProfilePhoto_Modal_FilesInput"
                                  onChange={handleFileChange}
                                />
                                {error && (
                                  <small className="text-danger">{error}</small>
                                )}
                                <small className="text-muted">
                                  Eg: (jpeg,png,pdf,jpg)
                                </small>
                              </Col>
                            </Row> */}
            <Row className="mb-3">
              <Col lg={12}>
                <label htmlFor="availabilityDate" className="mb-0 avbdate">
                  Resume Attachment
                </label>
                <input
                  type="file"
                  accept="image/jpg,image/jpeg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  className="form-control addEmp_ProfilePhoto"
                  id="MyPro_UploadedProfilePhoto_Modal_FilesInput"
                  onChange={handleCandidateFileChange}
                />
                {resumeError && (
                  <small className="text-danger">{resumeError}</small>
                )}
                <small className="text-muted">
                  Eg: (jpeg, png, pdf, jpg, doc, docx) upto 5MB
                </small>
              </Col>
            </Row>

            <Row className="mb-3 d-none">
              <Col lg={6}>
                <div className="p-field">
                  <label htmlFor="company">Categories</label>
                  <TreeSelect
                    value={selectedCategoryNode}
                    options={categoryNodes}
                    onChange={e => setSelectedCategoryNode(e.value)}
                    className="w-full"
                    placeholder="Select Category"
                    filter
                  />
                </div>
              </Col>
              <Col lg={6}>
                <div className="p-field">
                  <label htmlFor="company">Group</label>
                  <TreeSelect
                    value={selectedGroupNode}
                    options={groupNodes}
                    onChange={e => setSelectedGroupNode(e.value)}
                    className="w-full"
                    placeholder="Select Group"
                    filter
                  />
                </div>
              </Col>
            </Row>

            <Row className="mb-2 align-items-end">
              <Col lg={6}>
                <div className="p-field">
                  <label htmlFor="jobType">UserIDs</label>
                  <InputText
                    value={uniqueUserId}
                    disabled
                    placeholder="Select a User ID"
                    className="w-full activejobdrop"
                  />
                </div>
              </Col>
              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <div className="mb-2">
                      <div className="d-flex align-items-center gap-2">
                        <Controller
                          name="relocation"
                          control={control}
                          render={({ field }) => (
                            <Checkbox
                              inputId="relocation"
                              onChange={e => field.onChange(e.checked)}
                              checked={field.value}
                              onBlur={field.onBlur}
                            />
                          )}
                        />
                        <label htmlFor="relocation" className="mb-0">
                          Relocation
                        </label>
                      </div>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-2">
                      <div className="d-flex align-items-center gap-2">
                        <Controller
                          name="private"
                          control={control}
                          render={({ field }) => (
                            <>
                              <Checkbox
                                inputId="private"
                                inputRef={field.ref}
                                checked={field.value}
                                onChange={e => {
                                  field.onChange(e.checked)
                                  trigger("private")
                                }}
                              />
                              <label htmlFor="private" className="mb-0">
                                Private
                              </label>
                            </>
                          )}
                        />
                      </div>
                    </div>
                  </Col>

                  {/* <Col lg={6}>
                                    <div className="p-field">
                                      <input
                                        type="checkbox"
                                        className="me-2"
                                        {...register("private", {})}
                                        onKeyUp={() => {
                                          trigger("private")
                                        }}
                                      />
                                      <label htmlFor="jobType">Private</label>
                                    </div>
                                  </Col> */}
                </Row>
              </Col>
            </Row>
            <Row>
              {candidateError && (
                <Col lg={12}>
                  <div className="alert alert-danger mt-3">
                    {candidateError}
                  </div>
                </Col>
              )}
              {candidateLoading && (
                <div className="flex justify-content-center align-items-center mt-3">
                  <ProgressSpinner />
                </div>
              )}
            </Row>
            <div className="buttons float-end">
              <Button
                type="submit"
                color="primary"
                className="btn btn-primary me-2 sidebarbtn"
                disabled={candidateLoading}
              >
                {candidateLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Creating...
                  </>
                ) : (
                  "Create"
                )}
              </Button>
              <Button
                color="primary"
                className="btn btn-primary outlinebtn"
                onClick={() => {
                  reset()
                  setCandidateSidebarVisible(false)
                }}
                disabled={candidateLoading || disable}
              >
                Cancel
              </Button>
            </div>
          </div>
        </form>
      </Sidebar>
      {/* <Modal
        isOpen={showSuccessModal}
        toggle={() => setShowSuccessModal(false)}
      >
        <ModalHeader
          toggle={() => setShowSuccessModal(false)}
          className="modal-header_box blueBtn d-flex justify-content-between m-0 modal-header"
        >
          Success!
        </ModalHeader>
        <ModalBody className="text-center">
          <div className="py-3">
            <div className="text-success">
              <FaCheckCircle style={{ fontSize: "3rem" }} />
            </div>
            <div className="text-success pt-3" style={{ fontSize: "1.5rem" }}>
              Resume's uploaded successfully.
            </div>
          </div>
        </ModalBody>
        <ModalFooter className="justify-content-center">
          <Button
            className="btn border blueBtn"
            onClick={() => setShowSuccessModal(false)}
          >
            Close
          </Button>
          <Button
            className="btn border blueBtn"
            onClick={() => {
              setShowSuccessModal(false)
              setShowUploadedResumeModal(true);
            }}
          >
            View Details
          </Button>
        </ModalFooter>
      </Modal>
      {/* Uploaded Resume details */}
      <Modal
        isOpen={showResumeUploadChoiceModal}
        toggle={() => {
          if (!isImportingResume) {
            setShowResumeUploadChoiceModal(false)
            setPendingResumeFiles([])
          }
        }}
        centered
        size="lg"
        className="resume-upload-choice-modal"
      >
        <ModalHeader toggle={() => {
          if (!isImportingResume) {
            setShowResumeUploadChoiceModal(false)
            setPendingResumeFiles([])
          }
        }}>
          Add Uploaded Resume{pendingResumeFiles.length > 1 ? "s" : ""}
        </ModalHeader>
        <ModalBody className="resume-upload-choice-body">
          <div className="text-center mb-4">
            <div className="fw-bold" style={{ color: "#0e527d", fontSize: 18 }}>
              Where should {pendingResumeFiles.length > 1 ? "these resumes" : "this resume"} be added?
            </div>
            <div className="text-muted mt-1">
              Choose whether to keep the candidate unassigned or add the resume to a job order.
            </div>
          </div>

          {pendingResumeFiles.length > 0 && (
            <div className="resume-upload-pending-list">
              {pendingResumeFiles.map((file, index) => (
                <div className="resume-upload-file-card" key={`${file.name}-${index}`}>
                  <div className="resume-upload-file-icon">
                    {file.name.toLowerCase().endsWith(".pdf") ? (
                      <FaFilePdf className="resume-native-file-icon resume-file-pdf-icon" aria-label="PDF file" />
                    ) : file.name.toLowerCase().endsWith(".doc") || file.name.toLowerCase().endsWith(".docx") ? (
                      <FaFileWord className="resume-native-file-icon resume-file-word-icon" aria-label="Word file" />
                    ) : (
                      <i className="pi pi-file" aria-label="Document file" />
                    )}
                  </div>
                  <div className="resume-upload-file-details">
                    <strong title={file.name}>{file.name}</strong>
                    <div className="resume-upload-file-properties">
                      <span><b>Format</b>{file.name.split(".").pop()?.toUpperCase()}</span>
                      <span><b>Size</b>{(file.size / 1024).toFixed(1)} KB</span>
                      <span><b>Type</b>{file.type || "Unavailable"}</span>
                      <span><b>Modified</b>{file.lastModified ? new Date(file.lastModified).toLocaleString() : "Unavailable"}</span>
                    </div>
                  </div>
                  <span className="resume-upload-file-ready">Ready to parse</span>
                </div>
              ))}
            </div>
          )}

          <div className="row g-3">
            <div className="col-md-6">
              <button
                type="button"
                className={`w-100 text-start h-100 p-3 border rounded-3 bg-white ${resumeUploadMode === "manual" ? "border-primary shadow-sm" : ""}`}
                onClick={() => {
                  setResumeUploadMode("manual")
                  setShowResumeUploadChoiceModal(false)
                  setTimeout(() => document.getElementById("resume-import-upload")?.click(), 0)
                }}
                disabled={isImportingResume}
              >
                <div className="d-flex align-items-center gap-3">
                  <span className="d-flex align-items-center justify-content-center rounded-circle" style={{ width: 42, height: 42, background: "#e7f2fb", color: "#0e527d" }}>
                    <i className="pi pi-user-plus" />
                  </span>
                  <span>
                    <span className="d-block fw-bold text-dark">Add manually</span>
                    <span className="d-block small text-muted mt-1">Upload without linking to a job order.</span>
                  </span>
                </div>
              </button>
            </div>
            <div className="col-md-6">
              <button
                type="button"
                className={`w-100 text-start h-100 p-3 border rounded-3 bg-white ${resumeUploadMode === "job" ? "border-primary shadow-sm" : ""}`}
                onClick={() => {
                  setResumeUploadMode("job")
                  setSelectedResumeJob(null)
                  setJobTitleSearch("")
                  getJobTitles(companyId, 1, "")
                }}
                disabled={isImportingResume}
              >
                <div className="d-flex align-items-center gap-3">
                  <span className="d-flex align-items-center justify-content-center rounded-circle" style={{ width: 42, height: 42, background: "#e8f7f1", color: "#13795b" }}>
                    <i className="pi pi-briefcase" />
                  </span>
                  <span>
                    <span className="d-block fw-bold text-dark">Add to job order</span>
                    <span className="d-block small text-muted mt-1">Select a company job order below.</span>
                  </span>
                </div>
              </button>
            </div>
          </div>

          {resumeUploadMode === "job" && (
            <div className="mt-4 p-3 bg-white border rounded-3">
              <Label className="fw-semibold mb-2">Select job order</Label>
              <Dropdown
                value={selectedResumeJob?.id ?? null}
                options={jobTitleList}
                optionLabel="title"
                optionValue="id"
                onChange={e => setSelectedResumeJob(jobTitleList.find(job => String(job.id) === String(e.value)) || null)}
                placeholder="Select a job order"
                filter
                filterBy="title"
                filterPlaceholder="Search job & press Enter..."
                className="w-100"
                appendTo="self"
                panelStyle={{ zIndex: 2000 }}
                onHide={() => setJobTitleSearch("")}
                loading={jobTitlesLoading}
                emptyMessage={jobTitlesLoading ? "Loading job orders..." : "No job orders found"}
                filterTemplate={() => (
                  <div className="d-flex align-items-center gap-2 px-2 py-2" onMouseDown={e => e.stopPropagation()}>
                    <Input
                      type="text"
                      bsSize="sm"
                      placeholder="Search job & press Enter..."
                      value={jobTitleSearch}
                      onChange={e => setJobTitleSearch(e.target.value)}
                      onKeyDown={e => {
                        e.stopPropagation()
                        if (e.key === "Enter") {
                          e.preventDefault()
                          getJobTitles(companyId, 1, jobTitleSearch)
                        }
                      }}
                    />
                    {jobTitlesLoading && <ProgressSpinner style={{ width: 18, height: 18 }} strokeWidth="6" />}
                  </div>
                )}
                panelFooterTemplate={
                  <div className="d-flex align-items-center justify-content-between px-2 py-2 border-top" onMouseDown={e => e.stopPropagation()}>
                    <button type="button" className="btn btn-sm btn-outline-secondary" disabled={jobTitlesLoading || jobTitlePage <= 1} onClick={() => getJobTitles(companyId, jobTitlePage - 1, jobTitleSearch)}>
                      ‹ Prev
                    </button>
                    <small className="text-muted">Page {jobTitlePage} / {Math.max(1, Math.ceil(jobTitleTotalCount / 10))}</small>
                    <button type="button" className="btn btn-sm btn-outline-secondary" disabled={jobTitlesLoading || jobTitlePage >= Math.max(1, Math.ceil(jobTitleTotalCount / 10))} onClick={() => getJobTitles(companyId, jobTitlePage + 1, jobTitleSearch)}>
                      Next ›
                    </button>
                  </div>
                }
              />
              <div className="small text-muted mt-2">Showing jobs for the currently selected company.</div>
            </div>
          )}
        </ModalBody>
        {resumeUploadMode === "job" && (
          <ModalFooter className="justify-content-center gap-2">
            <Button color="secondary" outline onClick={() => setShowResumeUploadChoiceModal(false)} disabled={isImportingResume}>Cancel</Button>
            <Button
              color="primary"
              onClick={() => {
                setShowResumeUploadChoiceModal(false)
                setTimeout(() => document.getElementById("resume-import-upload")?.click(), 0)
              }}
              disabled={!selectedResumeJob || isImportingResume}
            >
              Select Resumes
            </Button>
          </ModalFooter>
        )}
      </Modal>

      {/* <Modal isOpen={showUploadedResumeModal} toggle={() => setShowUploadedResumeModal(false)} size='xl'> */}
        {/* <ModalHeader toggle={() => setShowUploadedResumeModal(false)} className="modal-header_box blueBtn d-flex justify-content-between m-0 modal-header">
          Uploaded Resume Details
        </ModalHeader> */}
        {/* <ModalBody style={{ maxHeight: "400px", overflowY: "auto" }}>
          {/* <div className="row">
            {uploadedResumeData?.created_candidates?.map((candidate, index) => (
            
              <div className="col-xxl-12"  key={index}>
                <div className="card border-0">
                  <div className="card-body shadow rounded">
                    {Object.entries(candidate).map(([key, value]) => (
                      <div className="row" key={key}>
                        <div className="col-4 fw-medium text-capitalize" style={{ fontSize: "14px"}}>{key.replace(/_/g, " ")}</div>
                        <div className="col-8" style={{ fontSize: "14px"}}>{value || "N/A"}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            
          ))}
          </div> */}
          {/* <table className="table table-bordered">
            <tbody>
              {uploadedResumeData?.created_candidates && uploadedResumeData.created_candidates.length > 0 && (
                <DataTable
                  value={uploadedResumeData.created_candidates}
                  className="p-datatable-sm"
                  emptyMessage="No candidates found."
                  paginator
                  rows={5}
                  id="AllEmployees_TableView"
                  rowsPerPageOptions={[5, 10, 20, 50]}
                >
                  {Object.keys(uploadedResumeData.created_candidates[0]).map((key) => (
                    <Column
                      key={key}
                      field={key}
                      header={key.replace(/_/g, " ")}
                      body={(rowData) => rowData[key] || "N/A"}
                    />
                  ))}
                </DataTable>
              )}
            </tbody>
          </table> */}
        {/* </ModalBody> */}
        {/* <ModalFooter className="justify-content-center">
          <Button className="btn border blueBtn" onClick={() => setShowUploadedResumeModal(false)}>
            Close
          </Button>
        </ModalFooter>
      </Modal> */} 
      {/* Approved/Rejected Candidate info */}
    <Modal
  isOpen={showUploadedResumeModal}
  toggle={() => setShowUploadedResumeModal(false)}
  size="xl"
  centered
  className="resume-upload-result-modal"
>
  <ModalHeader toggle={() => setShowUploadedResumeModal(false)} className="modal-header_box blueBtn d-flex justify-content-between m-0 modal-header">
    Resume Upload Result
  </ModalHeader>

  <ModalBody style={{ maxHeight: "500px", overflowY: "auto" }}>
    {shouldShowNotificationWarning && (
      <div className="alert alert-warning d-flex flex-wrap align-items-center justify-content-between gap-2">
        <div>
          <div className="fw-bold">Automatic processing completed, but some notification channels are disabled.</div>
          <div className="mt-2 d-flex flex-wrap gap-2">
            {uploadResult.disabled_notification_channels.map(channel => (
              <span key={channel} className="badge bg-warning text-dark">
                {notificationChannelLabel(channel)}
              </span>
            ))}
          </div>
        </div>
        <Button size="sm" color="warning" onClick={() => navigate("/calling-notification-settings")}>
          Open Notification Settings
        </Button>
      </div>
    )}
    <section className="resume-upload-summary-section mb-4">
        <h6 className="resume-upload-summary-title">Calling Notifications</h6>
        <div className="resume-upload-invite-summary">
        <div className="resume-upload-metric resume-upload-metric-success">
          <span>Invitations sent</span>
          <strong>{Array.isArray(uploadResult.invited) ? uploadResult.invited.length : Number(uploadResult.invited || 0)}</strong>
        </div>
        <div className="resume-upload-metric resume-upload-metric-warning">
          <span>Skipped</span>
          <strong>{Array.isArray(uploadResult.skipped) ? uploadResult.skipped.length : Number(uploadResult.skipped || 0)}</strong>
        </div>
        <div className="resume-upload-metric resume-upload-metric-danger">
          <span>Failed</span>
          <strong>{Array.isArray(uploadResult.failed) ? uploadResult.failed.length : Number(uploadResult.failed || 0)}</strong>
        </div>
        </div>
    </section>
    <section className="resume-upload-summary-section mb-4">
      <h6 className="resume-upload-summary-title">Resume Upload Summary</h6>
      <div className="resume-upload-total-summary">
      <div><span>Total uploaded</span><strong>{getUploadSuccessCount(uploadedResumeData) + getUploadFailedCount(uploadedResumeData)}</strong></div>
      <div className="text-success"><span>Success</span><strong>{getUploadSuccessCount(uploadedResumeData)}</strong></div>
      <div className="text-danger"><span>Failed</span><strong>{getUploadFailedCount(uploadedResumeData)}</strong></div>
      </div>
    </section>
  
    {/* SUCCESS SECTION */}
    {getUploadSuccessCount(uploadedResumeData) > 0 && (
      <>
        <div className="table-responsive">
          <table className="table table-bordered table-striped table-hover">
            <thead className="table-success">
              <tr>
                <th className="text-center">S.No</th>
                <th>Candidate Name</th>
                <th>Email</th>
                {/* <th className="text-center">Candidate ID</th> */}
                {/* <th className="text-center">Linked Job</th> */}
                <th className="text-center">Added On</th>
              </tr>
            </thead>
            <tbody>
              {getUploadSuccessFiles(uploadedResumeData).map((item, index) => (
                <tr key={index}>
                  <td className="text-center">{index + 1}</td>
                  <td>{item.name || "N/A"}</td>
                  <td>{item.email || "N/A"}</td>
                  {/* <td className="text-center">{item.candidate_id || "N/A"}</td> */}
                  {/* <td className="text-center">{item.linked_to_job || "N/A"}</td> */}
                  <td className="text-center">
                    {item.created_on
                      ? new Date(item.created_on).toLocaleString(undefined, {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                          hour12: true,
                        })
                      : "N/A"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </>
    )}
  
    {/* FAILED SECTION (existing) */}
    {getUploadFailedFiles(uploadedResumeData).length > 0 && (
      <>
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead className="table-danger">
              <tr>
                <th className="text-center">S.No</th>
                <th className="text-center">File Name</th>
                <th>Candidate Name</th>
                <th className="text-center">Email</th>
                <th>Reason</th>
              </tr>
            </thead>
            <tbody>
              {getUploadFailedFiles(uploadedResumeData).map((item, index) => (
                <tr key={index}>
                  <td className="text-center">{index + 1}</td>
                  <td>{item.file_name || "N/A"}</td>
                  <td>{item.name || "N/A"}</td>
                  <td>{item.email || "N/A"}</td>
                  <td className="text-danger fw-bold">
                    <div>{item.already_linked === true
                      ? (item.reason || "Candidate is already applied to this job")
                      : (item.reason || item.action || item.error || "Failed")}</div>
                    {item.already_linked === true && (
                      <>
                        <div className="fw-normal mt-1">
                          Added by: {item.added_by?.name || "Unknown user"}
                        </div>
                        <div className="fw-normal">
                          Email: {item.added_by?.email || "Email unavailable"}
                        </div>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </>
    )}
  
    {getUploadSuccessCount(uploadedResumeData) === 0 && 
     getUploadFailedCount(uploadedResumeData) === 0 && (
      <p className="text-center text-muted py-4">No upload result data available.</p>
    )}
  </ModalBody>

  <ModalFooter className="justify-content-center">
    <Button
      className="btn border blueBtn"
      onClick={() => setShowUploadedResumeModal(false)}
    >
      Close
    </Button>
    {/* <Button
      className="btn border blueBtn"
      onClick={() => navigate("/all_candidates")}
    >
      Go to Candidates List
    </Button> */}
  </ModalFooter>
</Modal>


<Modal
  isOpen={showDetailsModal}
  toggle={() => {
    setShowDetailsModal(false);
    setSelectedCandidateForDetails(null);
  }}
  centered
  size="xl"
>
  <ModalHeader
    toggle={() => setShowDetailsModal(false)}
    className="candidate-status-modal-header"
    style={{
      border: 0,
      background: "linear-gradient(135deg, #334155 0%, #4f46e5 100%)",
      color: "#fff",
      padding: "14px 18px",
    }}
  >
    <div>
      <div style={{ fontSize: 18, fontWeight: 800, lineHeight: 1.2 }}>
        Approval/Rejection Details
      </div>
      <div style={{ fontSize: 12, opacity: 0.86, marginTop: 3 }}>
        Review approval decisions for this candidate
      </div>
    </div>
  </ModalHeader>
  <ModalBody style={{ background: "#f7f8fc", padding: 18 }}>
  {selectedCandidateForDetails && (() => {
    const approvalCandidateName = [
      selectedCandidateForDetails.first_name,
      selectedCandidateForDetails.last_name,
    ].filter(Boolean).join(" ") || "--"
    const approvalJobs = selectedCandidateForDetails.approval_jobs || []
    const approvalStatusJob = approvalJobs.find(job => job.is_approved || job.is_rejected)
    const approvalSummaryStatus = approvalStatusJob
      ? approvalStatusJob.is_approved
        ? "Approved"
        : "Rejected"
      : ""
    const approvalCellStyle = {
      fontSize: 12,
      padding: "12px 14px",
      verticalAlign: "middle",
      color: "#0f172a",
      lineHeight: 1.45,
      textAlign: "center",
    }
    const approvalHeaderStyle = {
      fontSize: 12,
      fontWeight: 800,
      padding: "12px 14px",
      verticalAlign: "middle",
      color: "#334155",
      background: "#eef2ff",
      whiteSpace: "nowrap",
      textAlign: "center",
    }

    return (
    <div>
      <div
        title={`Candidate Name : ${approvalCandidateName}`}
        style={{
          background: "#ffffff",
          border: "1px solid #e2e8f0",
          borderRadius: 10,
          padding: "12px 14px",
          marginBottom: 14,
          boxShadow: "0 8px 18px rgba(51, 65, 85, 0.06)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
        }}
      >
        <div
          style={{ minWidth: 0 }}
        >
          <div style={{ fontSize: 11, color: "#64748b", fontWeight: 800, textTransform: "uppercase" }}>
            Candidate Name
          </div>
          <div
            style={{
              fontSize: 14,
              fontWeight: 800,
              color: "#0f172a",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {approvalCandidateName}
          </div>
        </div>
        {approvalSummaryStatus && (
          <span
            title={approvalSummaryStatus}
            style={{
              background: approvalSummaryStatus === "Approved" ? "#dcfce7" : "#fee2e2",
              border: `1px solid ${approvalSummaryStatus === "Approved" ? "#86efac" : "#fecaca"}`,
              color: approvalSummaryStatus === "Approved" ? "#166534" : "#991b1b",
              borderRadius: 999,
              padding: "5px 10px",
              fontSize: 12,
              fontWeight: 800,
              flexShrink: 0,
            }}
          >
            {approvalSummaryStatus}
          </span>
        )}
      </div>

      <div
        style={{
          background: "#fff",
          border: "1px solid #dbe4ef",
          borderRadius: 10,
          overflow: "hidden",
          boxShadow: "0 8px 18px rgba(51, 65, 85, 0.05)",
        }}
      >
        <div className="table-responsive">
          <table className="table table-bordered table-hover mb-0" style={{ tableLayout: "fixed" }}>
            <thead>
              <tr>
                <th title="Job Name" style={{ ...approvalHeaderStyle, width: "28%" }}>Job Name</th>
                <th title="Status" className="text-center" style={{ ...approvalHeaderStyle, width: 110 }}>Status</th>
                <th title="Reason" style={{ ...approvalHeaderStyle, width: "25%" }}>Reason</th>
                <th title="Approved / Rejected By" style={{ ...approvalHeaderStyle, width: "22%" }}>Approved / Rejected By</th>
                <th title="Approval / Rejection Date" style={{ ...approvalHeaderStyle, width: "18%" }}>Approval / Rejection Date</th>
              </tr>
            </thead>
            <tbody>
              {approvalJobs.length > 0 ? (
                approvalJobs.map((job, index) => {
                  const jobStatus = job.is_approved ? "Approved" : "Rejected"
                  const jobReason = job.is_approved
                    ? job.is_approved_reason || "--"
                    : job.is_rejected_reason || "--"
                  const jobReviewedBy = job.is_approved
                    ? job.approved_by_name || "--"
                    : job.rejected_by_name || "--"
                  const jobReviewedAt = job.is_approved
                    ? job.is_approved_at
                      ? new Date(job.is_approved_at).toLocaleString()
                      : "N/A"
                    : job.is_rejected_at
                      ? new Date(job.is_rejected_at).toLocaleString()
                      : "N/A"

                  return (
                    <tr key={index}>
                      <td title={job.job_name || "--"} style={approvalCellStyle}>
                        <div style={{ width: "100%", textAlign: "center", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {job.job_name || "--"}
                        </div>
                      </td>
                      <td title={jobStatus} className="text-center" style={approvalCellStyle}>
                        <span
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            minWidth: 74,
                            borderRadius: 999,
                            padding: "5px 10px",
                            fontSize: 11,
                            fontWeight: 800,
                            background: job.is_approved ? "#dcfce7" : "#fee2e2",
                            border: `1px solid ${job.is_approved ? "#86efac" : "#fecaca"}`,
                            color: job.is_approved ? "#166534" : "#991b1b",
                          }}
                        >
                          {jobStatus}
                        </span>
                      </td>
                      <td title={jobReason} style={approvalCellStyle}>
                        <div style={{ width: "100%", textAlign: "center", maxHeight: 48, overflow: "hidden" }}>
                          {jobReason}
                        </div>
                      </td>
                      <td title={jobReviewedBy} style={approvalCellStyle}>
                        <div style={{ width: "100%", textAlign: "center", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {jobReviewedBy}
                        </div>
                      </td>
                      <td title={jobReviewedAt} style={approvalCellStyle}>
                        <div style={{ width: "100%", textAlign: "center", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {jobReviewedAt}
                        </div>
                      </td>
                    </tr>
                  )
                })
              ) : (
                <tr>
                  <td colSpan="5" className="text-center" style={{ fontSize: 12, padding: "18px", color: "#64748b" }}>
                    No approval history found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
    )
  })()}
</ModalBody>

  <ModalFooter className="justify-content-center" style={{ background: "#f7f8fc", borderTop: 0, padding: "12px 18px 18px" }}>
    <Button
      color="secondary"
      className="btn btn-primary blueBtn"
      onClick={() => {
        setShowDetailsModal(false);
        setSelectedCandidateForDetails(null);
      }}
    >
      Close
    </Button>
  </ModalFooter>
</Modal>
{/* For Approving or rejecting a candidate */}
      <Modal
        isOpen={showApproveRejectModal}
        toggle={() => {
          setShowApproveRejectModal(false)
          setApproveRejectReason("")
          setSelectedJobCandidateForApproveReject(null)
        }}
        centered
        className="approve-reject-modal"
      >
        <ModalHeader
          className={`approve-reject-modal-header ${actionType === "approve" ? "approve" : "reject"}`}
          toggle={() => setShowApproveRejectModal(false)}
        >
          <div className="approve-reject-modal-title">
            {actionType === "approve" ? "Approve Candidate" : "Reject Candidate"}
            <span>
              {selectedJobCandidateForApproveReject?.candidate_name || ""} for {selectedJobCandidateForApproveReject?.job_name || ""} Role
            </span>
          </div>
        </ModalHeader>
        <ModalBody className="approve-reject-modal-body">
          <div className="approve-reject-field">
            <Label for="jobName" className="form-label">
              Job Name
            </Label>
            <Input
              type="text"
              id="jobName"
              value={selectedJobCandidateForApproveReject?.job_name || ""}
              disabled
            />
          </div>
          <div className="approve-reject-field">
            <Label for="jobName" className="form-label">
              Sent for Approval Reason
            </Label>
            <Input
              type="text"
              id="jobName"
              value={selectedJobCandidateForApproveReject?.send_for_approval_reason || ""}
              disabled
            />
          </div>
          <div className="approve-reject-field mb-0">
            <Label for="approveRejectReason" className="form-label">
              Reason for {actionType === "approve" ? "Approval" : "Rejection"}{" "}
              <span className="text-danger">*</span>
            </Label>
            <Input
              type="textarea"
              id="approveRejectReason"
              value={approveRejectReason}
              onChange={e => setApproveRejectReason(e.target.value)}
              placeholder={`Enter reason for ${
                actionType === "approve" ? "approval" : "rejection"
              }`}
              rows={3}
              required
            />
          </div>
        </ModalBody>
        <ModalFooter className="approve-reject-modal-footer">
          <Button
            color="secondary"
            className="approve-reject-cancel-btn"
            onClick={() => {
              setShowApproveRejectModal(false)
              setApproveRejectReason("")
              setSelectedJobCandidateForApproveReject(null)
            }}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            className={`approve-reject-submit-btn ${actionType === "approve" ? "approve" : "reject"}`}
            onClick={actionType === "approve" ? handleApprove : handleReject}
            disabled={isApprovingRejecting}
          >
            {isApprovingRejecting ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                ></span>
                {actionType === "approve" ? "Approving..." : "Rejecting..."}
              </>
            ) : actionType === "approve" ? (
              "Approve"
            ) : (
              "Reject"
          )}
        </Button>
      </ModalFooter>
      </Modal>
      <Modal
  isOpen={pipelineHistoryModalOpen}
  toggle={() => {
    setPipelineHistoryModalOpen(false);
    setPipelineHistoryData([]);
    setSelectedPipelineHistoryCandidate(null);
  }}
  size="lg"
  centered
>
  <ModalHeader
    toggle={() => {
      setPipelineHistoryModalOpen(false);
      setPipelineHistoryData([]);
      setSelectedPipelineHistoryCandidate(null);
    }}
    style={{
      border: "none",
      background: "linear-gradient(135deg, #eef2ff, #f5f3ff)",
      borderRadius: "0.3rem 0.3rem 0 0",
    }}
  >
    <div style={{ display: "grid", gridTemplateColumns: "minmax(0, 1fr) auto", alignItems: "center", gap: 18, width: "100%", paddingRight: 38 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, minWidth: 0 }}>
        <div
          style={{
            width: 42,
            height: 42,
            borderRadius: "50%",
            background: "linear-gradient(135deg, #6366f1, #7c3aed)",
            color: "#fff",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 800,
            fontSize: 15,
            boxShadow: "0 8px 18px rgba(79, 70, 229, 0.28)",
            flex: "0 0 auto",
          }}
        >
          {[
            selectedPipelineHistoryCandidate?.first_name,
            selectedPipelineHistoryCandidate?.middle_name,
            selectedPipelineHistoryCandidate?.last_name,
          ]
            .filter(Boolean)
            .slice(0, 2)
            .map(part => String(part).charAt(0).toUpperCase())
            .join("") || "C"}
        </div>
        <div style={{ minWidth: 0 }}>
          <div
            style={{
              color: "#64748b",
              fontSize: 12,
              fontWeight: 700,
              lineHeight: 1.2,
              marginBottom: 3,
            }}
          >
            {pipelineHistoryTitle}
          </div>
          <div
            style={{
              fontWeight: 800,
              color: "#0f172a",
              fontSize: 18,
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            title={`${selectedPipelineHistoryCandidate?.first_name || ""} ${selectedPipelineHistoryCandidate?.middle_name || ""} ${selectedPipelineHistoryCandidate?.last_name || ""}`.trim()}
          >
            {selectedPipelineHistoryCandidate?.first_name}{" "}
            {selectedPipelineHistoryCandidate?.middle_name || ""}{" "}
            {selectedPipelineHistoryCandidate?.last_name || ""}
          </div>
        </div>
      </div>
    </div>
  </ModalHeader>
  <ModalBody style={{ maxHeight: "70vh", overflowY: "auto", background: "#fbfbfe" }}>
  <PipelineHistoryTimeline
    items={pipelineHistoryData.map(item => ({
      ...item,
      rejected_round: item.rejected_round || selectedPipelineHistoryCandidate?.rejected_round,
      updatedAt: formatPipelineDate(item.changed_at),
      updatedBy: item.changed_by,
    }))}
    emptyMessage="No pipeline history found."
  />
  <div style={{ display: "none" }}>
  <div className="mb-3">
    <strong>
      Candidate Name :{" "}
      {selectedPipelineHistoryCandidate?.first_name}{" "}
      {selectedPipelineHistoryCandidate?.middle_name || ""}{" "}
      {selectedPipelineHistoryCandidate?.last_name || ""}
    </strong>
  </div>

{pipelineHistoryData.length ? (
  <div style={{ position: "relative", paddingLeft: 28 }}>
    {/* Timeline line */}
    <div
      style={{
        position: "absolute",
        left: 10,
        top: 8,
        bottom: 8,
        width: 2,
        background: "#e2e8f0",
      }}
    />

    {pipelineHistoryData.map((item, index) => {
      const isLast = index === pipelineHistoryData.length - 1;

      return (
        <div
          key={index}
          style={{
            position: "relative",
            marginBottom: 16,
          }}
        >
          <div
            style={{
              position: "absolute",
              left: -22,
              top: 12,
              width: 12,
              height: 12,
              borderRadius: "50%",
              background:
                item.stage?.toLowerCase() === "offered"
                  ? "#22c55e"
                  : item.stage?.toLowerCase() === "rejected"
                  ? "#ef4444"
                  : item.stage?.toLowerCase() === "interview"
                  ? "#3b82f6"
                  : "#6366f1",
              border: "2px solid #fff",
              boxShadow: "0 0 0 2px #6366f133",
            }}
          />

          <div
  style={{
    background: isLast ? "#ecfdf5" : "#f8fafc",
    border: isLast ? "1px solid #22c55e" : "1px solid #e2e8f0",
    borderRadius: 8,
    padding: "10px 14px",
  }}
>
  {/* 🔥 Header Row (Stage + Time aligned properly) */}
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 6,
      flexWrap: "wrap",
      gap: 6,
    }}
  >
    {/* Stage Badge */}
    <span
      style={{
        background:
          item.stage?.toLowerCase() === "offered"
            ? "#dcfce7"
            : item.stage?.toLowerCase() === "rejected"
            ? "#fee2e2"
            : item.stage?.toLowerCase() === "interview"
            ? "#dbeafe"
            : "#eef2ff",
        color:
          item.stage?.toLowerCase() === "offered"
            ? "#166534"
            : item.stage?.toLowerCase() === "rejected"
            ? "#991b1b"
            : item.stage?.toLowerCase() === "interview"
            ? "#1d4ed8"
            : "#4338ca",
        borderRadius: 999,
        padding: "2px 10px",
        fontSize: 12,
        fontWeight: 600,
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
      }}
    >
      {isLast ? (
        <>
          <span style={{ fontWeight: 500 }}>Current Stage :</span>
          <span style={{ fontWeight: 700 }}>
            {item.stage || "--"}
          </span>
        </>
      ) : (
        item.stage || "--"
      )}
    </span>

    {/* Time (Right aligned) */}
    <span style={{ fontSize: 11, color: "#000" }}>
      {formatPipelineDate(item.changed_at)}
    </span>
  </div>

  {/* Job */}
  <div
    style={{
      fontSize: 13,
      fontWeight: 600,
      color: "#0f172a",
      marginBottom: 4,
    }}
  >
    {item.job_title || "-"}
  </div>

  {/* Reason */}
  {item.reason && (
    <div style={{ fontSize: 12, color: "#64748b", marginTop: 4 }}>
      <strong>Reason :</strong> {item.reason}
    </div>
  )}

  {/* Updated By */}
  <div style={{ fontSize: 12, color: "#64748b", marginTop: 2 }}>
    <strong>Changed by :</strong> {item.changed_by || "--"}
  </div>
</div>
        </div>
      );
    })}
  </div>
) : (
  <div className="text-muted text-center py-3">
    No pipeline history found.
  </div>
)}
</div>
</ModalBody>
  <ModalFooter className="justify-content-center">
    <Button
      style={{ background: "#4f46e5", border: "none", borderRadius: 10, padding: "0.45rem 1.35rem" }}
      onClick={() => {
        setPipelineHistoryModalOpen(false);
        setPipelineHistoryData([]);
        setSelectedPipelineHistoryCandidate(null);
      }}
    >
      Close
    </Button>
  </ModalFooter>
</Modal>
    <Dialog
  header={
    <div className="test-result-modal-heading">
      <div className="test-result-modal-title">Talent Scan Result</div>
      <div className="test-result-modal-candidate-contact">
        {formatTalentScanValue(selectedResult?.[0]?.candidate_info?.name)} |{" "}
        {formatTalentScanValue(selectedResult?.[0]?.candidate_info?.email)} |{" "}
        {formatTalentScanValue(selectedResult?.[0]?.candidate_info?.phone)}
      </div>
    </div>
  }
  visible={showResultSummary}
  onHide={() => setShowResultSummary(false)}
  style={{ width: "78vw", maxWidth: 1180 }}
  className="talent-scan-result-dialog"
  breakpoints={{ "1200px": "88vw", "960px": "94vw", "641px": "100vw" }}
>
  {renderTalentScanResults()}
  {false && (selectedResult?.length ? (
    selectedResult.map((result, index) => (
      <div key={result.id} className="mb-4">
        <h5 className="mb-2 text-center">
          🧪 Test {index + 1}: {result.test_info?.name}
        </h5>

        <Row className="mb-3 px-3">
          <Col md={6}  className="border border-end-0  rounded">
            <div>
              <h6 className="py-2 px-2">🧑 Candidate Info</h6>
              <div class="table-responsive">
                <table className="table table-striped table-bordered">
                  <tr className="border">
                    <td className="py-2 px-2">Name </td>
                    <td className="py-2 px-2">: {result.candidate_info?.name}</td>
                  </tr>
                  <tr className="border">
                    <td className="py-2 px-2">Email </td>
                    <td className="py-2 px-2">: {result.candidate_info?.email}</td>
                  </tr>
                  <tr className="border">
                    <td className="py-2 px-2">Phone </td>
                    <td className="py-2 px-2">: {result.candidate_info?.phone}</td>
                  </tr>
                  <tr className="border">
                    <td className="py-2 px-2">Experience </td>
                    <td className="py-2 px-2">: {result.candidate_info?.experience} yrs</td>
                  </tr>
                </table>
              </div>
              {/* <p><strong>Name:</strong> {result.candidate_info?.name}</p>
              <p><strong>Email:</strong> {result.candidate_info?.email}</p>
              <p><strong>Phone:</strong> {result.candidate_info?.phone}</p>
              <p><strong>Experience:</strong> {result.candidate_info?.experience} yrs</p> */}
            </div>
          </Col>

          <Col md={6} className="border rounded">
            <div>
              <h6 className="py-2 px-2">🧾 Test Info</h6>
              <p><strong>Designation:</strong> {result.test_info?.test_designation}</p>
              <p><strong>Skills:</strong> {result.test_info?.skills?.join(", ")}</p>
              <p>
                <strong>Status:</strong>{" "}
                <span className={result.is_attempted ? "text-success" : "text-danger"}>
                  {result.is_attempted ? "Attempted" : "Not Attempted"}
                </span>
              </p>
            </div>
          </Col>
        </Row>

        <h6 className="text-center">🏁 ATS Summary</h6>
        <Row className="mb-3 px-3">
          <Col md={4} className="border text-center">
            <div className="pt-3"><strong>Total Score</strong></div>
            <p>
              {result.ats_details?.total_score_secured} /
              {result.ats_details?.actual_total_score}
            </p>
          </Col>

          <Col md={4} className="border text-center">
            <div className="pt-3"><strong>Percentage</strong></div>
            <p>{result.ats_details?.percentage_score}%</p>
          </Col>

          <Col md={4} className="border text-center">
            <div className="pt-3"><strong>Qualified</strong></div>
            <p className={result.ats_details?.is_test_qualified ? "text-success" : "text-danger"}>
              {result.ats_details?.is_test_qualified ? "Yes" : "No"}
            </p>
          </Col>
        </Row>

        <h6 className="text-center">📊 Section Scores</h6>
        <DataTable value={result.score_info || []} size="small" id="SectioScoreDatatable">
          <Column field="section__name" header="Section" />
          <Column field="no_of_questions" header="Number Of Questions" />
          <Column field="total_score" header="Total Score" />
          <Column field="cutoff_score" header="Cutoff" />
          <Column field="score_secured" header="Score Secured" />
          <Column field="percentage" header="Percentage" />
        </DataTable>

        <hr style={{ border: "2px solid #8b8b8b"}} />
      </div>
    ))
  ) : (
    <p>No Talent Scan result found.</p>
  ))}
</Dialog>
{showScrollTop && (
  <button
    onClick={scrollToTop}
    title="Scroll to top"
    style={{
      position: "fixed",
      bottom: 30,
      right: 3,
      width: 46,
      height: 46,
      borderRadius: "50%",
      background: "linear-gradient(90deg, #0e527d, #1a87cb)",
      border: "none",
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
      cursor: "pointer",
      zIndex: 1050,
      transition: "opacity 0.2s ease",
    }}
  >
    <FaArrowUp size={16} />
  </button>
)}


    </React.Fragment>
  )
}
 
export default AtsCandidatesAll 
